import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.date.to-json";
import "core-js/modules/es6.array.map";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.object.set-prototype-of";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.object.freeze";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es6.regexp.flags";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.array.last-index-of";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.regexp.constructor";
import rewritePattern from 'regexpu-core';
import MagicString from 'magic-string'; // Reserved word lists for various dialects of the language

var reservedWords = {
  3: "abstract boolean byte char class double enum export extends final float goto implements import int interface long native package private protected public short static super synchronized throws transient volatile",
  5: "class enum extends super const export import",
  6: "enum",
  strict: "implements interface let package private protected public static yield",
  strictBind: "eval arguments"
}; // And the keywords

var ecma5AndLessKeywords = "break case catch continue debugger default do else finally for function if return switch throw try var while with null true false instanceof typeof void delete new in this";
var keywords = {
  5: ecma5AndLessKeywords,
  6: ecma5AndLessKeywords + " const class extends export import super"
};
var keywordRelationalOperator = /^in(stanceof)?$/; // ## Character categories
// Big ugly regular expressions that match characters in the
// whitespace, identifier, and identifier-start categories. These
// are only applied when a character is found to actually have a
// code point above 128.
// Generated by `bin/generate-identifier-regex.js`.

var nonASCIIidentifierStartChars = "\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309B-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEF\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7B9\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC";
var nonASCIIidentifierChars = "\u200C\u200D\xB7\u0300-\u036F\u0387\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u0669\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u06F0-\u06F9\u0711\u0730-\u074A\u07A6-\u07B0\u07C0-\u07C9\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0966-\u096F\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u09E6-\u09EF\u09FE\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A66-\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0AE6-\u0AEF\u0AFA-\u0AFF\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B62\u0B63\u0B66-\u0B6F\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0BE6-\u0BEF\u0C00-\u0C04\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C66-\u0C6F\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0CE6-\u0CEF\u0D00-\u0D03\u0D3B\u0D3C\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D66-\u0D6F\u0D82\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0E50-\u0E59\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0ED0-\u0ED9\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1040-\u1049\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F-\u109D\u135D-\u135F\u1369-\u1371\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u18A9\u1920-\u192B\u1930-\u193B\u1946-\u194F\u19D0-\u19DA\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AB0-\u1ABD\u1B00-\u1B04\u1B34-\u1B44\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BB0-\u1BB9\u1BE6-\u1BF3\u1C24-\u1C37\u1C40-\u1C49\u1C50-\u1C59\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF2-\u1CF4\u1CF7-\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u203F\u2040\u2054\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA620-\uA629\uA66F\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA880\uA881\uA8B4-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F1\uA8FF-\uA909\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9D0-\uA9D9\uA9E5\uA9F0-\uA9F9\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA50-\uAA59\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uABF0-\uABF9\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFF10-\uFF19\uFF3F";
var nonASCIIidentifierStart = new RegExp("[" + nonASCIIidentifierStartChars + "]");
var nonASCIIidentifier = new RegExp("[" + nonASCIIidentifierStartChars + nonASCIIidentifierChars + "]");
nonASCIIidentifierStartChars = nonASCIIidentifierChars = null; // These are a run-length and offset encoded representation of the
// >0xffff code points that are a valid part of identifiers. The
// offset starts at 0x10000, and each pair of numbers represents an
// offset to the next range, and then a size of the range. They were
// generated by bin/generate-identifier-regex.js
// eslint-disable-next-line comma-spacing

var astralIdentifierStartCodes = [0, 11, 2, 25, 2, 18, 2, 1, 2, 14, 3, 13, 35, 122, 70, 52, 268, 28, 4, 48, 48, 31, 14, 29, 6, 37, 11, 29, 3, 35, 5, 7, 2, 4, 43, 157, 19, 35, 5, 35, 5, 39, 9, 51, 157, 310, 10, 21, 11, 7, 153, 5, 3, 0, 2, 43, 2, 1, 4, 0, 3, 22, 11, 22, 10, 30, 66, 18, 2, 1, 11, 21, 11, 25, 71, 55, 7, 1, 65, 0, 16, 3, 2, 2, 2, 28, 43, 28, 4, 28, 36, 7, 2, 27, 28, 53, 11, 21, 11, 18, 14, 17, 111, 72, 56, 50, 14, 50, 14, 35, 477, 28, 11, 0, 9, 21, 190, 52, 76, 44, 33, 24, 27, 35, 30, 0, 12, 34, 4, 0, 13, 47, 15, 3, 22, 0, 2, 0, 36, 17, 2, 24, 85, 6, 2, 0, 2, 3, 2, 14, 2, 9, 8, 46, 39, 7, 3, 1, 3, 21, 2, 6, 2, 1, 2, 4, 4, 0, 19, 0, 13, 4, 159, 52, 19, 3, 54, 47, 21, 1, 2, 0, 185, 46, 42, 3, 37, 47, 21, 0, 60, 42, 86, 26, 230, 43, 117, 63, 32, 0, 257, 0, 11, 39, 8, 0, 22, 0, 12, 39, 3, 3, 20, 0, 35, 56, 264, 8, 2, 36, 18, 0, 50, 29, 113, 6, 2, 1, 2, 37, 22, 0, 26, 5, 2, 1, 2, 31, 15, 0, 328, 18, 270, 921, 103, 110, 18, 195, 2749, 1070, 4050, 582, 8634, 568, 8, 30, 114, 29, 19, 47, 17, 3, 32, 20, 6, 18, 689, 63, 129, 68, 12, 0, 67, 12, 65, 1, 31, 6129, 15, 754, 9486, 286, 82, 395, 2309, 106, 6, 12, 4, 8, 8, 9, 5991, 84, 2, 70, 2, 1, 3, 0, 3, 1, 3, 3, 2, 11, 2, 0, 2, 6, 2, 64, 2, 3, 3, 7, 2, 6, 2, 27, 2, 3, 2, 4, 2, 0, 4, 6, 2, 339, 3, 24, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 7, 4149, 196, 60, 67, 1213, 3, 2, 26, 2, 1, 2, 0, 3, 0, 2, 9, 2, 3, 2, 0, 2, 0, 7, 0, 5, 0, 2, 0, 2, 0, 2, 2, 2, 1, 2, 0, 3, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 1, 2, 0, 3, 3, 2, 6, 2, 3, 2, 3, 2, 0, 2, 9, 2, 16, 6, 2, 2, 4, 2, 16, 4421, 42710, 42, 4148, 12, 221, 3, 5761, 15, 7472, 3104, 541]; // eslint-disable-next-line comma-spacing

var astralIdentifierCodes = [509, 0, 227, 0, 150, 4, 294, 9, 1368, 2, 2, 1, 6, 3, 41, 2, 5, 0, 166, 1, 574, 3, 9, 9, 525, 10, 176, 2, 54, 14, 32, 9, 16, 3, 46, 10, 54, 9, 7, 2, 37, 13, 2, 9, 6, 1, 45, 0, 13, 2, 49, 13, 9, 3, 4, 9, 83, 11, 7, 0, 161, 11, 6, 9, 7, 3, 56, 1, 2, 6, 3, 1, 3, 2, 10, 0, 11, 1, 3, 6, 4, 4, 193, 17, 10, 9, 5, 0, 82, 19, 13, 9, 214, 6, 3, 8, 28, 1, 83, 16, 16, 9, 82, 12, 9, 9, 84, 14, 5, 9, 243, 14, 166, 9, 280, 9, 41, 6, 2, 3, 9, 0, 10, 10, 47, 15, 406, 7, 2, 7, 17, 9, 57, 21, 2, 13, 123, 5, 4, 0, 2, 1, 2, 6, 2, 0, 9, 9, 49, 4, 2, 1, 2, 4, 9, 9, 330, 3, 19306, 9, 135, 4, 60, 6, 26, 9, 1016, 45, 17, 3, 19723, 1, 5319, 4, 4, 5, 9, 7, 3, 6, 31, 3, 149, 2, 1418, 49, 513, 54, 5, 49, 9, 0, 15, 0, 23, 4, 2, 14, 1361, 6, 2, 16, 3, 6, 2, 1, 2, 4, 2214, 6, 110, 6, 6, 9, 792487, 239]; // This has a complexity linear to the value of the code. The
// assumption is that looking up astral identifier characters is
// rare.

function isInAstralSet(code, set) {
  var pos = 0x10000;

  for (var i = 0; i < set.length; i += 2) {
    pos += set[i];

    if (pos > code) {
      return false;
    }

    pos += set[i + 1];

    if (pos >= code) {
      return true;
    }
  }
} // Test whether a given character code starts an identifier.


function isIdentifierStart(code, astral) {
  if (code < 65) {
    return code === 36;
  }

  if (code < 91) {
    return true;
  }

  if (code < 97) {
    return code === 95;
  }

  if (code < 123) {
    return true;
  }

  if (code <= 0xffff) {
    return code >= 0xaa && nonASCIIidentifierStart.test(String.fromCharCode(code));
  }

  if (astral === false) {
    return false;
  }

  return isInAstralSet(code, astralIdentifierStartCodes);
} // Test whether a given character is part of an identifier.


function isIdentifierChar(code, astral) {
  if (code < 48) {
    return code === 36;
  }

  if (code < 58) {
    return true;
  }

  if (code < 65) {
    return false;
  }

  if (code < 91) {
    return true;
  }

  if (code < 97) {
    return code === 95;
  }

  if (code < 123) {
    return true;
  }

  if (code <= 0xffff) {
    return code >= 0xaa && nonASCIIidentifier.test(String.fromCharCode(code));
  }

  if (astral === false) {
    return false;
  }

  return isInAstralSet(code, astralIdentifierStartCodes) || isInAstralSet(code, astralIdentifierCodes);
} // ## Token types
// The assignment of fine-grained, information-carrying type objects
// allows the tokenizer to store the information it has about a
// token in a way that is very cheap for the parser to look up.
// All token type variables start with an underscore, to make them
// easy to recognize.
// The `beforeExpr` property is used to disambiguate between regular
// expressions and divisions. It is set on all token types that can
// be followed by an expression (thus, a slash after them would be a
// regular expression).
//
// The `startsExpr` property is used to check if the token ends a
// `yield` expression. It is set on all token types that either can
// directly start an expression (like a quotation mark) or can
// continue an expression (like the body of a string).
//
// `isLoop` marks a keyword as starting a loop, which is important
// to know when parsing a label, in order to allow or disallow
// continue jumps to that label.


var TokenType = function TokenType(label, conf) {
  if (conf === void 0) conf = {};
  this.label = label;
  this.keyword = conf.keyword;
  this.beforeExpr = !!conf.beforeExpr;
  this.startsExpr = !!conf.startsExpr;
  this.isLoop = !!conf.isLoop;
  this.isAssign = !!conf.isAssign;
  this.prefix = !!conf.prefix;
  this.postfix = !!conf.postfix;
  this.binop = conf.binop || null;
  this.updateContext = null;
};

function binop(name, prec) {
  return new TokenType(name, {
    beforeExpr: true,
    binop: prec
  });
}

var beforeExpr = {
  beforeExpr: true
};
var startsExpr = {
  startsExpr: true
}; // Map keyword names to token types.

var keywords$1 = {}; // Succinct definitions of keyword token types

function kw(name, options) {
  if (options === void 0) options = {};
  options.keyword = name;
  return keywords$1[name] = new TokenType(name, options);
}

var types = {
  num: new TokenType("num", startsExpr),
  regexp: new TokenType("regexp", startsExpr),
  string: new TokenType("string", startsExpr),
  name: new TokenType("name", startsExpr),
  eof: new TokenType("eof"),
  // Punctuation token types.
  bracketL: new TokenType("[", {
    beforeExpr: true,
    startsExpr: true
  }),
  bracketR: new TokenType("]"),
  braceL: new TokenType("{", {
    beforeExpr: true,
    startsExpr: true
  }),
  braceR: new TokenType("}"),
  parenL: new TokenType("(", {
    beforeExpr: true,
    startsExpr: true
  }),
  parenR: new TokenType(")"),
  comma: new TokenType(",", beforeExpr),
  semi: new TokenType(";", beforeExpr),
  colon: new TokenType(":", beforeExpr),
  dot: new TokenType("."),
  question: new TokenType("?", beforeExpr),
  arrow: new TokenType("=>", beforeExpr),
  template: new TokenType("template"),
  invalidTemplate: new TokenType("invalidTemplate"),
  ellipsis: new TokenType("...", beforeExpr),
  backQuote: new TokenType("`", startsExpr),
  dollarBraceL: new TokenType("${", {
    beforeExpr: true,
    startsExpr: true
  }),
  // Operators. These carry several kinds of properties to help the
  // parser use them properly (the presence of these properties is
  // what categorizes them as operators).
  //
  // `binop`, when present, specifies that this operator is a binary
  // operator, and will refer to its precedence.
  //
  // `prefix` and `postfix` mark the operator as a prefix or postfix
  // unary operator.
  //
  // `isAssign` marks all of `=`, `+=`, `-=` etcetera, which act as
  // binary operators with a very low precedence, that should result
  // in AssignmentExpression nodes.
  eq: new TokenType("=", {
    beforeExpr: true,
    isAssign: true
  }),
  assign: new TokenType("_=", {
    beforeExpr: true,
    isAssign: true
  }),
  incDec: new TokenType("++/--", {
    prefix: true,
    postfix: true,
    startsExpr: true
  }),
  prefix: new TokenType("!/~", {
    beforeExpr: true,
    prefix: true,
    startsExpr: true
  }),
  logicalOR: binop("||", 1),
  logicalAND: binop("&&", 2),
  bitwiseOR: binop("|", 3),
  bitwiseXOR: binop("^", 4),
  bitwiseAND: binop("&", 5),
  equality: binop("==/!=/===/!==", 6),
  relational: binop("</>/<=/>=", 7),
  bitShift: binop("<</>>/>>>", 8),
  plusMin: new TokenType("+/-", {
    beforeExpr: true,
    binop: 9,
    prefix: true,
    startsExpr: true
  }),
  modulo: binop("%", 10),
  star: binop("*", 10),
  slash: binop("/", 10),
  starstar: new TokenType("**", {
    beforeExpr: true
  }),
  // Keyword token types.
  _break: kw("break"),
  _case: kw("case", beforeExpr),
  _catch: kw("catch"),
  _continue: kw("continue"),
  _debugger: kw("debugger"),
  _default: kw("default", beforeExpr),
  _do: kw("do", {
    isLoop: true,
    beforeExpr: true
  }),
  _else: kw("else", beforeExpr),
  _finally: kw("finally"),
  _for: kw("for", {
    isLoop: true
  }),
  _function: kw("function", startsExpr),
  _if: kw("if"),
  _return: kw("return", beforeExpr),
  _switch: kw("switch"),
  _throw: kw("throw", beforeExpr),
  _try: kw("try"),
  _var: kw("var"),
  _const: kw("const"),
  _while: kw("while", {
    isLoop: true
  }),
  _with: kw("with"),
  _new: kw("new", {
    beforeExpr: true,
    startsExpr: true
  }),
  _this: kw("this", startsExpr),
  _super: kw("super", startsExpr),
  _class: kw("class", startsExpr),
  _extends: kw("extends", beforeExpr),
  _export: kw("export"),
  _import: kw("import"),
  _null: kw("null", startsExpr),
  _true: kw("true", startsExpr),
  _false: kw("false", startsExpr),
  _in: kw("in", {
    beforeExpr: true,
    binop: 7
  }),
  _instanceof: kw("instanceof", {
    beforeExpr: true,
    binop: 7
  }),
  _typeof: kw("typeof", {
    beforeExpr: true,
    prefix: true,
    startsExpr: true
  }),
  _void: kw("void", {
    beforeExpr: true,
    prefix: true,
    startsExpr: true
  }),
  _delete: kw("delete", {
    beforeExpr: true,
    prefix: true,
    startsExpr: true
  })
}; // Matches a whole line break (where CRLF is considered a single
// line break). Used to count lines.

var lineBreak = /\r\n?|\n|\u2028|\u2029/;
var lineBreakG = new RegExp(lineBreak.source, "g");

function isNewLine(code, ecma2019String) {
  return code === 10 || code === 13 || !ecma2019String && (code === 0x2028 || code === 0x2029);
}

var nonASCIIwhitespace = /[\u1680\u180e\u2000-\u200a\u202f\u205f\u3000\ufeff]/;
var skipWhiteSpace = /(?:\s|\/\/.*|\/\*[^]*?\*\/)*/g;
var ref = Object.prototype;
var hasOwnProperty = ref.hasOwnProperty;
var toString = ref.toString; // Checks if an object has a property.

function has(obj, propName) {
  return hasOwnProperty.call(obj, propName);
}

var isArray = Array.isArray || function (obj) {
  return toString.call(obj) === "[object Array]";
}; // These are used when `options.locations` is on, for the
// `startLoc` and `endLoc` properties.


var Position = function Position(line, col) {
  this.line = line;
  this.column = col;
};

Position.prototype.offset = function offset(n) {
  return new Position(this.line, this.column + n);
};

var SourceLocation = function SourceLocation(p, start, end) {
  this.start = start;
  this.end = end;

  if (p.sourceFile !== null) {
    this.source = p.sourceFile;
  }
}; // The `getLineInfo` function is mostly useful when the
// `locations` option is off (for performance reasons) and you
// want to find the line/column position for a given character
// offset. `input` should be the code string that the offset refers
// into.


function getLineInfo(input, offset) {
  for (var line = 1, cur = 0;;) {
    lineBreakG.lastIndex = cur;
    var match = lineBreakG.exec(input);

    if (match && match.index < offset) {
      ++line;
      cur = match.index + match[0].length;
    } else {
      return new Position(line, offset - cur);
    }
  }
} // A second optional argument can be given to further configure
// the parser process. These options are recognized:


var defaultOptions = {
  // `ecmaVersion` indicates the ECMAScript version to parse. Must be
  // either 3, 5, 6 (2015), 7 (2016), 8 (2017), 9 (2018), or 10
  // (2019). This influences support for strict mode, the set of
  // reserved words, and support for new syntax features. The default
  // is 9.
  ecmaVersion: 9,
  // `sourceType` indicates the mode the code should be parsed in.
  // Can be either `"script"` or `"module"`. This influences global
  // strict mode and parsing of `import` and `export` declarations.
  sourceType: "script",
  // `onInsertedSemicolon` can be a callback that will be called
  // when a semicolon is automatically inserted. It will be passed
  // th position of the comma as an offset, and if `locations` is
  // enabled, it is given the location as a `{line, column}` object
  // as second argument.
  onInsertedSemicolon: null,
  // `onTrailingComma` is similar to `onInsertedSemicolon`, but for
  // trailing commas.
  onTrailingComma: null,
  // By default, reserved words are only enforced if ecmaVersion >= 5.
  // Set `allowReserved` to a boolean value to explicitly turn this on
  // an off. When this option has the value "never", reserved words
  // and keywords can also not be used as property names.
  allowReserved: null,
  // When enabled, a return at the top level is not considered an
  // error.
  allowReturnOutsideFunction: false,
  // When enabled, import/export statements are not constrained to
  // appearing at the top of the program.
  allowImportExportEverywhere: false,
  // When enabled, await identifiers are allowed to appear at the top-level scope,
  // but they are still not allowed in non-async functions.
  allowAwaitOutsideFunction: false,
  // When enabled, hashbang directive in the beginning of file
  // is allowed and treated as a line comment.
  allowHashBang: false,
  // When `locations` is on, `loc` properties holding objects with
  // `start` and `end` properties in `{line, column}` form (with
  // line being 1-based and column 0-based) will be attached to the
  // nodes.
  locations: false,
  // A function can be passed as `onToken` option, which will
  // cause Acorn to call that function with object in the same
  // format as tokens returned from `tokenizer().getToken()`. Note
  // that you are not allowed to call the parser from the
  // callback—that will corrupt its internal state.
  onToken: null,
  // A function can be passed as `onComment` option, which will
  // cause Acorn to call that function with `(block, text, start,
  // end)` parameters whenever a comment is skipped. `block` is a
  // boolean indicating whether this is a block (`/* */`) comment,
  // `text` is the content of the comment, and `start` and `end` are
  // character offsets that denote the start and end of the comment.
  // When the `locations` option is on, two more parameters are
  // passed, the full `{line, column}` locations of the start and
  // end of the comments. Note that you are not allowed to call the
  // parser from the callback—that will corrupt its internal state.
  onComment: null,
  // Nodes have their start and end characters offsets recorded in
  // `start` and `end` properties (directly on the node, rather than
  // the `loc` object, which holds line/column data. To also add a
  // [semi-standardized][range] `range` property holding a `[start,
  // end]` array with the same numbers, set the `ranges` option to
  // `true`.
  //
  // [range]: https://bugzilla.mozilla.org/show_bug.cgi?id=745678
  ranges: false,
  // It is possible to parse multiple files into a single AST by
  // passing the tree produced by parsing the first file as
  // `program` option in subsequent parses. This will add the
  // toplevel forms of the parsed file to the `Program` (top) node
  // of an existing parse tree.
  program: null,
  // When `locations` is on, you can pass this to record the source
  // file in every node's `loc` object.
  sourceFile: null,
  // This value, if given, is stored in every node, whether
  // `locations` is on or off.
  directSourceFile: null,
  // When enabled, parenthesized expressions are represented by
  // (non-standard) ParenthesizedExpression nodes
  preserveParens: false
}; // Interpret and default an options object

function getOptions(opts) {
  var options = {};

  for (var opt in defaultOptions) {
    options[opt] = opts && has(opts, opt) ? opts[opt] : defaultOptions[opt];
  }

  if (options.ecmaVersion >= 2015) {
    options.ecmaVersion -= 2009;
  }

  if (options.allowReserved == null) {
    options.allowReserved = options.ecmaVersion < 5;
  }

  if (isArray(options.onToken)) {
    var tokens = options.onToken;

    options.onToken = function (token) {
      return tokens.push(token);
    };
  }

  if (isArray(options.onComment)) {
    options.onComment = pushComment(options, options.onComment);
  }

  return options;
}

function pushComment(options, array) {
  return function (block, text, start, end, startLoc, endLoc) {
    var comment = {
      type: block ? "Block" : "Line",
      value: text,
      start: start,
      end: end
    };

    if (options.locations) {
      comment.loc = new SourceLocation(this, startLoc, endLoc);
    }

    if (options.ranges) {
      comment.range = [start, end];
    }

    array.push(comment);
  };
} // Each scope gets a bitset that may contain these flags


var SCOPE_TOP = 1;
var SCOPE_FUNCTION = 2;
var SCOPE_VAR = SCOPE_TOP | SCOPE_FUNCTION;
var SCOPE_ASYNC = 4;
var SCOPE_GENERATOR = 8;
var SCOPE_ARROW = 16;
var SCOPE_SIMPLE_CATCH = 32;

function functionFlags(async, generator) {
  return SCOPE_FUNCTION | (async ? SCOPE_ASYNC : 0) | (generator ? SCOPE_GENERATOR : 0);
} // Used in checkLVal and declareName to determine the type of a binding


var BIND_NONE = 0;
var BIND_VAR = 1;
var BIND_LEXICAL = 2;
var BIND_FUNCTION = 3;
var BIND_SIMPLE_CATCH = 4;
var BIND_OUTSIDE = 5; // Special case for function names as bound inside the function

function keywordRegexp(words) {
  return new RegExp("^(?:" + words.replace(/ /g, "|") + ")$");
}

var Parser = function Parser(options, input, startPos) {
  this.options = options = getOptions(options);
  this.sourceFile = options.sourceFile;
  this.keywords = keywordRegexp(keywords[options.ecmaVersion >= 6 ? 6 : 5]);
  var reserved = "";

  if (!options.allowReserved) {
    for (var v = options.ecmaVersion;; v--) {
      if (reserved = reservedWords[v]) {
        break;
      }
    }

    if (options.sourceType === "module") {
      reserved += " await";
    }
  }

  this.reservedWords = keywordRegexp(reserved);
  var reservedStrict = (reserved ? reserved + " " : "") + reservedWords.strict;
  this.reservedWordsStrict = keywordRegexp(reservedStrict);
  this.reservedWordsStrictBind = keywordRegexp(reservedStrict + " " + reservedWords.strictBind);
  this.input = String(input); // Used to signal to callers of `readWord1` whether the word
  // contained any escape sequences. This is needed because words with
  // escape sequences must not be interpreted as keywords.

  this.containsEsc = false; // Set up token state
  // The current position of the tokenizer in the input.

  if (startPos) {
    this.pos = startPos;
    this.lineStart = this.input.lastIndexOf("\n", startPos - 1) + 1;
    this.curLine = this.input.slice(0, this.lineStart).split(lineBreak).length;
  } else {
    this.pos = this.lineStart = 0;
    this.curLine = 1;
  } // Properties of the current token:
  // Its type


  this.type = types.eof; // For tokens that include more information than their type, the value

  this.value = null; // Its start and end offset

  this.start = this.end = this.pos; // And, if locations are used, the {line, column} object
  // corresponding to those offsets

  this.startLoc = this.endLoc = this.curPosition(); // Position information for the previous token

  this.lastTokEndLoc = this.lastTokStartLoc = null;
  this.lastTokStart = this.lastTokEnd = this.pos; // The context stack is used to superficially track syntactic
  // context to predict whether a regular expression is allowed in a
  // given position.

  this.context = this.initialContext();
  this.exprAllowed = true; // Figure out if it's a module code.

  this.inModule = options.sourceType === "module";
  this.strict = this.inModule || this.strictDirective(this.pos); // Used to signify the start of a potential arrow function

  this.potentialArrowAt = -1; // Positions to delayed-check that yield/await does not exist in default parameters.

  this.yieldPos = this.awaitPos = 0; // Labels in scope.

  this.labels = []; // If enabled, skip leading hashbang line.

  if (this.pos === 0 && options.allowHashBang && this.input.slice(0, 2) === "#!") {
    this.skipLineComment(2);
  } // Scope tracking for duplicate variable names (see scope.js)


  this.scopeStack = [];
  this.enterScope(SCOPE_TOP); // For RegExp validation

  this.regexpState = null;
};

var prototypeAccessors = {
  inFunction: {
    configurable: true
  },
  inGenerator: {
    configurable: true
  },
  inAsync: {
    configurable: true
  }
};

Parser.prototype.parse = function parse() {
  var node = this.options.program || this.startNode();
  this.nextToken();
  return this.parseTopLevel(node);
};

prototypeAccessors.inFunction.get = function () {
  return (this.currentVarScope().flags & SCOPE_FUNCTION) > 0;
};

prototypeAccessors.inGenerator.get = function () {
  return (this.currentVarScope().flags & SCOPE_GENERATOR) > 0;
};

prototypeAccessors.inAsync.get = function () {
  return (this.currentVarScope().flags & SCOPE_ASYNC) > 0;
};

Parser.extend = function extend() {
  var plugins = [],
      len = arguments.length;

  while (len--) {
    plugins[len] = arguments[len];
  }

  var cls = this;

  for (var i = 0; i < plugins.length; i++) {
    cls = plugins[i](cls);
  }

  return cls;
};

Parser.parse = function parse(input, options) {
  return new this(options, input).parse();
};

Parser.parseExpressionAt = function parseExpressionAt(input, pos, options) {
  var parser = new this(options, input, pos);
  parser.nextToken();
  return parser.parseExpression();
};

Parser.tokenizer = function tokenizer(input, options) {
  return new this(options, input);
};

Object.defineProperties(Parser.prototype, prototypeAccessors);
var pp = Parser.prototype; // ## Parser utilities

var literal = /^(?:'((?:\\.|[^'])*?)'|"((?:\\.|[^"])*?)"|;)/;

pp.strictDirective = function (start) {
  var this$1 = this;

  for (;;) {
    skipWhiteSpace.lastIndex = start;
    start += skipWhiteSpace.exec(this$1.input)[0].length;
    var match = literal.exec(this$1.input.slice(start));

    if (!match) {
      return false;
    }

    if ((match[1] || match[2]) === "use strict") {
      return true;
    }

    start += match[0].length;
  }
}; // Predicate that tests whether the next token is of the given
// type, and if yes, consumes it as a side effect.


pp.eat = function (type) {
  if (this.type === type) {
    this.next();
    return true;
  } else {
    return false;
  }
}; // Tests whether parsed token is a contextual keyword.


pp.isContextual = function (name) {
  return this.type === types.name && this.value === name && !this.containsEsc;
}; // Consumes contextual keyword if possible.


pp.eatContextual = function (name) {
  if (!this.isContextual(name)) {
    return false;
  }

  this.next();
  return true;
}; // Asserts that following token is given contextual keyword.


pp.expectContextual = function (name) {
  if (!this.eatContextual(name)) {
    this.unexpected();
  }
}; // Test whether a semicolon can be inserted at the current position.


pp.canInsertSemicolon = function () {
  return this.type === types.eof || this.type === types.braceR || lineBreak.test(this.input.slice(this.lastTokEnd, this.start));
};

pp.insertSemicolon = function () {
  if (this.canInsertSemicolon()) {
    if (this.options.onInsertedSemicolon) {
      this.options.onInsertedSemicolon(this.lastTokEnd, this.lastTokEndLoc);
    }

    return true;
  }
}; // Consume a semicolon, or, failing that, see if we are allowed to
// pretend that there is a semicolon at this position.


pp.semicolon = function () {
  if (!this.eat(types.semi) && !this.insertSemicolon()) {
    this.unexpected();
  }
};

pp.afterTrailingComma = function (tokType, notNext) {
  if (this.type === tokType) {
    if (this.options.onTrailingComma) {
      this.options.onTrailingComma(this.lastTokStart, this.lastTokStartLoc);
    }

    if (!notNext) {
      this.next();
    }

    return true;
  }
}; // Expect a token of a given type. If found, consume it, otherwise,
// raise an unexpected token error.


pp.expect = function (type) {
  this.eat(type) || this.unexpected();
}; // Raise an unexpected token error.


pp.unexpected = function (pos) {
  this.raise(pos != null ? pos : this.start, "Unexpected token");
};

function DestructuringErrors() {
  this.shorthandAssign = this.trailingComma = this.parenthesizedAssign = this.parenthesizedBind = this.doubleProto = -1;
}

pp.checkPatternErrors = function (refDestructuringErrors, isAssign) {
  if (!refDestructuringErrors) {
    return;
  }

  if (refDestructuringErrors.trailingComma > -1) {
    this.raiseRecoverable(refDestructuringErrors.trailingComma, "Comma is not permitted after the rest element");
  }

  var parens = isAssign ? refDestructuringErrors.parenthesizedAssign : refDestructuringErrors.parenthesizedBind;

  if (parens > -1) {
    this.raiseRecoverable(parens, "Parenthesized pattern");
  }
};

pp.checkExpressionErrors = function (refDestructuringErrors, andThrow) {
  if (!refDestructuringErrors) {
    return false;
  }

  var shorthandAssign = refDestructuringErrors.shorthandAssign;
  var doubleProto = refDestructuringErrors.doubleProto;

  if (!andThrow) {
    return shorthandAssign >= 0 || doubleProto >= 0;
  }

  if (shorthandAssign >= 0) {
    this.raise(shorthandAssign, "Shorthand property assignments are valid only in destructuring patterns");
  }

  if (doubleProto >= 0) {
    this.raiseRecoverable(doubleProto, "Redefinition of __proto__ property");
  }
};

pp.checkYieldAwaitInDefaultParams = function () {
  if (this.yieldPos && (!this.awaitPos || this.yieldPos < this.awaitPos)) {
    this.raise(this.yieldPos, "Yield expression cannot be a default value");
  }

  if (this.awaitPos) {
    this.raise(this.awaitPos, "Await expression cannot be a default value");
  }
};

pp.isSimpleAssignTarget = function (expr) {
  if (expr.type === "ParenthesizedExpression") {
    return this.isSimpleAssignTarget(expr.expression);
  }

  return expr.type === "Identifier" || expr.type === "MemberExpression";
};

var pp$1 = Parser.prototype; // ### Statement parsing
// Parse a program. Initializes the parser, reads any number of
// statements, and wraps them in a Program node.  Optionally takes a
// `program` argument.  If present, the statements will be appended
// to its body instead of creating a new node.

pp$1.parseTopLevel = function (node) {
  var this$1 = this;
  var exports = {};

  if (!node.body) {
    node.body = [];
  }

  while (this.type !== types.eof) {
    var stmt = this$1.parseStatement(null, true, exports);
    node.body.push(stmt);
  }

  this.adaptDirectivePrologue(node.body);
  this.next();

  if (this.options.ecmaVersion >= 6) {
    node.sourceType = this.options.sourceType;
  }

  return this.finishNode(node, "Program");
};

var loopLabel = {
  kind: "loop"
};
var switchLabel = {
  kind: "switch"
};

pp$1.isLet = function () {
  if (this.options.ecmaVersion < 6 || !this.isContextual("let")) {
    return false;
  }

  skipWhiteSpace.lastIndex = this.pos;
  var skip = skipWhiteSpace.exec(this.input);
  var next = this.pos + skip[0].length,
      nextCh = this.input.charCodeAt(next);

  if (nextCh === 91 || nextCh === 123) {
    return true;
  } // '{' and '['


  if (isIdentifierStart(nextCh, true)) {
    var pos = next + 1;

    while (isIdentifierChar(this.input.charCodeAt(pos), true)) {
      ++pos;
    }

    var ident = this.input.slice(next, pos);

    if (!keywordRelationalOperator.test(ident)) {
      return true;
    }
  }

  return false;
}; // check 'async [no LineTerminator here] function'
// - 'async /*foo*/ function' is OK.
// - 'async /*\n*/ function' is invalid.


pp$1.isAsyncFunction = function () {
  if (this.options.ecmaVersion < 8 || !this.isContextual("async")) {
    return false;
  }

  skipWhiteSpace.lastIndex = this.pos;
  var skip = skipWhiteSpace.exec(this.input);
  var next = this.pos + skip[0].length;
  return !lineBreak.test(this.input.slice(this.pos, next)) && this.input.slice(next, next + 8) === "function" && (next + 8 === this.input.length || !isIdentifierChar(this.input.charAt(next + 8)));
}; // Parse a single statement.
//
// If expecting a statement and finding a slash operator, parse a
// regular expression literal. This is to handle cases like
// `if (foo) /blah/.exec(foo)`, where looking at the previous token
// does not help.


pp$1.parseStatement = function (context, topLevel, exports) {
  var starttype = this.type,
      node = this.startNode(),
      kind;

  if (this.isLet()) {
    starttype = types._var;
    kind = "let";
  } // Most types of statements are recognized by the keyword they
  // start with. Many are trivial to parse, some require a bit of
  // complexity.


  switch (starttype) {
    case types._break:
    case types._continue:
      return this.parseBreakContinueStatement(node, starttype.keyword);

    case types._debugger:
      return this.parseDebuggerStatement(node);

    case types._do:
      return this.parseDoStatement(node);

    case types._for:
      return this.parseForStatement(node);

    case types._function:
      if (context && (this.strict || context !== "if") && this.options.ecmaVersion >= 6) {
        this.unexpected();
      }

      return this.parseFunctionStatement(node, false, !context);

    case types._class:
      if (context) {
        this.unexpected();
      }

      return this.parseClass(node, true);

    case types._if:
      return this.parseIfStatement(node);

    case types._return:
      return this.parseReturnStatement(node);

    case types._switch:
      return this.parseSwitchStatement(node);

    case types._throw:
      return this.parseThrowStatement(node);

    case types._try:
      return this.parseTryStatement(node);

    case types._const:
    case types._var:
      kind = kind || this.value;

      if (context && kind !== "var") {
        this.unexpected();
      }

      return this.parseVarStatement(node, kind);

    case types._while:
      return this.parseWhileStatement(node);

    case types._with:
      return this.parseWithStatement(node);

    case types.braceL:
      return this.parseBlock(true, node);

    case types.semi:
      return this.parseEmptyStatement(node);

    case types._export:
    case types._import:
      if (!this.options.allowImportExportEverywhere) {
        if (!topLevel) {
          this.raise(this.start, "'import' and 'export' may only appear at the top level");
        }

        if (!this.inModule) {
          this.raise(this.start, "'import' and 'export' may appear only with 'sourceType: module'");
        }
      }

      return starttype === types._import ? this.parseImport(node) : this.parseExport(node, exports);
    // If the statement does not start with a statement keyword or a
    // brace, it's an ExpressionStatement or LabeledStatement. We
    // simply start parsing an expression, and afterwards, if the
    // next token is a colon and the expression was a simple
    // Identifier node, we switch to interpreting it as a label.

    default:
      if (this.isAsyncFunction()) {
        if (context) {
          this.unexpected();
        }

        this.next();
        return this.parseFunctionStatement(node, true, !context);
      }

      var maybeName = this.value,
          expr = this.parseExpression();

      if (starttype === types.name && expr.type === "Identifier" && this.eat(types.colon)) {
        return this.parseLabeledStatement(node, maybeName, expr, context);
      } else {
        return this.parseExpressionStatement(node, expr);
      }

  }
};

pp$1.parseBreakContinueStatement = function (node, keyword) {
  var this$1 = this;
  var isBreak = keyword === "break";
  this.next();

  if (this.eat(types.semi) || this.insertSemicolon()) {
    node.label = null;
  } else if (this.type !== types.name) {
    this.unexpected();
  } else {
    node.label = this.parseIdent();
    this.semicolon();
  } // Verify that there is an actual destination to break or
  // continue to.


  var i = 0;

  for (; i < this.labels.length; ++i) {
    var lab = this$1.labels[i];

    if (node.label == null || lab.name === node.label.name) {
      if (lab.kind != null && (isBreak || lab.kind === "loop")) {
        break;
      }

      if (node.label && isBreak) {
        break;
      }
    }
  }

  if (i === this.labels.length) {
    this.raise(node.start, "Unsyntactic " + keyword);
  }

  return this.finishNode(node, isBreak ? "BreakStatement" : "ContinueStatement");
};

pp$1.parseDebuggerStatement = function (node) {
  this.next();
  this.semicolon();
  return this.finishNode(node, "DebuggerStatement");
};

pp$1.parseDoStatement = function (node) {
  this.next();
  this.labels.push(loopLabel);
  node.body = this.parseStatement("do");
  this.labels.pop();
  this.expect(types._while);
  node.test = this.parseParenExpression();

  if (this.options.ecmaVersion >= 6) {
    this.eat(types.semi);
  } else {
    this.semicolon();
  }

  return this.finishNode(node, "DoWhileStatement");
}; // Disambiguating between a `for` and a `for`/`in` or `for`/`of`
// loop is non-trivial. Basically, we have to parse the init `var`
// statement or expression, disallowing the `in` operator (see
// the second parameter to `parseExpression`), and then check
// whether the next token is `in` or `of`. When there is no init
// part (semicolon immediately after the opening parenthesis), it
// is a regular `for` loop.


pp$1.parseForStatement = function (node) {
  this.next();
  var awaitAt = this.options.ecmaVersion >= 9 && (this.inAsync || !this.inFunction && this.options.allowAwaitOutsideFunction) && this.eatContextual("await") ? this.lastTokStart : -1;
  this.labels.push(loopLabel);
  this.enterScope(0);
  this.expect(types.parenL);

  if (this.type === types.semi) {
    if (awaitAt > -1) {
      this.unexpected(awaitAt);
    }

    return this.parseFor(node, null);
  }

  var isLet = this.isLet();

  if (this.type === types._var || this.type === types._const || isLet) {
    var init$1 = this.startNode(),
        kind = isLet ? "let" : this.value;
    this.next();
    this.parseVar(init$1, true, kind);
    this.finishNode(init$1, "VariableDeclaration");

    if ((this.type === types._in || this.options.ecmaVersion >= 6 && this.isContextual("of")) && init$1.declarations.length === 1 && !(kind !== "var" && init$1.declarations[0].init)) {
      if (this.options.ecmaVersion >= 9) {
        if (this.type === types._in) {
          if (awaitAt > -1) {
            this.unexpected(awaitAt);
          }
        } else {
          node["await"] = awaitAt > -1;
        }
      }

      return this.parseForIn(node, init$1);
    }

    if (awaitAt > -1) {
      this.unexpected(awaitAt);
    }

    return this.parseFor(node, init$1);
  }

  var refDestructuringErrors = new DestructuringErrors();
  var init = this.parseExpression(true, refDestructuringErrors);

  if (this.type === types._in || this.options.ecmaVersion >= 6 && this.isContextual("of")) {
    if (this.options.ecmaVersion >= 9) {
      if (this.type === types._in) {
        if (awaitAt > -1) {
          this.unexpected(awaitAt);
        }
      } else {
        node["await"] = awaitAt > -1;
      }
    }

    this.toAssignable(init, false, refDestructuringErrors);
    this.checkLVal(init);
    return this.parseForIn(node, init);
  } else {
    this.checkExpressionErrors(refDestructuringErrors, true);
  }

  if (awaitAt > -1) {
    this.unexpected(awaitAt);
  }

  return this.parseFor(node, init);
};

pp$1.parseFunctionStatement = function (node, isAsync, declarationPosition) {
  this.next();
  return this.parseFunction(node, FUNC_STATEMENT | (declarationPosition ? 0 : FUNC_HANGING_STATEMENT), false, isAsync);
};

pp$1.parseIfStatement = function (node) {
  this.next();
  node.test = this.parseParenExpression(); // allow function declarations in branches, but only in non-strict mode

  node.consequent = this.parseStatement("if");
  node.alternate = this.eat(types._else) ? this.parseStatement("if") : null;
  return this.finishNode(node, "IfStatement");
};

pp$1.parseReturnStatement = function (node) {
  if (!this.inFunction && !this.options.allowReturnOutsideFunction) {
    this.raise(this.start, "'return' outside of function");
  }

  this.next(); // In `return` (and `break`/`continue`), the keywords with
  // optional arguments, we eagerly look for a semicolon or the
  // possibility to insert one.

  if (this.eat(types.semi) || this.insertSemicolon()) {
    node.argument = null;
  } else {
    node.argument = this.parseExpression();
    this.semicolon();
  }

  return this.finishNode(node, "ReturnStatement");
};

pp$1.parseSwitchStatement = function (node) {
  var this$1 = this;
  this.next();
  node.discriminant = this.parseParenExpression();
  node.cases = [];
  this.expect(types.braceL);
  this.labels.push(switchLabel);
  this.enterScope(0); // Statements under must be grouped (by label) in SwitchCase
  // nodes. `cur` is used to keep the node that we are currently
  // adding statements to.

  var cur;

  for (var sawDefault = false; this.type !== types.braceR;) {
    if (this$1.type === types._case || this$1.type === types._default) {
      var isCase = this$1.type === types._case;

      if (cur) {
        this$1.finishNode(cur, "SwitchCase");
      }

      node.cases.push(cur = this$1.startNode());
      cur.consequent = [];
      this$1.next();

      if (isCase) {
        cur.test = this$1.parseExpression();
      } else {
        if (sawDefault) {
          this$1.raiseRecoverable(this$1.lastTokStart, "Multiple default clauses");
        }

        sawDefault = true;
        cur.test = null;
      }

      this$1.expect(types.colon);
    } else {
      if (!cur) {
        this$1.unexpected();
      }

      cur.consequent.push(this$1.parseStatement(null));
    }
  }

  this.exitScope();

  if (cur) {
    this.finishNode(cur, "SwitchCase");
  }

  this.next(); // Closing brace

  this.labels.pop();
  return this.finishNode(node, "SwitchStatement");
};

pp$1.parseThrowStatement = function (node) {
  this.next();

  if (lineBreak.test(this.input.slice(this.lastTokEnd, this.start))) {
    this.raise(this.lastTokEnd, "Illegal newline after throw");
  }

  node.argument = this.parseExpression();
  this.semicolon();
  return this.finishNode(node, "ThrowStatement");
}; // Reused empty array added for node fields that are always empty.


var empty = [];

pp$1.parseTryStatement = function (node) {
  this.next();
  node.block = this.parseBlock();
  node.handler = null;

  if (this.type === types._catch) {
    var clause = this.startNode();
    this.next();

    if (this.eat(types.parenL)) {
      clause.param = this.parseBindingAtom();
      var simple = clause.param.type === "Identifier";
      this.enterScope(simple ? SCOPE_SIMPLE_CATCH : 0);
      this.checkLVal(clause.param, simple ? BIND_SIMPLE_CATCH : BIND_LEXICAL);
      this.expect(types.parenR);
    } else {
      if (this.options.ecmaVersion < 10) {
        this.unexpected();
      }

      clause.param = null;
      this.enterScope(0);
    }

    clause.body = this.parseBlock(false);
    this.exitScope();
    node.handler = this.finishNode(clause, "CatchClause");
  }

  node.finalizer = this.eat(types._finally) ? this.parseBlock() : null;

  if (!node.handler && !node.finalizer) {
    this.raise(node.start, "Missing catch or finally clause");
  }

  return this.finishNode(node, "TryStatement");
};

pp$1.parseVarStatement = function (node, kind) {
  this.next();
  this.parseVar(node, false, kind);
  this.semicolon();
  return this.finishNode(node, "VariableDeclaration");
};

pp$1.parseWhileStatement = function (node) {
  this.next();
  node.test = this.parseParenExpression();
  this.labels.push(loopLabel);
  node.body = this.parseStatement("while");
  this.labels.pop();
  return this.finishNode(node, "WhileStatement");
};

pp$1.parseWithStatement = function (node) {
  if (this.strict) {
    this.raise(this.start, "'with' in strict mode");
  }

  this.next();
  node.object = this.parseParenExpression();
  node.body = this.parseStatement("with");
  return this.finishNode(node, "WithStatement");
};

pp$1.parseEmptyStatement = function (node) {
  this.next();
  return this.finishNode(node, "EmptyStatement");
};

pp$1.parseLabeledStatement = function (node, maybeName, expr, context) {
  var this$1 = this;

  for (var i$1 = 0, list = this$1.labels; i$1 < list.length; i$1 += 1) {
    var label = list[i$1];

    if (label.name === maybeName) {
      this$1.raise(expr.start, "Label '" + maybeName + "' is already declared");
    }
  }

  var kind = this.type.isLoop ? "loop" : this.type === types._switch ? "switch" : null;

  for (var i = this.labels.length - 1; i >= 0; i--) {
    var label$1 = this$1.labels[i];

    if (label$1.statementStart === node.start) {
      // Update information about previous labels on this node
      label$1.statementStart = this$1.start;
      label$1.kind = kind;
    } else {
      break;
    }
  }

  this.labels.push({
    name: maybeName,
    kind: kind,
    statementStart: this.start
  });
  node.body = this.parseStatement(context);

  if (node.body.type === "ClassDeclaration" || node.body.type === "VariableDeclaration" && node.body.kind !== "var" || node.body.type === "FunctionDeclaration" && (this.strict || node.body.generator || node.body.async)) {
    this.raiseRecoverable(node.body.start, "Invalid labeled declaration");
  }

  this.labels.pop();
  node.label = expr;
  return this.finishNode(node, "LabeledStatement");
};

pp$1.parseExpressionStatement = function (node, expr) {
  node.expression = expr;
  this.semicolon();
  return this.finishNode(node, "ExpressionStatement");
}; // Parse a semicolon-enclosed block of statements, handling `"use
// strict"` declarations when `allowStrict` is true (used for
// function bodies).


pp$1.parseBlock = function (createNewLexicalScope, node) {
  var this$1 = this;
  if (createNewLexicalScope === void 0) createNewLexicalScope = true;
  if (node === void 0) node = this.startNode();
  node.body = [];
  this.expect(types.braceL);

  if (createNewLexicalScope) {
    this.enterScope(0);
  }

  while (!this.eat(types.braceR)) {
    var stmt = this$1.parseStatement(null);
    node.body.push(stmt);
  }

  if (createNewLexicalScope) {
    this.exitScope();
  }

  return this.finishNode(node, "BlockStatement");
}; // Parse a regular `for` loop. The disambiguation code in
// `parseStatement` will already have parsed the init statement or
// expression.


pp$1.parseFor = function (node, init) {
  node.init = init;
  this.expect(types.semi);
  node.test = this.type === types.semi ? null : this.parseExpression();
  this.expect(types.semi);
  node.update = this.type === types.parenR ? null : this.parseExpression();
  this.expect(types.parenR);
  this.exitScope();
  node.body = this.parseStatement("for");
  this.labels.pop();
  return this.finishNode(node, "ForStatement");
}; // Parse a `for`/`in` and `for`/`of` loop, which are almost
// same from parser's perspective.


pp$1.parseForIn = function (node, init) {
  var type = this.type === types._in ? "ForInStatement" : "ForOfStatement";
  this.next();

  if (type === "ForInStatement") {
    if (init.type === "AssignmentPattern" || init.type === "VariableDeclaration" && init.declarations[0].init != null && (this.strict || init.declarations[0].id.type !== "Identifier")) {
      this.raise(init.start, "Invalid assignment in for-in loop head");
    }
  }

  node.left = init;
  node.right = type === "ForInStatement" ? this.parseExpression() : this.parseMaybeAssign();
  this.expect(types.parenR);
  this.exitScope();
  node.body = this.parseStatement("for");
  this.labels.pop();
  return this.finishNode(node, type);
}; // Parse a list of variable declarations.


pp$1.parseVar = function (node, isFor, kind) {
  var this$1 = this;
  node.declarations = [];
  node.kind = kind;

  for (;;) {
    var decl = this$1.startNode();
    this$1.parseVarId(decl, kind);

    if (this$1.eat(types.eq)) {
      decl.init = this$1.parseMaybeAssign(isFor);
    } else if (kind === "const" && !(this$1.type === types._in || this$1.options.ecmaVersion >= 6 && this$1.isContextual("of"))) {
      this$1.unexpected();
    } else if (decl.id.type !== "Identifier" && !(isFor && (this$1.type === types._in || this$1.isContextual("of")))) {
      this$1.raise(this$1.lastTokEnd, "Complex binding patterns require an initialization value");
    } else {
      decl.init = null;
    }

    node.declarations.push(this$1.finishNode(decl, "VariableDeclarator"));

    if (!this$1.eat(types.comma)) {
      break;
    }
  }

  return node;
};

pp$1.parseVarId = function (decl, kind) {
  decl.id = this.parseBindingAtom(kind);
  this.checkLVal(decl.id, kind === "var" ? BIND_VAR : BIND_LEXICAL, false);
};

var FUNC_STATEMENT = 1;
var FUNC_HANGING_STATEMENT = 2;
var FUNC_NULLABLE_ID = 4; // Parse a function declaration or literal (depending on the
// `isStatement` parameter).

pp$1.parseFunction = function (node, statement, allowExpressionBody, isAsync) {
  this.initFunction(node);

  if (this.options.ecmaVersion >= 9 || this.options.ecmaVersion >= 6 && !isAsync) {
    node.generator = this.eat(types.star);
  }

  if (this.options.ecmaVersion >= 8) {
    node.async = !!isAsync;
  }

  if (statement & FUNC_STATEMENT) {
    node.id = statement & FUNC_NULLABLE_ID && this.type !== types.name ? null : this.parseIdent();

    if (node.id && !(statement & FUNC_HANGING_STATEMENT)) {
      this.checkLVal(node.id, this.inModule && !this.inFunction ? BIND_LEXICAL : BIND_FUNCTION);
    }
  }

  var oldYieldPos = this.yieldPos,
      oldAwaitPos = this.awaitPos;
  this.yieldPos = 0;
  this.awaitPos = 0;
  this.enterScope(functionFlags(node.async, node.generator));

  if (!(statement & FUNC_STATEMENT)) {
    node.id = this.type === types.name ? this.parseIdent() : null;
  }

  this.parseFunctionParams(node);
  this.parseFunctionBody(node, allowExpressionBody);
  this.yieldPos = oldYieldPos;
  this.awaitPos = oldAwaitPos;
  return this.finishNode(node, statement & FUNC_STATEMENT ? "FunctionDeclaration" : "FunctionExpression");
};

pp$1.parseFunctionParams = function (node) {
  this.expect(types.parenL);
  node.params = this.parseBindingList(types.parenR, false, this.options.ecmaVersion >= 8);
  this.checkYieldAwaitInDefaultParams();
}; // Parse a class declaration or literal (depending on the
// `isStatement` parameter).


pp$1.parseClass = function (node, isStatement) {
  var this$1 = this;
  this.next();
  this.parseClassId(node, isStatement);
  this.parseClassSuper(node);
  var classBody = this.startNode();
  var hadConstructor = false;
  classBody.body = [];
  this.expect(types.braceL);

  while (!this.eat(types.braceR)) {
    var element = this$1.parseClassElement();

    if (element) {
      classBody.body.push(element);

      if (element.type === "MethodDefinition" && element.kind === "constructor") {
        if (hadConstructor) {
          this$1.raise(element.start, "Duplicate constructor in the same class");
        }

        hadConstructor = true;
      }
    }
  }

  node.body = this.finishNode(classBody, "ClassBody");
  return this.finishNode(node, isStatement ? "ClassDeclaration" : "ClassExpression");
};

pp$1.parseClassElement = function () {
  var this$1 = this;

  if (this.eat(types.semi)) {
    return null;
  }

  var method = this.startNode();

  var tryContextual = function tryContextual(k, noLineBreak) {
    if (noLineBreak === void 0) noLineBreak = false;
    var start = this$1.start,
        startLoc = this$1.startLoc;

    if (!this$1.eatContextual(k)) {
      return false;
    }

    if (this$1.type !== types.parenL && (!noLineBreak || !this$1.canInsertSemicolon())) {
      return true;
    }

    if (method.key) {
      this$1.unexpected();
    }

    method.computed = false;
    method.key = this$1.startNodeAt(start, startLoc);
    method.key.name = k;
    this$1.finishNode(method.key, "Identifier");
    return false;
  };

  method.kind = "method";
  method["static"] = tryContextual("static");
  var isGenerator = this.eat(types.star);
  var isAsync = false;

  if (!isGenerator) {
    if (this.options.ecmaVersion >= 8 && tryContextual("async", true)) {
      isAsync = true;
      isGenerator = this.options.ecmaVersion >= 9 && this.eat(types.star);
    } else if (tryContextual("get")) {
      method.kind = "get";
    } else if (tryContextual("set")) {
      method.kind = "set";
    }
  }

  if (!method.key) {
    this.parsePropertyName(method);
  }

  var key = method.key;

  if (!method.computed && !method["static"] && (key.type === "Identifier" && key.name === "constructor" || key.type === "Literal" && key.value === "constructor")) {
    if (method.kind !== "method") {
      this.raise(key.start, "Constructor can't have get/set modifier");
    }

    if (isGenerator) {
      this.raise(key.start, "Constructor can't be a generator");
    }

    if (isAsync) {
      this.raise(key.start, "Constructor can't be an async method");
    }

    method.kind = "constructor";
  } else if (method["static"] && key.type === "Identifier" && key.name === "prototype") {
    this.raise(key.start, "Classes may not have a static property named prototype");
  }

  this.parseClassMethod(method, isGenerator, isAsync);

  if (method.kind === "get" && method.value.params.length !== 0) {
    this.raiseRecoverable(method.value.start, "getter should have no params");
  }

  if (method.kind === "set" && method.value.params.length !== 1) {
    this.raiseRecoverable(method.value.start, "setter should have exactly one param");
  }

  if (method.kind === "set" && method.value.params[0].type === "RestElement") {
    this.raiseRecoverable(method.value.params[0].start, "Setter cannot use rest params");
  }

  return method;
};

pp$1.parseClassMethod = function (method, isGenerator, isAsync) {
  method.value = this.parseMethod(isGenerator, isAsync);
  return this.finishNode(method, "MethodDefinition");
};

pp$1.parseClassId = function (node, isStatement) {
  node.id = this.type === types.name ? this.parseIdent() : isStatement === true ? this.unexpected() : null;
};

pp$1.parseClassSuper = function (node) {
  node.superClass = this.eat(types._extends) ? this.parseExprSubscripts() : null;
}; // Parses module export declaration.


pp$1.parseExport = function (node, exports) {
  var this$1 = this;
  this.next(); // export * from '...'

  if (this.eat(types.star)) {
    this.expectContextual("from");

    if (this.type !== types.string) {
      this.unexpected();
    }

    node.source = this.parseExprAtom();
    this.semicolon();
    return this.finishNode(node, "ExportAllDeclaration");
  }

  if (this.eat(types._default)) {
    // export default ...
    this.checkExport(exports, "default", this.lastTokStart);
    var isAsync;

    if (this.type === types._function || (isAsync = this.isAsyncFunction())) {
      var fNode = this.startNode();
      this.next();

      if (isAsync) {
        this.next();
      }

      node.declaration = this.parseFunction(fNode, FUNC_STATEMENT | FUNC_NULLABLE_ID, false, isAsync, true);
    } else if (this.type === types._class) {
      var cNode = this.startNode();
      node.declaration = this.parseClass(cNode, "nullableID");
    } else {
      node.declaration = this.parseMaybeAssign();
      this.semicolon();
    }

    return this.finishNode(node, "ExportDefaultDeclaration");
  } // export var|const|let|function|class ...


  if (this.shouldParseExportStatement()) {
    node.declaration = this.parseStatement(null);

    if (node.declaration.type === "VariableDeclaration") {
      this.checkVariableExport(exports, node.declaration.declarations);
    } else {
      this.checkExport(exports, node.declaration.id.name, node.declaration.id.start);
    }

    node.specifiers = [];
    node.source = null;
  } else {
    // export { x, y as z } [from '...']
    node.declaration = null;
    node.specifiers = this.parseExportSpecifiers(exports);

    if (this.eatContextual("from")) {
      if (this.type !== types.string) {
        this.unexpected();
      }

      node.source = this.parseExprAtom();
    } else {
      // check for keywords used as local names
      for (var i = 0, list = node.specifiers; i < list.length; i += 1) {
        var spec = list[i];
        this$1.checkUnreserved(spec.local);
      }

      node.source = null;
    }

    this.semicolon();
  }

  return this.finishNode(node, "ExportNamedDeclaration");
};

pp$1.checkExport = function (exports, name, pos) {
  if (!exports) {
    return;
  }

  if (has(exports, name)) {
    this.raiseRecoverable(pos, "Duplicate export '" + name + "'");
  }

  exports[name] = true;
};

pp$1.checkPatternExport = function (exports, pat) {
  var this$1 = this;
  var type = pat.type;

  if (type === "Identifier") {
    this.checkExport(exports, pat.name, pat.start);
  } else if (type === "ObjectPattern") {
    for (var i = 0, list = pat.properties; i < list.length; i += 1) {
      var prop = list[i];
      this$1.checkPatternExport(exports, prop);
    }
  } else if (type === "ArrayPattern") {
    for (var i$1 = 0, list$1 = pat.elements; i$1 < list$1.length; i$1 += 1) {
      var elt = list$1[i$1];

      if (elt) {
        this$1.checkPatternExport(exports, elt);
      }
    }
  } else if (type === "Property") {
    this.checkPatternExport(exports, pat.value);
  } else if (type === "AssignmentPattern") {
    this.checkPatternExport(exports, pat.left);
  } else if (type === "RestElement") {
    this.checkPatternExport(exports, pat.argument);
  } else if (type === "ParenthesizedExpression") {
    this.checkPatternExport(exports, pat.expression);
  }
};

pp$1.checkVariableExport = function (exports, decls) {
  var this$1 = this;

  if (!exports) {
    return;
  }

  for (var i = 0, list = decls; i < list.length; i += 1) {
    var decl = list[i];
    this$1.checkPatternExport(exports, decl.id);
  }
};

pp$1.shouldParseExportStatement = function () {
  return this.type.keyword === "var" || this.type.keyword === "const" || this.type.keyword === "class" || this.type.keyword === "function" || this.isLet() || this.isAsyncFunction();
}; // Parses a comma-separated list of module exports.


pp$1.parseExportSpecifiers = function (exports) {
  var this$1 = this;
  var nodes = [],
      first = true; // export { x, y as z } [from '...']

  this.expect(types.braceL);

  while (!this.eat(types.braceR)) {
    if (!first) {
      this$1.expect(types.comma);

      if (this$1.afterTrailingComma(types.braceR)) {
        break;
      }
    } else {
      first = false;
    }

    var node = this$1.startNode();
    node.local = this$1.parseIdent(true);
    node.exported = this$1.eatContextual("as") ? this$1.parseIdent(true) : node.local;
    this$1.checkExport(exports, node.exported.name, node.exported.start);
    nodes.push(this$1.finishNode(node, "ExportSpecifier"));
  }

  return nodes;
}; // Parses import declaration.


pp$1.parseImport = function (node) {
  this.next(); // import '...'

  if (this.type === types.string) {
    node.specifiers = empty;
    node.source = this.parseExprAtom();
  } else {
    node.specifiers = this.parseImportSpecifiers();
    this.expectContextual("from");
    node.source = this.type === types.string ? this.parseExprAtom() : this.unexpected();
  }

  this.semicolon();
  return this.finishNode(node, "ImportDeclaration");
}; // Parses a comma-separated list of module imports.


pp$1.parseImportSpecifiers = function () {
  var this$1 = this;
  var nodes = [],
      first = true;

  if (this.type === types.name) {
    // import defaultObj, { x, y as z } from '...'
    var node = this.startNode();
    node.local = this.parseIdent();
    this.checkLVal(node.local, BIND_LEXICAL);
    nodes.push(this.finishNode(node, "ImportDefaultSpecifier"));

    if (!this.eat(types.comma)) {
      return nodes;
    }
  }

  if (this.type === types.star) {
    var node$1 = this.startNode();
    this.next();
    this.expectContextual("as");
    node$1.local = this.parseIdent();
    this.checkLVal(node$1.local, BIND_LEXICAL);
    nodes.push(this.finishNode(node$1, "ImportNamespaceSpecifier"));
    return nodes;
  }

  this.expect(types.braceL);

  while (!this.eat(types.braceR)) {
    if (!first) {
      this$1.expect(types.comma);

      if (this$1.afterTrailingComma(types.braceR)) {
        break;
      }
    } else {
      first = false;
    }

    var node$2 = this$1.startNode();
    node$2.imported = this$1.parseIdent(true);

    if (this$1.eatContextual("as")) {
      node$2.local = this$1.parseIdent();
    } else {
      this$1.checkUnreserved(node$2.imported);
      node$2.local = node$2.imported;
    }

    this$1.checkLVal(node$2.local, BIND_LEXICAL);
    nodes.push(this$1.finishNode(node$2, "ImportSpecifier"));
  }

  return nodes;
}; // Set `ExpressionStatement#directive` property for directive prologues.


pp$1.adaptDirectivePrologue = function (statements) {
  for (var i = 0; i < statements.length && this.isDirectiveCandidate(statements[i]); ++i) {
    statements[i].directive = statements[i].expression.raw.slice(1, -1);
  }
};

pp$1.isDirectiveCandidate = function (statement) {
  return statement.type === "ExpressionStatement" && statement.expression.type === "Literal" && typeof statement.expression.value === "string" && ( // Reject parenthesized strings.
  this.input[statement.start] === "\"" || this.input[statement.start] === "'");
};

var pp$2 = Parser.prototype; // Convert existing expression atom to assignable pattern
// if possible.

pp$2.toAssignable = function (node, isBinding, refDestructuringErrors) {
  var this$1 = this;

  if (this.options.ecmaVersion >= 6 && node) {
    switch (node.type) {
      case "Identifier":
        if (this.inAsync && node.name === "await") {
          this.raise(node.start, "Can not use 'await' as identifier inside an async function");
        }

        break;

      case "ObjectPattern":
      case "ArrayPattern":
      case "RestElement":
        break;

      case "ObjectExpression":
        node.type = "ObjectPattern";

        if (refDestructuringErrors) {
          this.checkPatternErrors(refDestructuringErrors, true);
        }

        for (var i = 0, list = node.properties; i < list.length; i += 1) {
          var prop = list[i];
          this$1.toAssignable(prop, isBinding); // Early error:
          //   AssignmentRestProperty[Yield, Await] :
          //     `...` DestructuringAssignmentTarget[Yield, Await]
          //
          //   It is a Syntax Error if |DestructuringAssignmentTarget| is an |ArrayLiteral| or an |ObjectLiteral|.

          if (prop.type === "RestElement" && (prop.argument.type === "ArrayPattern" || prop.argument.type === "ObjectPattern")) {
            this$1.raise(prop.argument.start, "Unexpected token");
          }
        }

        break;

      case "Property":
        // AssignmentProperty has type === "Property"
        if (node.kind !== "init") {
          this.raise(node.key.start, "Object pattern can't contain getter or setter");
        }

        this.toAssignable(node.value, isBinding);
        break;

      case "ArrayExpression":
        node.type = "ArrayPattern";

        if (refDestructuringErrors) {
          this.checkPatternErrors(refDestructuringErrors, true);
        }

        this.toAssignableList(node.elements, isBinding);
        break;

      case "SpreadElement":
        node.type = "RestElement";
        this.toAssignable(node.argument, isBinding);

        if (node.argument.type === "AssignmentPattern") {
          this.raise(node.argument.start, "Rest elements cannot have a default value");
        }

        break;

      case "AssignmentExpression":
        if (node.operator !== "=") {
          this.raise(node.left.end, "Only '=' operator can be used for specifying default value.");
        }

        node.type = "AssignmentPattern";
        delete node.operator;
        this.toAssignable(node.left, isBinding);
      // falls through to AssignmentPattern

      case "AssignmentPattern":
        break;

      case "ParenthesizedExpression":
        this.toAssignable(node.expression, isBinding);
        break;

      case "MemberExpression":
        if (!isBinding) {
          break;
        }

      default:
        this.raise(node.start, "Assigning to rvalue");
    }
  } else if (refDestructuringErrors) {
    this.checkPatternErrors(refDestructuringErrors, true);
  }

  return node;
}; // Convert list of expression atoms to binding list.


pp$2.toAssignableList = function (exprList, isBinding) {
  var this$1 = this;
  var end = exprList.length;

  for (var i = 0; i < end; i++) {
    var elt = exprList[i];

    if (elt) {
      this$1.toAssignable(elt, isBinding);
    }
  }

  if (end) {
    var last = exprList[end - 1];

    if (this.options.ecmaVersion === 6 && isBinding && last && last.type === "RestElement" && last.argument.type !== "Identifier") {
      this.unexpected(last.argument.start);
    }
  }

  return exprList;
}; // Parses spread element.


pp$2.parseSpread = function (refDestructuringErrors) {
  var node = this.startNode();
  this.next();
  node.argument = this.parseMaybeAssign(false, refDestructuringErrors);
  return this.finishNode(node, "SpreadElement");
};

pp$2.parseRestBinding = function () {
  var node = this.startNode();
  this.next(); // RestElement inside of a function parameter must be an identifier

  if (this.options.ecmaVersion === 6 && this.type !== types.name) {
    this.unexpected();
  }

  node.argument = this.parseBindingAtom();
  return this.finishNode(node, "RestElement");
}; // Parses lvalue (assignable) atom.


pp$2.parseBindingAtom = function () {
  if (this.options.ecmaVersion >= 6) {
    switch (this.type) {
      case types.bracketL:
        var node = this.startNode();
        this.next();
        node.elements = this.parseBindingList(types.bracketR, true, true);
        return this.finishNode(node, "ArrayPattern");

      case types.braceL:
        return this.parseObj(true);
    }
  }

  return this.parseIdent();
};

pp$2.parseBindingList = function (close, allowEmpty, allowTrailingComma) {
  var this$1 = this;
  var elts = [],
      first = true;

  while (!this.eat(close)) {
    if (first) {
      first = false;
    } else {
      this$1.expect(types.comma);
    }

    if (allowEmpty && this$1.type === types.comma) {
      elts.push(null);
    } else if (allowTrailingComma && this$1.afterTrailingComma(close)) {
      break;
    } else if (this$1.type === types.ellipsis) {
      var rest = this$1.parseRestBinding();
      this$1.parseBindingListItem(rest);
      elts.push(rest);

      if (this$1.type === types.comma) {
        this$1.raise(this$1.start, "Comma is not permitted after the rest element");
      }

      this$1.expect(close);
      break;
    } else {
      var elem = this$1.parseMaybeDefault(this$1.start, this$1.startLoc);
      this$1.parseBindingListItem(elem);
      elts.push(elem);
    }
  }

  return elts;
};

pp$2.parseBindingListItem = function (param) {
  return param;
}; // Parses assignment pattern around given atom if possible.


pp$2.parseMaybeDefault = function (startPos, startLoc, left) {
  left = left || this.parseBindingAtom();

  if (this.options.ecmaVersion < 6 || !this.eat(types.eq)) {
    return left;
  }

  var node = this.startNodeAt(startPos, startLoc);
  node.left = left;
  node.right = this.parseMaybeAssign();
  return this.finishNode(node, "AssignmentPattern");
}; // Verify that a node is an lval — something that can be assigned
// to.
// bindingType can be either:
// 'var' indicating that the lval creates a 'var' binding
// 'let' indicating that the lval creates a lexical ('let' or 'const') binding
// 'none' indicating that the binding should be checked for illegal identifiers, but not for duplicate references


pp$2.checkLVal = function (expr, bindingType, checkClashes) {
  var this$1 = this;
  if (bindingType === void 0) bindingType = BIND_NONE;

  switch (expr.type) {
    case "Identifier":
      if (this.strict && this.reservedWordsStrictBind.test(expr.name)) {
        this.raiseRecoverable(expr.start, (bindingType ? "Binding " : "Assigning to ") + expr.name + " in strict mode");
      }

      if (checkClashes) {
        if (has(checkClashes, expr.name)) {
          this.raiseRecoverable(expr.start, "Argument name clash");
        }

        checkClashes[expr.name] = true;
      }

      if (bindingType !== BIND_NONE && bindingType !== BIND_OUTSIDE) {
        this.declareName(expr.name, bindingType, expr.start);
      }

      break;

    case "MemberExpression":
      if (bindingType) {
        this.raiseRecoverable(expr.start, "Binding member expression");
      }

      break;

    case "ObjectPattern":
      for (var i = 0, list = expr.properties; i < list.length; i += 1) {
        var prop = list[i];
        this$1.checkLVal(prop, bindingType, checkClashes);
      }

      break;

    case "Property":
      // AssignmentProperty has type === "Property"
      this.checkLVal(expr.value, bindingType, checkClashes);
      break;

    case "ArrayPattern":
      for (var i$1 = 0, list$1 = expr.elements; i$1 < list$1.length; i$1 += 1) {
        var elem = list$1[i$1];

        if (elem) {
          this$1.checkLVal(elem, bindingType, checkClashes);
        }
      }

      break;

    case "AssignmentPattern":
      this.checkLVal(expr.left, bindingType, checkClashes);
      break;

    case "RestElement":
      this.checkLVal(expr.argument, bindingType, checkClashes);
      break;

    case "ParenthesizedExpression":
      this.checkLVal(expr.expression, bindingType, checkClashes);
      break;

    default:
      this.raise(expr.start, (bindingType ? "Binding" : "Assigning to") + " rvalue");
  }
}; // A recursive descent parser operates by defining functions for all
// syntactic elements, and recursively calling those, each function
// advancing the input stream and returning an AST node. Precedence
// of constructs (for example, the fact that `!x[1]` means `!(x[1])`
// instead of `(!x)[1]` is handled by the fact that the parser
// function that parses unary prefix operators is called first, and
// in turn calls the function that parses `[]` subscripts — that
// way, it'll receive the node for `x[1]` already parsed, and wraps
// *that* in the unary operator node.
//
// Acorn uses an [operator precedence parser][opp] to handle binary
// operator precedence, because it is much more compact than using
// the technique outlined above, which uses different, nesting
// functions to specify precedence, for all of the ten binary
// precedence levels that JavaScript defines.
//
// [opp]: http://en.wikipedia.org/wiki/Operator-precedence_parser


var pp$3 = Parser.prototype; // Check if property name clashes with already added.
// Object/class getters and setters are not allowed to clash —
// either with each other or with an init property — and in
// strict mode, init properties are also not allowed to be repeated.

pp$3.checkPropClash = function (prop, propHash, refDestructuringErrors) {
  if (this.options.ecmaVersion >= 9 && prop.type === "SpreadElement") {
    return;
  }

  if (this.options.ecmaVersion >= 6 && (prop.computed || prop.method || prop.shorthand)) {
    return;
  }

  var key = prop.key;
  var name;

  switch (key.type) {
    case "Identifier":
      name = key.name;
      break;

    case "Literal":
      name = String(key.value);
      break;

    default:
      return;
  }

  var kind = prop.kind;

  if (this.options.ecmaVersion >= 6) {
    if (name === "__proto__" && kind === "init") {
      if (propHash.proto) {
        if (refDestructuringErrors && refDestructuringErrors.doubleProto < 0) {
          refDestructuringErrors.doubleProto = key.start;
        } // Backwards-compat kludge. Can be removed in version 6.0
        else {
            this.raiseRecoverable(key.start, "Redefinition of __proto__ property");
          }
      }

      propHash.proto = true;
    }

    return;
  }

  name = "$" + name;
  var other = propHash[name];

  if (other) {
    var redefinition;

    if (kind === "init") {
      redefinition = this.strict && other.init || other.get || other.set;
    } else {
      redefinition = other.init || other[kind];
    }

    if (redefinition) {
      this.raiseRecoverable(key.start, "Redefinition of property");
    }
  } else {
    other = propHash[name] = {
      init: false,
      get: false,
      set: false
    };
  }

  other[kind] = true;
}; // ### Expression parsing
// These nest, from the most general expression type at the top to
// 'atomic', nondivisible expression types at the bottom. Most of
// the functions will simply let the function(s) below them parse,
// and, *if* the syntactic construct they handle is present, wrap
// the AST node that the inner parser gave them in another node.
// Parse a full expression. The optional arguments are used to
// forbid the `in` operator (in for loops initalization expressions)
// and provide reference for storing '=' operator inside shorthand
// property assignment in contexts where both object expression
// and object pattern might appear (so it's possible to raise
// delayed syntax error at correct position).


pp$3.parseExpression = function (noIn, refDestructuringErrors) {
  var this$1 = this;
  var startPos = this.start,
      startLoc = this.startLoc;
  var expr = this.parseMaybeAssign(noIn, refDestructuringErrors);

  if (this.type === types.comma) {
    var node = this.startNodeAt(startPos, startLoc);
    node.expressions = [expr];

    while (this.eat(types.comma)) {
      node.expressions.push(this$1.parseMaybeAssign(noIn, refDestructuringErrors));
    }

    return this.finishNode(node, "SequenceExpression");
  }

  return expr;
}; // Parse an assignment expression. This includes applications of
// operators like `+=`.


pp$3.parseMaybeAssign = function (noIn, refDestructuringErrors, afterLeftParse) {
  if (this.isContextual("yield")) {
    if (this.inGenerator) {
      return this.parseYield();
    } // The tokenizer will assume an expression is allowed after
    // `yield`, but this isn't that kind of yield
    else {
        this.exprAllowed = false;
      }
  }

  var ownDestructuringErrors = false,
      oldParenAssign = -1,
      oldTrailingComma = -1,
      oldShorthandAssign = -1;

  if (refDestructuringErrors) {
    oldParenAssign = refDestructuringErrors.parenthesizedAssign;
    oldTrailingComma = refDestructuringErrors.trailingComma;
    oldShorthandAssign = refDestructuringErrors.shorthandAssign;
    refDestructuringErrors.parenthesizedAssign = refDestructuringErrors.trailingComma = refDestructuringErrors.shorthandAssign = -1;
  } else {
    refDestructuringErrors = new DestructuringErrors();
    ownDestructuringErrors = true;
  }

  var startPos = this.start,
      startLoc = this.startLoc;

  if (this.type === types.parenL || this.type === types.name) {
    this.potentialArrowAt = this.start;
  }

  var left = this.parseMaybeConditional(noIn, refDestructuringErrors);

  if (afterLeftParse) {
    left = afterLeftParse.call(this, left, startPos, startLoc);
  }

  if (this.type.isAssign) {
    var node = this.startNodeAt(startPos, startLoc);
    node.operator = this.value;
    node.left = this.type === types.eq ? this.toAssignable(left, false, refDestructuringErrors) : left;

    if (!ownDestructuringErrors) {
      DestructuringErrors.call(refDestructuringErrors);
    }

    refDestructuringErrors.shorthandAssign = -1; // reset because shorthand default was used correctly

    this.checkLVal(left);
    this.next();
    node.right = this.parseMaybeAssign(noIn);
    return this.finishNode(node, "AssignmentExpression");
  } else {
    if (ownDestructuringErrors) {
      this.checkExpressionErrors(refDestructuringErrors, true);
    }
  }

  if (oldParenAssign > -1) {
    refDestructuringErrors.parenthesizedAssign = oldParenAssign;
  }

  if (oldTrailingComma > -1) {
    refDestructuringErrors.trailingComma = oldTrailingComma;
  }

  if (oldShorthandAssign > -1) {
    refDestructuringErrors.shorthandAssign = oldShorthandAssign;
  }

  return left;
}; // Parse a ternary conditional (`?:`) operator.


pp$3.parseMaybeConditional = function (noIn, refDestructuringErrors) {
  var startPos = this.start,
      startLoc = this.startLoc;
  var expr = this.parseExprOps(noIn, refDestructuringErrors);

  if (this.checkExpressionErrors(refDestructuringErrors)) {
    return expr;
  }

  if (this.eat(types.question)) {
    var node = this.startNodeAt(startPos, startLoc);
    node.test = expr;
    node.consequent = this.parseMaybeAssign();
    this.expect(types.colon);
    node.alternate = this.parseMaybeAssign(noIn);
    return this.finishNode(node, "ConditionalExpression");
  }

  return expr;
}; // Start the precedence parser.


pp$3.parseExprOps = function (noIn, refDestructuringErrors) {
  var startPos = this.start,
      startLoc = this.startLoc;
  var expr = this.parseMaybeUnary(refDestructuringErrors, false);

  if (this.checkExpressionErrors(refDestructuringErrors)) {
    return expr;
  }

  return expr.start === startPos && expr.type === "ArrowFunctionExpression" ? expr : this.parseExprOp(expr, startPos, startLoc, -1, noIn);
}; // Parse binary operators with the operator precedence parsing
// algorithm. `left` is the left-hand side of the operator.
// `minPrec` provides context that allows the function to stop and
// defer further parser to one of its callers when it encounters an
// operator that has a lower precedence than the set it is parsing.


pp$3.parseExprOp = function (left, leftStartPos, leftStartLoc, minPrec, noIn) {
  var prec = this.type.binop;

  if (prec != null && (!noIn || this.type !== types._in)) {
    if (prec > minPrec) {
      var logical = this.type === types.logicalOR || this.type === types.logicalAND;
      var op = this.value;
      this.next();
      var startPos = this.start,
          startLoc = this.startLoc;
      var right = this.parseExprOp(this.parseMaybeUnary(null, false), startPos, startLoc, prec, noIn);
      var node = this.buildBinary(leftStartPos, leftStartLoc, left, right, op, logical);
      return this.parseExprOp(node, leftStartPos, leftStartLoc, minPrec, noIn);
    }
  }

  return left;
};

pp$3.buildBinary = function (startPos, startLoc, left, right, op, logical) {
  var node = this.startNodeAt(startPos, startLoc);
  node.left = left;
  node.operator = op;
  node.right = right;
  return this.finishNode(node, logical ? "LogicalExpression" : "BinaryExpression");
}; // Parse unary operators, both prefix and postfix.


pp$3.parseMaybeUnary = function (refDestructuringErrors, sawUnary) {
  var this$1 = this;
  var startPos = this.start,
      startLoc = this.startLoc,
      expr;

  if (this.isContextual("await") && (this.inAsync || !this.inFunction && this.options.allowAwaitOutsideFunction)) {
    expr = this.parseAwait();
    sawUnary = true;
  } else if (this.type.prefix) {
    var node = this.startNode(),
        update = this.type === types.incDec;
    node.operator = this.value;
    node.prefix = true;
    this.next();
    node.argument = this.parseMaybeUnary(null, true);
    this.checkExpressionErrors(refDestructuringErrors, true);

    if (update) {
      this.checkLVal(node.argument);
    } else if (this.strict && node.operator === "delete" && node.argument.type === "Identifier") {
      this.raiseRecoverable(node.start, "Deleting local variable in strict mode");
    } else {
      sawUnary = true;
    }

    expr = this.finishNode(node, update ? "UpdateExpression" : "UnaryExpression");
  } else {
    expr = this.parseExprSubscripts(refDestructuringErrors);

    if (this.checkExpressionErrors(refDestructuringErrors)) {
      return expr;
    }

    while (this.type.postfix && !this.canInsertSemicolon()) {
      var node$1 = this$1.startNodeAt(startPos, startLoc);
      node$1.operator = this$1.value;
      node$1.prefix = false;
      node$1.argument = expr;
      this$1.checkLVal(expr);
      this$1.next();
      expr = this$1.finishNode(node$1, "UpdateExpression");
    }
  }

  if (!sawUnary && this.eat(types.starstar)) {
    return this.buildBinary(startPos, startLoc, expr, this.parseMaybeUnary(null, false), "**", false);
  } else {
    return expr;
  }
}; // Parse call, dot, and `[]`-subscript expressions.


pp$3.parseExprSubscripts = function (refDestructuringErrors) {
  var startPos = this.start,
      startLoc = this.startLoc;
  var expr = this.parseExprAtom(refDestructuringErrors);
  var skipArrowSubscripts = expr.type === "ArrowFunctionExpression" && this.input.slice(this.lastTokStart, this.lastTokEnd) !== ")";

  if (this.checkExpressionErrors(refDestructuringErrors) || skipArrowSubscripts) {
    return expr;
  }

  var result = this.parseSubscripts(expr, startPos, startLoc);

  if (refDestructuringErrors && result.type === "MemberExpression") {
    if (refDestructuringErrors.parenthesizedAssign >= result.start) {
      refDestructuringErrors.parenthesizedAssign = -1;
    }

    if (refDestructuringErrors.parenthesizedBind >= result.start) {
      refDestructuringErrors.parenthesizedBind = -1;
    }
  }

  return result;
};

pp$3.parseSubscripts = function (base, startPos, startLoc, noCalls) {
  var this$1 = this;
  var maybeAsyncArrow = this.options.ecmaVersion >= 8 && base.type === "Identifier" && base.name === "async" && this.lastTokEnd === base.end && !this.canInsertSemicolon() && this.input.slice(base.start, base.end) === "async";

  for (var computed = void 0;;) {
    if ((computed = this$1.eat(types.bracketL)) || this$1.eat(types.dot)) {
      var node = this$1.startNodeAt(startPos, startLoc);
      node.object = base;
      node.property = computed ? this$1.parseExpression() : this$1.parseIdent(true);
      node.computed = !!computed;

      if (computed) {
        this$1.expect(types.bracketR);
      }

      base = this$1.finishNode(node, "MemberExpression");
    } else if (!noCalls && this$1.eat(types.parenL)) {
      var refDestructuringErrors = new DestructuringErrors(),
          oldYieldPos = this$1.yieldPos,
          oldAwaitPos = this$1.awaitPos;
      this$1.yieldPos = 0;
      this$1.awaitPos = 0;
      var exprList = this$1.parseExprList(types.parenR, this$1.options.ecmaVersion >= 8, false, refDestructuringErrors);

      if (maybeAsyncArrow && !this$1.canInsertSemicolon() && this$1.eat(types.arrow)) {
        this$1.checkPatternErrors(refDestructuringErrors, false);
        this$1.checkYieldAwaitInDefaultParams();
        this$1.yieldPos = oldYieldPos;
        this$1.awaitPos = oldAwaitPos;
        return this$1.parseArrowExpression(this$1.startNodeAt(startPos, startLoc), exprList, true);
      }

      this$1.checkExpressionErrors(refDestructuringErrors, true);
      this$1.yieldPos = oldYieldPos || this$1.yieldPos;
      this$1.awaitPos = oldAwaitPos || this$1.awaitPos;
      var node$1 = this$1.startNodeAt(startPos, startLoc);
      node$1.callee = base;
      node$1.arguments = exprList;
      base = this$1.finishNode(node$1, "CallExpression");
    } else if (this$1.type === types.backQuote) {
      var node$2 = this$1.startNodeAt(startPos, startLoc);
      node$2.tag = base;
      node$2.quasi = this$1.parseTemplate({
        isTagged: true
      });
      base = this$1.finishNode(node$2, "TaggedTemplateExpression");
    } else {
      return base;
    }
  }
}; // Parse an atomic expression — either a single token that is an
// expression, an expression started by a keyword like `function` or
// `new`, or an expression wrapped in punctuation like `()`, `[]`,
// or `{}`.


pp$3.parseExprAtom = function (refDestructuringErrors) {
  var node,
      canBeArrow = this.potentialArrowAt === this.start;

  switch (this.type) {
    case types._super:
      if (!this.inFunction) {
        this.raise(this.start, "'super' outside of function or class");
      }

      node = this.startNode();
      this.next(); // The `super` keyword can appear at below:
      // SuperProperty:
      //     super [ Expression ]
      //     super . IdentifierName
      // SuperCall:
      //     super Arguments

      if (this.type !== types.dot && this.type !== types.bracketL && this.type !== types.parenL) {
        this.unexpected();
      }

      return this.finishNode(node, "Super");

    case types._this:
      node = this.startNode();
      this.next();
      return this.finishNode(node, "ThisExpression");

    case types.name:
      var startPos = this.start,
          startLoc = this.startLoc,
          containsEsc = this.containsEsc;
      var id = this.parseIdent(this.type !== types.name);

      if (this.options.ecmaVersion >= 8 && !containsEsc && id.name === "async" && !this.canInsertSemicolon() && this.eat(types._function)) {
        return this.parseFunction(this.startNodeAt(startPos, startLoc), 0, false, true);
      }

      if (canBeArrow && !this.canInsertSemicolon()) {
        if (this.eat(types.arrow)) {
          return this.parseArrowExpression(this.startNodeAt(startPos, startLoc), [id], false);
        }

        if (this.options.ecmaVersion >= 8 && id.name === "async" && this.type === types.name && !containsEsc) {
          id = this.parseIdent();

          if (this.canInsertSemicolon() || !this.eat(types.arrow)) {
            this.unexpected();
          }

          return this.parseArrowExpression(this.startNodeAt(startPos, startLoc), [id], true);
        }
      }

      return id;

    case types.regexp:
      var value = this.value;
      node = this.parseLiteral(value.value);
      node.regex = {
        pattern: value.pattern,
        flags: value.flags
      };
      return node;

    case types.num:
    case types.string:
      return this.parseLiteral(this.value);

    case types._null:
    case types._true:
    case types._false:
      node = this.startNode();
      node.value = this.type === types._null ? null : this.type === types._true;
      node.raw = this.type.keyword;
      this.next();
      return this.finishNode(node, "Literal");

    case types.parenL:
      var start = this.start,
          expr = this.parseParenAndDistinguishExpression(canBeArrow);

      if (refDestructuringErrors) {
        if (refDestructuringErrors.parenthesizedAssign < 0 && !this.isSimpleAssignTarget(expr)) {
          refDestructuringErrors.parenthesizedAssign = start;
        }

        if (refDestructuringErrors.parenthesizedBind < 0) {
          refDestructuringErrors.parenthesizedBind = start;
        }
      }

      return expr;

    case types.bracketL:
      node = this.startNode();
      this.next();
      node.elements = this.parseExprList(types.bracketR, true, true, refDestructuringErrors);
      return this.finishNode(node, "ArrayExpression");

    case types.braceL:
      return this.parseObj(false, refDestructuringErrors);

    case types._function:
      node = this.startNode();
      this.next();
      return this.parseFunction(node, 0);

    case types._class:
      return this.parseClass(this.startNode(), false);

    case types._new:
      return this.parseNew();

    case types.backQuote:
      return this.parseTemplate();

    default:
      this.unexpected();
  }
};

pp$3.parseLiteral = function (value) {
  var node = this.startNode();
  node.value = value;
  node.raw = this.input.slice(this.start, this.end);
  this.next();
  return this.finishNode(node, "Literal");
};

pp$3.parseParenExpression = function () {
  this.expect(types.parenL);
  var val = this.parseExpression();
  this.expect(types.parenR);
  return val;
};

pp$3.parseParenAndDistinguishExpression = function (canBeArrow) {
  var this$1 = this;
  var startPos = this.start,
      startLoc = this.startLoc,
      val,
      allowTrailingComma = this.options.ecmaVersion >= 8;

  if (this.options.ecmaVersion >= 6) {
    this.next();
    var innerStartPos = this.start,
        innerStartLoc = this.startLoc;
    var exprList = [],
        first = true,
        lastIsComma = false;
    var refDestructuringErrors = new DestructuringErrors(),
        oldYieldPos = this.yieldPos,
        oldAwaitPos = this.awaitPos,
        spreadStart;
    this.yieldPos = 0;
    this.awaitPos = 0;

    while (this.type !== types.parenR) {
      first ? first = false : this$1.expect(types.comma);

      if (allowTrailingComma && this$1.afterTrailingComma(types.parenR, true)) {
        lastIsComma = true;
        break;
      } else if (this$1.type === types.ellipsis) {
        spreadStart = this$1.start;
        exprList.push(this$1.parseParenItem(this$1.parseRestBinding()));

        if (this$1.type === types.comma) {
          this$1.raise(this$1.start, "Comma is not permitted after the rest element");
        }

        break;
      } else {
        exprList.push(this$1.parseMaybeAssign(false, refDestructuringErrors, this$1.parseParenItem));
      }
    }

    var innerEndPos = this.start,
        innerEndLoc = this.startLoc;
    this.expect(types.parenR);

    if (canBeArrow && !this.canInsertSemicolon() && this.eat(types.arrow)) {
      this.checkPatternErrors(refDestructuringErrors, false);
      this.checkYieldAwaitInDefaultParams();
      this.yieldPos = oldYieldPos;
      this.awaitPos = oldAwaitPos;
      return this.parseParenArrowList(startPos, startLoc, exprList);
    }

    if (!exprList.length || lastIsComma) {
      this.unexpected(this.lastTokStart);
    }

    if (spreadStart) {
      this.unexpected(spreadStart);
    }

    this.checkExpressionErrors(refDestructuringErrors, true);
    this.yieldPos = oldYieldPos || this.yieldPos;
    this.awaitPos = oldAwaitPos || this.awaitPos;

    if (exprList.length > 1) {
      val = this.startNodeAt(innerStartPos, innerStartLoc);
      val.expressions = exprList;
      this.finishNodeAt(val, "SequenceExpression", innerEndPos, innerEndLoc);
    } else {
      val = exprList[0];
    }
  } else {
    val = this.parseParenExpression();
  }

  if (this.options.preserveParens) {
    var par = this.startNodeAt(startPos, startLoc);
    par.expression = val;
    return this.finishNode(par, "ParenthesizedExpression");
  } else {
    return val;
  }
};

pp$3.parseParenItem = function (item) {
  return item;
};

pp$3.parseParenArrowList = function (startPos, startLoc, exprList) {
  return this.parseArrowExpression(this.startNodeAt(startPos, startLoc), exprList);
}; // New's precedence is slightly tricky. It must allow its argument to
// be a `[]` or dot subscript expression, but not a call — at least,
// not without wrapping it in parentheses. Thus, it uses the noCalls
// argument to parseSubscripts to prevent it from consuming the
// argument list.


var empty$1 = [];

pp$3.parseNew = function () {
  var node = this.startNode();
  var meta = this.parseIdent(true);

  if (this.options.ecmaVersion >= 6 && this.eat(types.dot)) {
    node.meta = meta;
    var containsEsc = this.containsEsc;
    node.property = this.parseIdent(true);

    if (node.property.name !== "target" || containsEsc) {
      this.raiseRecoverable(node.property.start, "The only valid meta property for new is new.target");
    }

    if (!this.inNonArrowFunction()) {
      this.raiseRecoverable(node.start, "new.target can only be used in functions");
    }

    return this.finishNode(node, "MetaProperty");
  }

  var startPos = this.start,
      startLoc = this.startLoc;
  node.callee = this.parseSubscripts(this.parseExprAtom(), startPos, startLoc, true);

  if (this.eat(types.parenL)) {
    node.arguments = this.parseExprList(types.parenR, this.options.ecmaVersion >= 8, false);
  } else {
    node.arguments = empty$1;
  }

  return this.finishNode(node, "NewExpression");
}; // Parse template expression.


pp$3.parseTemplateElement = function (ref) {
  var isTagged = ref.isTagged;
  var elem = this.startNode();

  if (this.type === types.invalidTemplate) {
    if (!isTagged) {
      this.raiseRecoverable(this.start, "Bad escape sequence in untagged template literal");
    }

    elem.value = {
      raw: this.value,
      cooked: null
    };
  } else {
    elem.value = {
      raw: this.input.slice(this.start, this.end).replace(/\r\n?/g, "\n"),
      cooked: this.value
    };
  }

  this.next();
  elem.tail = this.type === types.backQuote;
  return this.finishNode(elem, "TemplateElement");
};

pp$3.parseTemplate = function (ref) {
  var this$1 = this;
  if (ref === void 0) ref = {};
  var isTagged = ref.isTagged;
  if (isTagged === void 0) isTagged = false;
  var node = this.startNode();
  this.next();
  node.expressions = [];
  var curElt = this.parseTemplateElement({
    isTagged: isTagged
  });
  node.quasis = [curElt];

  while (!curElt.tail) {
    if (this$1.type === types.eof) {
      this$1.raise(this$1.pos, "Unterminated template literal");
    }

    this$1.expect(types.dollarBraceL);
    node.expressions.push(this$1.parseExpression());
    this$1.expect(types.braceR);
    node.quasis.push(curElt = this$1.parseTemplateElement({
      isTagged: isTagged
    }));
  }

  this.next();
  return this.finishNode(node, "TemplateLiteral");
};

pp$3.isAsyncProp = function (prop) {
  return !prop.computed && prop.key.type === "Identifier" && prop.key.name === "async" && (this.type === types.name || this.type === types.num || this.type === types.string || this.type === types.bracketL || this.type.keyword || this.options.ecmaVersion >= 9 && this.type === types.star) && !lineBreak.test(this.input.slice(this.lastTokEnd, this.start));
}; // Parse an object literal or binding pattern.


pp$3.parseObj = function (isPattern, refDestructuringErrors) {
  var this$1 = this;
  var node = this.startNode(),
      first = true,
      propHash = {};
  node.properties = [];
  this.next();

  while (!this.eat(types.braceR)) {
    if (!first) {
      this$1.expect(types.comma);

      if (this$1.afterTrailingComma(types.braceR)) {
        break;
      }
    } else {
      first = false;
    }

    var prop = this$1.parseProperty(isPattern, refDestructuringErrors);

    if (!isPattern) {
      this$1.checkPropClash(prop, propHash, refDestructuringErrors);
    }

    node.properties.push(prop);
  }

  return this.finishNode(node, isPattern ? "ObjectPattern" : "ObjectExpression");
};

pp$3.parseProperty = function (isPattern, refDestructuringErrors) {
  var prop = this.startNode(),
      isGenerator,
      isAsync,
      startPos,
      startLoc;

  if (this.options.ecmaVersion >= 9 && this.eat(types.ellipsis)) {
    if (isPattern) {
      prop.argument = this.parseIdent(false);

      if (this.type === types.comma) {
        this.raise(this.start, "Comma is not permitted after the rest element");
      }

      return this.finishNode(prop, "RestElement");
    } // To disallow parenthesized identifier via `this.toAssignable()`.


    if (this.type === types.parenL && refDestructuringErrors) {
      if (refDestructuringErrors.parenthesizedAssign < 0) {
        refDestructuringErrors.parenthesizedAssign = this.start;
      }

      if (refDestructuringErrors.parenthesizedBind < 0) {
        refDestructuringErrors.parenthesizedBind = this.start;
      }
    } // Parse argument.


    prop.argument = this.parseMaybeAssign(false, refDestructuringErrors); // To disallow trailing comma via `this.toAssignable()`.

    if (this.type === types.comma && refDestructuringErrors && refDestructuringErrors.trailingComma < 0) {
      refDestructuringErrors.trailingComma = this.start;
    } // Finish


    return this.finishNode(prop, "SpreadElement");
  }

  if (this.options.ecmaVersion >= 6) {
    prop.method = false;
    prop.shorthand = false;

    if (isPattern || refDestructuringErrors) {
      startPos = this.start;
      startLoc = this.startLoc;
    }

    if (!isPattern) {
      isGenerator = this.eat(types.star);
    }
  }

  var containsEsc = this.containsEsc;
  this.parsePropertyName(prop);

  if (!isPattern && !containsEsc && this.options.ecmaVersion >= 8 && !isGenerator && this.isAsyncProp(prop)) {
    isAsync = true;
    isGenerator = this.options.ecmaVersion >= 9 && this.eat(types.star);
    this.parsePropertyName(prop, refDestructuringErrors);
  } else {
    isAsync = false;
  }

  this.parsePropertyValue(prop, isPattern, isGenerator, isAsync, startPos, startLoc, refDestructuringErrors, containsEsc);
  return this.finishNode(prop, "Property");
};

pp$3.parsePropertyValue = function (prop, isPattern, isGenerator, isAsync, startPos, startLoc, refDestructuringErrors, containsEsc) {
  if ((isGenerator || isAsync) && this.type === types.colon) {
    this.unexpected();
  }

  if (this.eat(types.colon)) {
    prop.value = isPattern ? this.parseMaybeDefault(this.start, this.startLoc) : this.parseMaybeAssign(false, refDestructuringErrors);
    prop.kind = "init";
  } else if (this.options.ecmaVersion >= 6 && this.type === types.parenL) {
    if (isPattern) {
      this.unexpected();
    }

    prop.kind = "init";
    prop.method = true;
    prop.value = this.parseMethod(isGenerator, isAsync);
  } else if (!isPattern && !containsEsc && this.options.ecmaVersion >= 5 && !prop.computed && prop.key.type === "Identifier" && (prop.key.name === "get" || prop.key.name === "set") && this.type !== types.comma && this.type !== types.braceR) {
    if (isGenerator || isAsync) {
      this.unexpected();
    }

    prop.kind = prop.key.name;
    this.parsePropertyName(prop);
    prop.value = this.parseMethod(false);
    var paramCount = prop.kind === "get" ? 0 : 1;

    if (prop.value.params.length !== paramCount) {
      var start = prop.value.start;

      if (prop.kind === "get") {
        this.raiseRecoverable(start, "getter should have no params");
      } else {
        this.raiseRecoverable(start, "setter should have exactly one param");
      }
    } else {
      if (prop.kind === "set" && prop.value.params[0].type === "RestElement") {
        this.raiseRecoverable(prop.value.params[0].start, "Setter cannot use rest params");
      }
    }
  } else if (this.options.ecmaVersion >= 6 && !prop.computed && prop.key.type === "Identifier") {
    this.checkUnreserved(prop.key);
    prop.kind = "init";

    if (isPattern) {
      prop.value = this.parseMaybeDefault(startPos, startLoc, prop.key);
    } else if (this.type === types.eq && refDestructuringErrors) {
      if (refDestructuringErrors.shorthandAssign < 0) {
        refDestructuringErrors.shorthandAssign = this.start;
      }

      prop.value = this.parseMaybeDefault(startPos, startLoc, prop.key);
    } else {
      prop.value = prop.key;
    }

    prop.shorthand = true;
  } else {
    this.unexpected();
  }
};

pp$3.parsePropertyName = function (prop) {
  if (this.options.ecmaVersion >= 6) {
    if (this.eat(types.bracketL)) {
      prop.computed = true;
      prop.key = this.parseMaybeAssign();
      this.expect(types.bracketR);
      return prop.key;
    } else {
      prop.computed = false;
    }
  }

  return prop.key = this.type === types.num || this.type === types.string ? this.parseExprAtom() : this.parseIdent(true);
}; // Initialize empty function node.


pp$3.initFunction = function (node) {
  node.id = null;

  if (this.options.ecmaVersion >= 6) {
    node.generator = node.expression = false;
  }

  if (this.options.ecmaVersion >= 8) {
    node.async = false;
  }
}; // Parse object or class method.


pp$3.parseMethod = function (isGenerator, isAsync) {
  var node = this.startNode(),
      oldYieldPos = this.yieldPos,
      oldAwaitPos = this.awaitPos;
  this.initFunction(node);

  if (this.options.ecmaVersion >= 6) {
    node.generator = isGenerator;
  }

  if (this.options.ecmaVersion >= 8) {
    node.async = !!isAsync;
  }

  this.yieldPos = 0;
  this.awaitPos = 0;
  this.enterScope(functionFlags(isAsync, node.generator));
  this.expect(types.parenL);
  node.params = this.parseBindingList(types.parenR, false, this.options.ecmaVersion >= 8);
  this.checkYieldAwaitInDefaultParams();
  this.parseFunctionBody(node, false);
  this.yieldPos = oldYieldPos;
  this.awaitPos = oldAwaitPos;
  return this.finishNode(node, "FunctionExpression");
}; // Parse arrow function expression with given parameters.


pp$3.parseArrowExpression = function (node, params, isAsync) {
  var oldYieldPos = this.yieldPos,
      oldAwaitPos = this.awaitPos;
  this.enterScope(functionFlags(isAsync, false) | SCOPE_ARROW);
  this.initFunction(node);

  if (this.options.ecmaVersion >= 8) {
    node.async = !!isAsync;
  }

  this.yieldPos = 0;
  this.awaitPos = 0;
  node.params = this.toAssignableList(params, true);
  this.parseFunctionBody(node, true);
  this.yieldPos = oldYieldPos;
  this.awaitPos = oldAwaitPos;
  return this.finishNode(node, "ArrowFunctionExpression");
}; // Parse function body and check parameters.


pp$3.parseFunctionBody = function (node, isArrowFunction) {
  var isExpression = isArrowFunction && this.type !== types.braceL;
  var oldStrict = this.strict,
      useStrict = false;

  if (isExpression) {
    node.body = this.parseMaybeAssign();
    node.expression = true;
    this.checkParams(node, false);
  } else {
    var nonSimple = this.options.ecmaVersion >= 7 && !this.isSimpleParamList(node.params);

    if (!oldStrict || nonSimple) {
      useStrict = this.strictDirective(this.end); // If this is a strict mode function, verify that argument names
      // are not repeated, and it does not try to bind the words `eval`
      // or `arguments`.

      if (useStrict && nonSimple) {
        this.raiseRecoverable(node.start, "Illegal 'use strict' directive in function with non-simple parameter list");
      }
    } // Start a new scope with regard to labels and the `inFunction`
    // flag (restore them to their old value afterwards).


    var oldLabels = this.labels;
    this.labels = [];

    if (useStrict) {
      this.strict = true;
    } // Add the params to varDeclaredNames to ensure that an error is thrown
    // if a let/const declaration in the function clashes with one of the params.


    this.checkParams(node, !oldStrict && !useStrict && !isArrowFunction && this.isSimpleParamList(node.params));
    node.body = this.parseBlock(false);
    node.expression = false;
    this.adaptDirectivePrologue(node.body.body);
    this.labels = oldLabels;
  }

  this.exitScope(); // Ensure the function name isn't a forbidden identifier in strict mode, e.g. 'eval'

  if (this.strict && node.id) {
    this.checkLVal(node.id, BIND_OUTSIDE);
  }

  this.strict = oldStrict;
};

pp$3.isSimpleParamList = function (params) {
  for (var i = 0, list = params; i < list.length; i += 1) {
    var param = list[i];

    if (param.type !== "Identifier") {
      return false;
    }
  }

  return true;
}; // Checks function params for various disallowed patterns such as using "eval"
// or "arguments" and duplicate parameters.


pp$3.checkParams = function (node, allowDuplicates) {
  var this$1 = this;
  var nameHash = {};

  for (var i = 0, list = node.params; i < list.length; i += 1) {
    var param = list[i];
    this$1.checkLVal(param, BIND_VAR, allowDuplicates ? null : nameHash);
  }
}; // Parses a comma-separated list of expressions, and returns them as
// an array. `close` is the token type that ends the list, and
// `allowEmpty` can be turned on to allow subsequent commas with
// nothing in between them to be parsed as `null` (which is needed
// for array literals).


pp$3.parseExprList = function (close, allowTrailingComma, allowEmpty, refDestructuringErrors) {
  var this$1 = this;
  var elts = [],
      first = true;

  while (!this.eat(close)) {
    if (!first) {
      this$1.expect(types.comma);

      if (allowTrailingComma && this$1.afterTrailingComma(close)) {
        break;
      }
    } else {
      first = false;
    }

    var elt = void 0;

    if (allowEmpty && this$1.type === types.comma) {
      elt = null;
    } else if (this$1.type === types.ellipsis) {
      elt = this$1.parseSpread(refDestructuringErrors);

      if (refDestructuringErrors && this$1.type === types.comma && refDestructuringErrors.trailingComma < 0) {
        refDestructuringErrors.trailingComma = this$1.start;
      }
    } else {
      elt = this$1.parseMaybeAssign(false, refDestructuringErrors);
    }

    elts.push(elt);
  }

  return elts;
};

pp$3.checkUnreserved = function (ref) {
  var start = ref.start;
  var end = ref.end;
  var name = ref.name;

  if (this.inGenerator && name === "yield") {
    this.raiseRecoverable(start, "Can not use 'yield' as identifier inside a generator");
  }

  if (this.inAsync && name === "await") {
    this.raiseRecoverable(start, "Can not use 'await' as identifier inside an async function");
  }

  if (this.keywords.test(name)) {
    this.raise(start, "Unexpected keyword '" + name + "'");
  }

  if (this.options.ecmaVersion < 6 && this.input.slice(start, end).indexOf("\\") !== -1) {
    return;
  }

  var re = this.strict ? this.reservedWordsStrict : this.reservedWords;

  if (re.test(name)) {
    if (!this.inAsync && name === "await") {
      this.raiseRecoverable(start, "Can not use keyword 'await' outside an async function");
    }

    this.raiseRecoverable(start, "The keyword '" + name + "' is reserved");
  }
}; // Parse the next token as an identifier. If `liberal` is true (used
// when parsing properties), it will also convert keywords into
// identifiers.


pp$3.parseIdent = function (liberal, isBinding) {
  var node = this.startNode();

  if (liberal && this.options.allowReserved === "never") {
    liberal = false;
  }

  if (this.type === types.name) {
    node.name = this.value;
  } else if (this.type.keyword) {
    node.name = this.type.keyword; // To fix https://github.com/acornjs/acorn/issues/575
    // `class` and `function` keywords push new context into this.context.
    // But there is no chance to pop the context if the keyword is consumed as an identifier such as a property name.
    // If the previous token is a dot, this does not apply because the context-managing code already ignored the keyword

    if ((node.name === "class" || node.name === "function") && (this.lastTokEnd !== this.lastTokStart + 1 || this.input.charCodeAt(this.lastTokStart) !== 46)) {
      this.context.pop();
    }
  } else {
    this.unexpected();
  }

  this.next();
  this.finishNode(node, "Identifier");

  if (!liberal) {
    this.checkUnreserved(node);
  }

  return node;
}; // Parses yield expression inside generator.


pp$3.parseYield = function () {
  if (!this.yieldPos) {
    this.yieldPos = this.start;
  }

  var node = this.startNode();
  this.next();

  if (this.type === types.semi || this.canInsertSemicolon() || this.type !== types.star && !this.type.startsExpr) {
    node.delegate = false;
    node.argument = null;
  } else {
    node.delegate = this.eat(types.star);
    node.argument = this.parseMaybeAssign();
  }

  return this.finishNode(node, "YieldExpression");
};

pp$3.parseAwait = function () {
  if (!this.awaitPos) {
    this.awaitPos = this.start;
  }

  var node = this.startNode();
  this.next();
  node.argument = this.parseMaybeUnary(null, true);
  return this.finishNode(node, "AwaitExpression");
};

var pp$4 = Parser.prototype; // This function is used to raise exceptions on parse errors. It
// takes an offset integer (into the current `input`) to indicate
// the location of the error, attaches the position to the end
// of the error message, and then raises a `SyntaxError` with that
// message.

pp$4.raise = function (pos, message) {
  var loc = getLineInfo(this.input, pos);
  message += " (" + loc.line + ":" + loc.column + ")";
  var err = new SyntaxError(message);
  err.pos = pos;
  err.loc = loc;
  err.raisedAt = this.pos;
  throw err;
};

pp$4.raiseRecoverable = pp$4.raise;

pp$4.curPosition = function () {
  if (this.options.locations) {
    return new Position(this.curLine, this.pos - this.lineStart);
  }
};

var pp$5 = Parser.prototype;

var Scope = function Scope(flags) {
  this.flags = flags; // A list of var-declared names in the current lexical scope

  this["var"] = []; // A list of lexically-declared names in the current lexical scope

  this.lexical = [];
}; // The functions in this module keep track of declared variables in the current scope in order to detect duplicate variable names.


pp$5.enterScope = function (flags) {
  this.scopeStack.push(new Scope(flags));
};

pp$5.exitScope = function () {
  this.scopeStack.pop();
};

pp$5.declareName = function (name, bindingType, pos) {
  var this$1 = this;
  var redeclared = false;

  if (bindingType === BIND_LEXICAL) {
    var scope = this.currentScope();
    redeclared = scope.lexical.indexOf(name) > -1 || scope["var"].indexOf(name) > -1;
    scope.lexical.push(name);
  } else if (bindingType === BIND_SIMPLE_CATCH) {
    var scope$1 = this.currentScope();
    scope$1.lexical.push(name);
  } else if (bindingType === BIND_FUNCTION) {
    var scope$2 = this.currentScope();
    redeclared = scope$2.lexical.indexOf(name) > -1;
    scope$2["var"].push(name);
  } else {
    for (var i = this.scopeStack.length - 1; i >= 0; --i) {
      var scope$3 = this$1.scopeStack[i];

      if (scope$3.lexical.indexOf(name) > -1 && !(scope$3.flags & SCOPE_SIMPLE_CATCH) && scope$3.lexical[0] === name) {
        redeclared = true;
      }

      scope$3["var"].push(name);

      if (scope$3.flags & SCOPE_VAR) {
        break;
      }
    }
  }

  if (redeclared) {
    this.raiseRecoverable(pos, "Identifier '" + name + "' has already been declared");
  }
};

pp$5.currentScope = function () {
  return this.scopeStack[this.scopeStack.length - 1];
};

pp$5.currentVarScope = function () {
  var this$1 = this;

  for (var i = this.scopeStack.length - 1;; i--) {
    var scope = this$1.scopeStack[i];

    if (scope.flags & SCOPE_VAR) {
      return scope;
    }
  }
};

pp$5.inNonArrowFunction = function () {
  var this$1 = this;

  for (var i = this.scopeStack.length - 1; i >= 0; i--) {
    if (this$1.scopeStack[i].flags & SCOPE_FUNCTION && !(this$1.scopeStack[i].flags & SCOPE_ARROW)) {
      return true;
    }
  }

  return false;
};

var Node = function Node(parser, pos, loc) {
  this.type = "";
  this.start = pos;
  this.end = 0;

  if (parser.options.locations) {
    this.loc = new SourceLocation(parser, loc);
  }

  if (parser.options.directSourceFile) {
    this.sourceFile = parser.options.directSourceFile;
  }

  if (parser.options.ranges) {
    this.range = [pos, 0];
  }
}; // Start an AST node, attaching a start offset.


var pp$6 = Parser.prototype;

pp$6.startNode = function () {
  return new Node(this, this.start, this.startLoc);
};

pp$6.startNodeAt = function (pos, loc) {
  return new Node(this, pos, loc);
}; // Finish an AST node, adding `type` and `end` properties.


function finishNodeAt(node, type, pos, loc) {
  node.type = type;
  node.end = pos;

  if (this.options.locations) {
    node.loc.end = loc;
  }

  if (this.options.ranges) {
    node.range[1] = pos;
  }

  return node;
}

pp$6.finishNode = function (node, type) {
  return finishNodeAt.call(this, node, type, this.lastTokEnd, this.lastTokEndLoc);
}; // Finish node at given position


pp$6.finishNodeAt = function (node, type, pos, loc) {
  return finishNodeAt.call(this, node, type, pos, loc);
}; // The algorithm used to determine whether a regexp can appear at a
// given point in the program is loosely based on sweet.js' approach.
// See https://github.com/mozilla/sweet.js/wiki/design


var TokContext = function TokContext(token, isExpr, preserveSpace, override, generator) {
  this.token = token;
  this.isExpr = !!isExpr;
  this.preserveSpace = !!preserveSpace;
  this.override = override;
  this.generator = !!generator;
};

var types$1 = {
  b_stat: new TokContext("{", false),
  b_expr: new TokContext("{", true),
  b_tmpl: new TokContext("${", false),
  p_stat: new TokContext("(", false),
  p_expr: new TokContext("(", true),
  q_tmpl: new TokContext("`", true, true, function (p) {
    return p.tryReadTemplateToken();
  }),
  f_stat: new TokContext("function", false),
  f_expr: new TokContext("function", true),
  f_expr_gen: new TokContext("function", true, false, null, true),
  f_gen: new TokContext("function", false, false, null, true)
};
var pp$7 = Parser.prototype;

pp$7.initialContext = function () {
  return [types$1.b_stat];
};

pp$7.braceIsBlock = function (prevType) {
  var parent = this.curContext();

  if (parent === types$1.f_expr || parent === types$1.f_stat) {
    return true;
  }

  if (prevType === types.colon && (parent === types$1.b_stat || parent === types$1.b_expr)) {
    return !parent.isExpr;
  } // The check for `tt.name && exprAllowed` detects whether we are
  // after a `yield` or `of` construct. See the `updateContext` for
  // `tt.name`.


  if (prevType === types._return || prevType === types.name && this.exprAllowed) {
    return lineBreak.test(this.input.slice(this.lastTokEnd, this.start));
  }

  if (prevType === types._else || prevType === types.semi || prevType === types.eof || prevType === types.parenR || prevType === types.arrow) {
    return true;
  }

  if (prevType === types.braceL) {
    return parent === types$1.b_stat;
  }

  if (prevType === types._var || prevType === types.name) {
    return false;
  }

  return !this.exprAllowed;
};

pp$7.inGeneratorContext = function () {
  var this$1 = this;

  for (var i = this.context.length - 1; i >= 1; i--) {
    var context = this$1.context[i];

    if (context.token === "function") {
      return context.generator;
    }
  }

  return false;
};

pp$7.updateContext = function (prevType) {
  var update,
      type = this.type;

  if (type.keyword && prevType === types.dot) {
    this.exprAllowed = false;
  } else if (update = type.updateContext) {
    update.call(this, prevType);
  } else {
    this.exprAllowed = type.beforeExpr;
  }
}; // Token-specific context update code


types.parenR.updateContext = types.braceR.updateContext = function () {
  if (this.context.length === 1) {
    this.exprAllowed = true;
    return;
  }

  var out = this.context.pop();

  if (out === types$1.b_stat && this.curContext().token === "function") {
    out = this.context.pop();
  }

  this.exprAllowed = !out.isExpr;
};

types.braceL.updateContext = function (prevType) {
  this.context.push(this.braceIsBlock(prevType) ? types$1.b_stat : types$1.b_expr);
  this.exprAllowed = true;
};

types.dollarBraceL.updateContext = function () {
  this.context.push(types$1.b_tmpl);
  this.exprAllowed = true;
};

types.parenL.updateContext = function (prevType) {
  var statementParens = prevType === types._if || prevType === types._for || prevType === types._with || prevType === types._while;
  this.context.push(statementParens ? types$1.p_stat : types$1.p_expr);
  this.exprAllowed = true;
};

types.incDec.updateContext = function () {// tokExprAllowed stays unchanged
};

types._function.updateContext = types._class.updateContext = function (prevType) {
  if (prevType.beforeExpr && prevType !== types.semi && prevType !== types._else && !((prevType === types.colon || prevType === types.braceL) && this.curContext() === types$1.b_stat)) {
    this.context.push(types$1.f_expr);
  } else {
    this.context.push(types$1.f_stat);
  }

  this.exprAllowed = false;
};

types.backQuote.updateContext = function () {
  if (this.curContext() === types$1.q_tmpl) {
    this.context.pop();
  } else {
    this.context.push(types$1.q_tmpl);
  }

  this.exprAllowed = false;
};

types.star.updateContext = function (prevType) {
  if (prevType === types._function) {
    var index = this.context.length - 1;

    if (this.context[index] === types$1.f_expr) {
      this.context[index] = types$1.f_expr_gen;
    } else {
      this.context[index] = types$1.f_gen;
    }
  }

  this.exprAllowed = true;
};

types.name.updateContext = function (prevType) {
  var allowed = false;

  if (this.options.ecmaVersion >= 6 && prevType !== types.dot) {
    if (this.value === "of" && !this.exprAllowed || this.value === "yield" && this.inGeneratorContext()) {
      allowed = true;
    }
  }

  this.exprAllowed = allowed;
};

var data = {
  "$LONE": ["ASCII", "ASCII_Hex_Digit", "AHex", "Alphabetic", "Alpha", "Any", "Assigned", "Bidi_Control", "Bidi_C", "Bidi_Mirrored", "Bidi_M", "Case_Ignorable", "CI", "Cased", "Changes_When_Casefolded", "CWCF", "Changes_When_Casemapped", "CWCM", "Changes_When_Lowercased", "CWL", "Changes_When_NFKC_Casefolded", "CWKCF", "Changes_When_Titlecased", "CWT", "Changes_When_Uppercased", "CWU", "Dash", "Default_Ignorable_Code_Point", "DI", "Deprecated", "Dep", "Diacritic", "Dia", "Emoji", "Emoji_Component", "Emoji_Modifier", "Emoji_Modifier_Base", "Emoji_Presentation", "Extender", "Ext", "Grapheme_Base", "Gr_Base", "Grapheme_Extend", "Gr_Ext", "Hex_Digit", "Hex", "IDS_Binary_Operator", "IDSB", "IDS_Trinary_Operator", "IDST", "ID_Continue", "IDC", "ID_Start", "IDS", "Ideographic", "Ideo", "Join_Control", "Join_C", "Logical_Order_Exception", "LOE", "Lowercase", "Lower", "Math", "Noncharacter_Code_Point", "NChar", "Pattern_Syntax", "Pat_Syn", "Pattern_White_Space", "Pat_WS", "Quotation_Mark", "QMark", "Radical", "Regional_Indicator", "RI", "Sentence_Terminal", "STerm", "Soft_Dotted", "SD", "Terminal_Punctuation", "Term", "Unified_Ideograph", "UIdeo", "Uppercase", "Upper", "Variation_Selector", "VS", "White_Space", "space", "XID_Continue", "XIDC", "XID_Start", "XIDS"],
  "General_Category": ["Cased_Letter", "LC", "Close_Punctuation", "Pe", "Connector_Punctuation", "Pc", "Control", "Cc", "cntrl", "Currency_Symbol", "Sc", "Dash_Punctuation", "Pd", "Decimal_Number", "Nd", "digit", "Enclosing_Mark", "Me", "Final_Punctuation", "Pf", "Format", "Cf", "Initial_Punctuation", "Pi", "Letter", "L", "Letter_Number", "Nl", "Line_Separator", "Zl", "Lowercase_Letter", "Ll", "Mark", "M", "Combining_Mark", "Math_Symbol", "Sm", "Modifier_Letter", "Lm", "Modifier_Symbol", "Sk", "Nonspacing_Mark", "Mn", "Number", "N", "Open_Punctuation", "Ps", "Other", "C", "Other_Letter", "Lo", "Other_Number", "No", "Other_Punctuation", "Po", "Other_Symbol", "So", "Paragraph_Separator", "Zp", "Private_Use", "Co", "Punctuation", "P", "punct", "Separator", "Z", "Space_Separator", "Zs", "Spacing_Mark", "Mc", "Surrogate", "Cs", "Symbol", "S", "Titlecase_Letter", "Lt", "Unassigned", "Cn", "Uppercase_Letter", "Lu"],
  "Script": ["Adlam", "Adlm", "Ahom", "Anatolian_Hieroglyphs", "Hluw", "Arabic", "Arab", "Armenian", "Armn", "Avestan", "Avst", "Balinese", "Bali", "Bamum", "Bamu", "Bassa_Vah", "Bass", "Batak", "Batk", "Bengali", "Beng", "Bhaiksuki", "Bhks", "Bopomofo", "Bopo", "Brahmi", "Brah", "Braille", "Brai", "Buginese", "Bugi", "Buhid", "Buhd", "Canadian_Aboriginal", "Cans", "Carian", "Cari", "Caucasian_Albanian", "Aghb", "Chakma", "Cakm", "Cham", "Cherokee", "Cher", "Common", "Zyyy", "Coptic", "Copt", "Qaac", "Cuneiform", "Xsux", "Cypriot", "Cprt", "Cyrillic", "Cyrl", "Deseret", "Dsrt", "Devanagari", "Deva", "Duployan", "Dupl", "Egyptian_Hieroglyphs", "Egyp", "Elbasan", "Elba", "Ethiopic", "Ethi", "Georgian", "Geor", "Glagolitic", "Glag", "Gothic", "Goth", "Grantha", "Gran", "Greek", "Grek", "Gujarati", "Gujr", "Gurmukhi", "Guru", "Han", "Hani", "Hangul", "Hang", "Hanunoo", "Hano", "Hatran", "Hatr", "Hebrew", "Hebr", "Hiragana", "Hira", "Imperial_Aramaic", "Armi", "Inherited", "Zinh", "Qaai", "Inscriptional_Pahlavi", "Phli", "Inscriptional_Parthian", "Prti", "Javanese", "Java", "Kaithi", "Kthi", "Kannada", "Knda", "Katakana", "Kana", "Kayah_Li", "Kali", "Kharoshthi", "Khar", "Khmer", "Khmr", "Khojki", "Khoj", "Khudawadi", "Sind", "Lao", "Laoo", "Latin", "Latn", "Lepcha", "Lepc", "Limbu", "Limb", "Linear_A", "Lina", "Linear_B", "Linb", "Lisu", "Lycian", "Lyci", "Lydian", "Lydi", "Mahajani", "Mahj", "Malayalam", "Mlym", "Mandaic", "Mand", "Manichaean", "Mani", "Marchen", "Marc", "Masaram_Gondi", "Gonm", "Meetei_Mayek", "Mtei", "Mende_Kikakui", "Mend", "Meroitic_Cursive", "Merc", "Meroitic_Hieroglyphs", "Mero", "Miao", "Plrd", "Modi", "Mongolian", "Mong", "Mro", "Mroo", "Multani", "Mult", "Myanmar", "Mymr", "Nabataean", "Nbat", "New_Tai_Lue", "Talu", "Newa", "Nko", "Nkoo", "Nushu", "Nshu", "Ogham", "Ogam", "Ol_Chiki", "Olck", "Old_Hungarian", "Hung", "Old_Italic", "Ital", "Old_North_Arabian", "Narb", "Old_Permic", "Perm", "Old_Persian", "Xpeo", "Old_South_Arabian", "Sarb", "Old_Turkic", "Orkh", "Oriya", "Orya", "Osage", "Osge", "Osmanya", "Osma", "Pahawh_Hmong", "Hmng", "Palmyrene", "Palm", "Pau_Cin_Hau", "Pauc", "Phags_Pa", "Phag", "Phoenician", "Phnx", "Psalter_Pahlavi", "Phlp", "Rejang", "Rjng", "Runic", "Runr", "Samaritan", "Samr", "Saurashtra", "Saur", "Sharada", "Shrd", "Shavian", "Shaw", "Siddham", "Sidd", "SignWriting", "Sgnw", "Sinhala", "Sinh", "Sora_Sompeng", "Sora", "Soyombo", "Soyo", "Sundanese", "Sund", "Syloti_Nagri", "Sylo", "Syriac", "Syrc", "Tagalog", "Tglg", "Tagbanwa", "Tagb", "Tai_Le", "Tale", "Tai_Tham", "Lana", "Tai_Viet", "Tavt", "Takri", "Takr", "Tamil", "Taml", "Tangut", "Tang", "Telugu", "Telu", "Thaana", "Thaa", "Thai", "Tibetan", "Tibt", "Tifinagh", "Tfng", "Tirhuta", "Tirh", "Ugaritic", "Ugar", "Vai", "Vaii", "Warang_Citi", "Wara", "Yi", "Yiii", "Zanabazar_Square", "Zanb"]
};
Array.prototype.push.apply(data.$LONE, data.General_Category);
data.gc = data.General_Category;
data.sc = data.Script_Extensions = data.scx = data.Script;
var pp$9 = Parser.prototype;

var RegExpValidationState = function RegExpValidationState(parser) {
  this.parser = parser;
  this.validFlags = "gim" + (parser.options.ecmaVersion >= 6 ? "uy" : "") + (parser.options.ecmaVersion >= 9 ? "s" : "");
  this.source = "";
  this.flags = "";
  this.start = 0;
  this.switchU = false;
  this.switchN = false;
  this.pos = 0;
  this.lastIntValue = 0;
  this.lastStringValue = "";
  this.lastAssertionIsQuantifiable = false;
  this.numCapturingParens = 0;
  this.maxBackReference = 0;
  this.groupNames = [];
  this.backReferenceNames = [];
};

RegExpValidationState.prototype.reset = function reset(start, pattern, flags) {
  var unicode = flags.indexOf("u") !== -1;
  this.start = start | 0;
  this.source = pattern + "";
  this.flags = flags;
  this.switchU = unicode && this.parser.options.ecmaVersion >= 6;
  this.switchN = unicode && this.parser.options.ecmaVersion >= 9;
};

RegExpValidationState.prototype.raise = function raise(message) {
  this.parser.raiseRecoverable(this.start, "Invalid regular expression: /" + this.source + "/: " + message);
}; // If u flag is given, this returns the code point at the index (it combines a surrogate pair).
// Otherwise, this returns the code unit of the index (can be a part of a surrogate pair).


RegExpValidationState.prototype.at = function at(i) {
  var s = this.source;
  var l = s.length;

  if (i >= l) {
    return -1;
  }

  var c = s.charCodeAt(i);

  if (!this.switchU || c <= 0xD7FF || c >= 0xE000 || i + 1 >= l) {
    return c;
  }

  return (c << 10) + s.charCodeAt(i + 1) - 0x35FDC00;
};

RegExpValidationState.prototype.nextIndex = function nextIndex(i) {
  var s = this.source;
  var l = s.length;

  if (i >= l) {
    return l;
  }

  var c = s.charCodeAt(i);

  if (!this.switchU || c <= 0xD7FF || c >= 0xE000 || i + 1 >= l) {
    return i + 1;
  }

  return i + 2;
};

RegExpValidationState.prototype.current = function current() {
  return this.at(this.pos);
};

RegExpValidationState.prototype.lookahead = function lookahead() {
  return this.at(this.nextIndex(this.pos));
};

RegExpValidationState.prototype.advance = function advance() {
  this.pos = this.nextIndex(this.pos);
};

RegExpValidationState.prototype.eat = function eat(ch) {
  if (this.current() === ch) {
    this.advance();
    return true;
  }

  return false;
};

function codePointToString$1(ch) {
  if (ch <= 0xFFFF) {
    return String.fromCharCode(ch);
  }

  ch -= 0x10000;
  return String.fromCharCode((ch >> 10) + 0xD800, (ch & 0x03FF) + 0xDC00);
}
/**
 * Validate the flags part of a given RegExpLiteral.
 *
 * @param {RegExpValidationState} state The state to validate RegExp.
 * @returns {void}
 */


pp$9.validateRegExpFlags = function (state) {
  var this$1 = this;
  var validFlags = state.validFlags;
  var flags = state.flags;

  for (var i = 0; i < flags.length; i++) {
    var flag = flags.charAt(i);

    if (validFlags.indexOf(flag) === -1) {
      this$1.raise(state.start, "Invalid regular expression flag");
    }

    if (flags.indexOf(flag, i + 1) > -1) {
      this$1.raise(state.start, "Duplicate regular expression flag");
    }
  }
};
/**
 * Validate the pattern part of a given RegExpLiteral.
 *
 * @param {RegExpValidationState} state The state to validate RegExp.
 * @returns {void}
 */


pp$9.validateRegExpPattern = function (state) {
  this.regexp_pattern(state); // The goal symbol for the parse is |Pattern[~U, ~N]|. If the result of
  // parsing contains a |GroupName|, reparse with the goal symbol
  // |Pattern[~U, +N]| and use this result instead. Throw a *SyntaxError*
  // exception if _P_ did not conform to the grammar, if any elements of _P_
  // were not matched by the parse, or if any Early Error conditions exist.

  if (!state.switchN && this.options.ecmaVersion >= 9 && state.groupNames.length > 0) {
    state.switchN = true;
    this.regexp_pattern(state);
  }
}; // https://www.ecma-international.org/ecma-262/8.0/#prod-Pattern


pp$9.regexp_pattern = function (state) {
  state.pos = 0;
  state.lastIntValue = 0;
  state.lastStringValue = "";
  state.lastAssertionIsQuantifiable = false;
  state.numCapturingParens = 0;
  state.maxBackReference = 0;
  state.groupNames.length = 0;
  state.backReferenceNames.length = 0;
  this.regexp_disjunction(state);

  if (state.pos !== state.source.length) {
    // Make the same messages as V8.
    if (state.eat(0x29
    /* ) */
    )) {
      state.raise("Unmatched ')'");
    }

    if (state.eat(0x5D
    /* [ */
    ) || state.eat(0x7D
    /* } */
    )) {
      state.raise("Lone quantifier brackets");
    }
  }

  if (state.maxBackReference > state.numCapturingParens) {
    state.raise("Invalid escape");
  }

  for (var i = 0, list = state.backReferenceNames; i < list.length; i += 1) {
    var name = list[i];

    if (state.groupNames.indexOf(name) === -1) {
      state.raise("Invalid named capture referenced");
    }
  }
}; // https://www.ecma-international.org/ecma-262/8.0/#prod-Disjunction


pp$9.regexp_disjunction = function (state) {
  var this$1 = this;
  this.regexp_alternative(state);

  while (state.eat(0x7C
  /* | */
  )) {
    this$1.regexp_alternative(state);
  } // Make the same message as V8.


  if (this.regexp_eatQuantifier(state, true)) {
    state.raise("Nothing to repeat");
  }

  if (state.eat(0x7B
  /* { */
  )) {
    state.raise("Lone quantifier brackets");
  }
}; // https://www.ecma-international.org/ecma-262/8.0/#prod-Alternative


pp$9.regexp_alternative = function (state) {
  while (state.pos < state.source.length && this.regexp_eatTerm(state)) {}
}; // https://www.ecma-international.org/ecma-262/8.0/#prod-annexB-Term


pp$9.regexp_eatTerm = function (state) {
  if (this.regexp_eatAssertion(state)) {
    // Handle `QuantifiableAssertion Quantifier` alternative.
    // `state.lastAssertionIsQuantifiable` is true if the last eaten Assertion
    // is a QuantifiableAssertion.
    if (state.lastAssertionIsQuantifiable && this.regexp_eatQuantifier(state)) {
      // Make the same message as V8.
      if (state.switchU) {
        state.raise("Invalid quantifier");
      }
    }

    return true;
  }

  if (state.switchU ? this.regexp_eatAtom(state) : this.regexp_eatExtendedAtom(state)) {
    this.regexp_eatQuantifier(state);
    return true;
  }

  return false;
}; // https://www.ecma-international.org/ecma-262/8.0/#prod-annexB-Assertion


pp$9.regexp_eatAssertion = function (state) {
  var start = state.pos;
  state.lastAssertionIsQuantifiable = false; // ^, $

  if (state.eat(0x5E
  /* ^ */
  ) || state.eat(0x24
  /* $ */
  )) {
    return true;
  } // \b \B


  if (state.eat(0x5C
  /* \ */
  )) {
    if (state.eat(0x42
    /* B */
    ) || state.eat(0x62
    /* b */
    )) {
      return true;
    }

    state.pos = start;
  } // Lookahead / Lookbehind


  if (state.eat(0x28
  /* ( */
  ) && state.eat(0x3F
  /* ? */
  )) {
    var lookbehind = false;

    if (this.options.ecmaVersion >= 9) {
      lookbehind = state.eat(0x3C
      /* < */
      );
    }

    if (state.eat(0x3D
    /* = */
    ) || state.eat(0x21
    /* ! */
    )) {
      this.regexp_disjunction(state);

      if (!state.eat(0x29
      /* ) */
      )) {
        state.raise("Unterminated group");
      }

      state.lastAssertionIsQuantifiable = !lookbehind;
      return true;
    }
  }

  state.pos = start;
  return false;
}; // https://www.ecma-international.org/ecma-262/8.0/#prod-Quantifier


pp$9.regexp_eatQuantifier = function (state, noError) {
  if (noError === void 0) noError = false;

  if (this.regexp_eatQuantifierPrefix(state, noError)) {
    state.eat(0x3F
    /* ? */
    );
    return true;
  }

  return false;
}; // https://www.ecma-international.org/ecma-262/8.0/#prod-QuantifierPrefix


pp$9.regexp_eatQuantifierPrefix = function (state, noError) {
  return state.eat(0x2A
  /* * */
  ) || state.eat(0x2B
  /* + */
  ) || state.eat(0x3F
  /* ? */
  ) || this.regexp_eatBracedQuantifier(state, noError);
};

pp$9.regexp_eatBracedQuantifier = function (state, noError) {
  var start = state.pos;

  if (state.eat(0x7B
  /* { */
  )) {
    var min = 0,
        max = -1;

    if (this.regexp_eatDecimalDigits(state)) {
      min = state.lastIntValue;

      if (state.eat(0x2C
      /* , */
      ) && this.regexp_eatDecimalDigits(state)) {
        max = state.lastIntValue;
      }

      if (state.eat(0x7D
      /* } */
      )) {
        // SyntaxError in https://www.ecma-international.org/ecma-262/8.0/#sec-term
        if (max !== -1 && max < min && !noError) {
          state.raise("numbers out of order in {} quantifier");
        }

        return true;
      }
    }

    if (state.switchU && !noError) {
      state.raise("Incomplete quantifier");
    }

    state.pos = start;
  }

  return false;
}; // https://www.ecma-international.org/ecma-262/8.0/#prod-Atom


pp$9.regexp_eatAtom = function (state) {
  return this.regexp_eatPatternCharacters(state) || state.eat(0x2E
  /* . */
  ) || this.regexp_eatReverseSolidusAtomEscape(state) || this.regexp_eatCharacterClass(state) || this.regexp_eatUncapturingGroup(state) || this.regexp_eatCapturingGroup(state);
};

pp$9.regexp_eatReverseSolidusAtomEscape = function (state) {
  var start = state.pos;

  if (state.eat(0x5C
  /* \ */
  )) {
    if (this.regexp_eatAtomEscape(state)) {
      return true;
    }

    state.pos = start;
  }

  return false;
};

pp$9.regexp_eatUncapturingGroup = function (state) {
  var start = state.pos;

  if (state.eat(0x28
  /* ( */
  )) {
    if (state.eat(0x3F
    /* ? */
    ) && state.eat(0x3A
    /* : */
    )) {
      this.regexp_disjunction(state);

      if (state.eat(0x29
      /* ) */
      )) {
        return true;
      }

      state.raise("Unterminated group");
    }

    state.pos = start;
  }

  return false;
};

pp$9.regexp_eatCapturingGroup = function (state) {
  if (state.eat(0x28
  /* ( */
  )) {
    if (this.options.ecmaVersion >= 9) {
      this.regexp_groupSpecifier(state);
    } else if (state.current() === 0x3F
    /* ? */
    ) {
        state.raise("Invalid group");
      }

    this.regexp_disjunction(state);

    if (state.eat(0x29
    /* ) */
    )) {
      state.numCapturingParens += 1;
      return true;
    }

    state.raise("Unterminated group");
  }

  return false;
}; // https://www.ecma-international.org/ecma-262/8.0/#prod-annexB-ExtendedAtom


pp$9.regexp_eatExtendedAtom = function (state) {
  return state.eat(0x2E
  /* . */
  ) || this.regexp_eatReverseSolidusAtomEscape(state) || this.regexp_eatCharacterClass(state) || this.regexp_eatUncapturingGroup(state) || this.regexp_eatCapturingGroup(state) || this.regexp_eatInvalidBracedQuantifier(state) || this.regexp_eatExtendedPatternCharacter(state);
}; // https://www.ecma-international.org/ecma-262/8.0/#prod-annexB-InvalidBracedQuantifier


pp$9.regexp_eatInvalidBracedQuantifier = function (state) {
  if (this.regexp_eatBracedQuantifier(state, true)) {
    state.raise("Nothing to repeat");
  }

  return false;
}; // https://www.ecma-international.org/ecma-262/8.0/#prod-SyntaxCharacter


pp$9.regexp_eatSyntaxCharacter = function (state) {
  var ch = state.current();

  if (isSyntaxCharacter(ch)) {
    state.lastIntValue = ch;
    state.advance();
    return true;
  }

  return false;
};

function isSyntaxCharacter(ch) {
  return ch === 0x24
  /* $ */
  || ch >= 0x28
  /* ( */
  && ch <= 0x2B
  /* + */
  || ch === 0x2E
  /* . */
  || ch === 0x3F
  /* ? */
  || ch >= 0x5B
  /* [ */
  && ch <= 0x5E
  /* ^ */
  || ch >= 0x7B
  /* { */
  && ch <= 0x7D
  /* } */
  ;
} // https://www.ecma-international.org/ecma-262/8.0/#prod-PatternCharacter
// But eat eager.


pp$9.regexp_eatPatternCharacters = function (state) {
  var start = state.pos;
  var ch = 0;

  while ((ch = state.current()) !== -1 && !isSyntaxCharacter(ch)) {
    state.advance();
  }

  return state.pos !== start;
}; // https://www.ecma-international.org/ecma-262/8.0/#prod-annexB-ExtendedPatternCharacter


pp$9.regexp_eatExtendedPatternCharacter = function (state) {
  var ch = state.current();

  if (ch !== -1 && ch !== 0x24
  /* $ */
  && !(ch >= 0x28
  /* ( */
  && ch <= 0x2B
  /* + */
  ) && ch !== 0x2E
  /* . */
  && ch !== 0x3F
  /* ? */
  && ch !== 0x5B
  /* [ */
  && ch !== 0x5E
  /* ^ */
  && ch !== 0x7C
  /* | */
  ) {
      state.advance();
      return true;
    }

  return false;
}; // GroupSpecifier[U] ::
//   [empty]
//   `?` GroupName[?U]


pp$9.regexp_groupSpecifier = function (state) {
  if (state.eat(0x3F
  /* ? */
  )) {
    if (this.regexp_eatGroupName(state)) {
      if (state.groupNames.indexOf(state.lastStringValue) !== -1) {
        state.raise("Duplicate capture group name");
      }

      state.groupNames.push(state.lastStringValue);
      return;
    }

    state.raise("Invalid group");
  }
}; // GroupName[U] ::
//   `<` RegExpIdentifierName[?U] `>`
// Note: this updates `state.lastStringValue` property with the eaten name.


pp$9.regexp_eatGroupName = function (state) {
  state.lastStringValue = "";

  if (state.eat(0x3C
  /* < */
  )) {
    if (this.regexp_eatRegExpIdentifierName(state) && state.eat(0x3E
    /* > */
    )) {
      return true;
    }

    state.raise("Invalid capture group name");
  }

  return false;
}; // RegExpIdentifierName[U] ::
//   RegExpIdentifierStart[?U]
//   RegExpIdentifierName[?U] RegExpIdentifierPart[?U]
// Note: this updates `state.lastStringValue` property with the eaten name.


pp$9.regexp_eatRegExpIdentifierName = function (state) {
  state.lastStringValue = "";

  if (this.regexp_eatRegExpIdentifierStart(state)) {
    state.lastStringValue += codePointToString$1(state.lastIntValue);

    while (this.regexp_eatRegExpIdentifierPart(state)) {
      state.lastStringValue += codePointToString$1(state.lastIntValue);
    }

    return true;
  }

  return false;
}; // RegExpIdentifierStart[U] ::
//   UnicodeIDStart
//   `$`
//   `_`
//   `\` RegExpUnicodeEscapeSequence[?U]


pp$9.regexp_eatRegExpIdentifierStart = function (state) {
  var start = state.pos;
  var ch = state.current();
  state.advance();

  if (ch === 0x5C
  /* \ */
  && this.regexp_eatRegExpUnicodeEscapeSequence(state)) {
    ch = state.lastIntValue;
  }

  if (isRegExpIdentifierStart(ch)) {
    state.lastIntValue = ch;
    return true;
  }

  state.pos = start;
  return false;
};

function isRegExpIdentifierStart(ch) {
  return isIdentifierStart(ch, true) || ch === 0x24
  /* $ */
  || ch === 0x5F;
  /* _ */
} // RegExpIdentifierPart[U] ::
//   UnicodeIDContinue
//   `$`
//   `_`
//   `\` RegExpUnicodeEscapeSequence[?U]
//   <ZWNJ>
//   <ZWJ>


pp$9.regexp_eatRegExpIdentifierPart = function (state) {
  var start = state.pos;
  var ch = state.current();
  state.advance();

  if (ch === 0x5C
  /* \ */
  && this.regexp_eatRegExpUnicodeEscapeSequence(state)) {
    ch = state.lastIntValue;
  }

  if (isRegExpIdentifierPart(ch)) {
    state.lastIntValue = ch;
    return true;
  }

  state.pos = start;
  return false;
};

function isRegExpIdentifierPart(ch) {
  return isIdentifierChar(ch, true) || ch === 0x24
  /* $ */
  || ch === 0x5F
  /* _ */
  || ch === 0x200C
  /* <ZWNJ> */
  || ch === 0x200D;
  /* <ZWJ> */
} // https://www.ecma-international.org/ecma-262/8.0/#prod-annexB-AtomEscape


pp$9.regexp_eatAtomEscape = function (state) {
  if (this.regexp_eatBackReference(state) || this.regexp_eatCharacterClassEscape(state) || this.regexp_eatCharacterEscape(state) || state.switchN && this.regexp_eatKGroupName(state)) {
    return true;
  }

  if (state.switchU) {
    // Make the same message as V8.
    if (state.current() === 0x63
    /* c */
    ) {
        state.raise("Invalid unicode escape");
      }

    state.raise("Invalid escape");
  }

  return false;
};

pp$9.regexp_eatBackReference = function (state) {
  var start = state.pos;

  if (this.regexp_eatDecimalEscape(state)) {
    var n = state.lastIntValue;

    if (state.switchU) {
      // For SyntaxError in https://www.ecma-international.org/ecma-262/8.0/#sec-atomescape
      if (n > state.maxBackReference) {
        state.maxBackReference = n;
      }

      return true;
    }

    if (n <= state.numCapturingParens) {
      return true;
    }

    state.pos = start;
  }

  return false;
};

pp$9.regexp_eatKGroupName = function (state) {
  if (state.eat(0x6B
  /* k */
  )) {
    if (this.regexp_eatGroupName(state)) {
      state.backReferenceNames.push(state.lastStringValue);
      return true;
    }

    state.raise("Invalid named reference");
  }

  return false;
}; // https://www.ecma-international.org/ecma-262/8.0/#prod-annexB-CharacterEscape


pp$9.regexp_eatCharacterEscape = function (state) {
  return this.regexp_eatControlEscape(state) || this.regexp_eatCControlLetter(state) || this.regexp_eatZero(state) || this.regexp_eatHexEscapeSequence(state) || this.regexp_eatRegExpUnicodeEscapeSequence(state) || !state.switchU && this.regexp_eatLegacyOctalEscapeSequence(state) || this.regexp_eatIdentityEscape(state);
};

pp$9.regexp_eatCControlLetter = function (state) {
  var start = state.pos;

  if (state.eat(0x63
  /* c */
  )) {
    if (this.regexp_eatControlLetter(state)) {
      return true;
    }

    state.pos = start;
  }

  return false;
};

pp$9.regexp_eatZero = function (state) {
  if (state.current() === 0x30
  /* 0 */
  && !isDecimalDigit(state.lookahead())) {
    state.lastIntValue = 0;
    state.advance();
    return true;
  }

  return false;
}; // https://www.ecma-international.org/ecma-262/8.0/#prod-ControlEscape


pp$9.regexp_eatControlEscape = function (state) {
  var ch = state.current();

  if (ch === 0x74
  /* t */
  ) {
      state.lastIntValue = 0x09;
      /* \t */

      state.advance();
      return true;
    }

  if (ch === 0x6E
  /* n */
  ) {
      state.lastIntValue = 0x0A;
      /* \n */

      state.advance();
      return true;
    }

  if (ch === 0x76
  /* v */
  ) {
      state.lastIntValue = 0x0B;
      /* \v */

      state.advance();
      return true;
    }

  if (ch === 0x66
  /* f */
  ) {
      state.lastIntValue = 0x0C;
      /* \f */

      state.advance();
      return true;
    }

  if (ch === 0x72
  /* r */
  ) {
      state.lastIntValue = 0x0D;
      /* \r */

      state.advance();
      return true;
    }

  return false;
}; // https://www.ecma-international.org/ecma-262/8.0/#prod-ControlLetter


pp$9.regexp_eatControlLetter = function (state) {
  var ch = state.current();

  if (isControlLetter(ch)) {
    state.lastIntValue = ch % 0x20;
    state.advance();
    return true;
  }

  return false;
};

function isControlLetter(ch) {
  return ch >= 0x41
  /* A */
  && ch <= 0x5A
  /* Z */
  || ch >= 0x61
  /* a */
  && ch <= 0x7A
  /* z */
  ;
} // https://www.ecma-international.org/ecma-262/8.0/#prod-RegExpUnicodeEscapeSequence


pp$9.regexp_eatRegExpUnicodeEscapeSequence = function (state) {
  var start = state.pos;

  if (state.eat(0x75
  /* u */
  )) {
    if (this.regexp_eatFixedHexDigits(state, 4)) {
      var lead = state.lastIntValue;

      if (state.switchU && lead >= 0xD800 && lead <= 0xDBFF) {
        var leadSurrogateEnd = state.pos;

        if (state.eat(0x5C
        /* \ */
        ) && state.eat(0x75
        /* u */
        ) && this.regexp_eatFixedHexDigits(state, 4)) {
          var trail = state.lastIntValue;

          if (trail >= 0xDC00 && trail <= 0xDFFF) {
            state.lastIntValue = (lead - 0xD800) * 0x400 + (trail - 0xDC00) + 0x10000;
            return true;
          }
        }

        state.pos = leadSurrogateEnd;
        state.lastIntValue = lead;
      }

      return true;
    }

    if (state.switchU && state.eat(0x7B
    /* { */
    ) && this.regexp_eatHexDigits(state) && state.eat(0x7D
    /* } */
    ) && isValidUnicode(state.lastIntValue)) {
      return true;
    }

    if (state.switchU) {
      state.raise("Invalid unicode escape");
    }

    state.pos = start;
  }

  return false;
};

function isValidUnicode(ch) {
  return ch >= 0 && ch <= 0x10FFFF;
} // https://www.ecma-international.org/ecma-262/8.0/#prod-annexB-IdentityEscape


pp$9.regexp_eatIdentityEscape = function (state) {
  if (state.switchU) {
    if (this.regexp_eatSyntaxCharacter(state)) {
      return true;
    }

    if (state.eat(0x2F
    /* / */
    )) {
      state.lastIntValue = 0x2F;
      /* / */

      return true;
    }

    return false;
  }

  var ch = state.current();

  if (ch !== 0x63
  /* c */
  && (!state.switchN || ch !== 0x6B
  /* k */
  )) {
    state.lastIntValue = ch;
    state.advance();
    return true;
  }

  return false;
}; // https://www.ecma-international.org/ecma-262/8.0/#prod-DecimalEscape


pp$9.regexp_eatDecimalEscape = function (state) {
  state.lastIntValue = 0;
  var ch = state.current();

  if (ch >= 0x31
  /* 1 */
  && ch <= 0x39
  /* 9 */
  ) {
      do {
        state.lastIntValue = 10 * state.lastIntValue + (ch - 0x30
        /* 0 */
        );
        state.advance();
      } while ((ch = state.current()) >= 0x30
      /* 0 */
      && ch <= 0x39
      /* 9 */
      );

      return true;
    }

  return false;
}; // https://www.ecma-international.org/ecma-262/8.0/#prod-CharacterClassEscape


pp$9.regexp_eatCharacterClassEscape = function (state) {
  var ch = state.current();

  if (isCharacterClassEscape(ch)) {
    state.lastIntValue = -1;
    state.advance();
    return true;
  }

  if (state.switchU && this.options.ecmaVersion >= 9 && (ch === 0x50
  /* P */
  || ch === 0x70
  /* p */
  )) {
    state.lastIntValue = -1;
    state.advance();

    if (state.eat(0x7B
    /* { */
    ) && this.regexp_eatUnicodePropertyValueExpression(state) && state.eat(0x7D
    /* } */
    )) {
      return true;
    }

    state.raise("Invalid property name");
  }

  return false;
};

function isCharacterClassEscape(ch) {
  return ch === 0x64
  /* d */
  || ch === 0x44
  /* D */
  || ch === 0x73
  /* s */
  || ch === 0x53
  /* S */
  || ch === 0x77
  /* w */
  || ch === 0x57
  /* W */
  ;
} // UnicodePropertyValueExpression ::
//   UnicodePropertyName `=` UnicodePropertyValue
//   LoneUnicodePropertyNameOrValue


pp$9.regexp_eatUnicodePropertyValueExpression = function (state) {
  var start = state.pos; // UnicodePropertyName `=` UnicodePropertyValue

  if (this.regexp_eatUnicodePropertyName(state) && state.eat(0x3D
  /* = */
  )) {
    var name = state.lastStringValue;

    if (this.regexp_eatUnicodePropertyValue(state)) {
      var value = state.lastStringValue;
      this.regexp_validateUnicodePropertyNameAndValue(state, name, value);
      return true;
    }
  }

  state.pos = start; // LoneUnicodePropertyNameOrValue

  if (this.regexp_eatLoneUnicodePropertyNameOrValue(state)) {
    var nameOrValue = state.lastStringValue;
    this.regexp_validateUnicodePropertyNameOrValue(state, nameOrValue);
    return true;
  }

  return false;
};

pp$9.regexp_validateUnicodePropertyNameAndValue = function (state, name, value) {
  if (!data.hasOwnProperty(name) || data[name].indexOf(value) === -1) {
    state.raise("Invalid property name");
  }
};

pp$9.regexp_validateUnicodePropertyNameOrValue = function (state, nameOrValue) {
  if (data.$LONE.indexOf(nameOrValue) === -1) {
    state.raise("Invalid property name");
  }
}; // UnicodePropertyName ::
//   UnicodePropertyNameCharacters


pp$9.regexp_eatUnicodePropertyName = function (state) {
  var ch = 0;
  state.lastStringValue = "";

  while (isUnicodePropertyNameCharacter(ch = state.current())) {
    state.lastStringValue += codePointToString$1(ch);
    state.advance();
  }

  return state.lastStringValue !== "";
};

function isUnicodePropertyNameCharacter(ch) {
  return isControlLetter(ch) || ch === 0x5F;
  /* _ */
} // UnicodePropertyValue ::
//   UnicodePropertyValueCharacters


pp$9.regexp_eatUnicodePropertyValue = function (state) {
  var ch = 0;
  state.lastStringValue = "";

  while (isUnicodePropertyValueCharacter(ch = state.current())) {
    state.lastStringValue += codePointToString$1(ch);
    state.advance();
  }

  return state.lastStringValue !== "";
};

function isUnicodePropertyValueCharacter(ch) {
  return isUnicodePropertyNameCharacter(ch) || isDecimalDigit(ch);
} // LoneUnicodePropertyNameOrValue ::
//   UnicodePropertyValueCharacters


pp$9.regexp_eatLoneUnicodePropertyNameOrValue = function (state) {
  return this.regexp_eatUnicodePropertyValue(state);
}; // https://www.ecma-international.org/ecma-262/8.0/#prod-CharacterClass


pp$9.regexp_eatCharacterClass = function (state) {
  if (state.eat(0x5B
  /* [ */
  )) {
    state.eat(0x5E
    /* ^ */
    );
    this.regexp_classRanges(state);

    if (state.eat(0x5D
    /* [ */
    )) {
      return true;
    } // Unreachable since it threw "unterminated regular expression" error before.


    state.raise("Unterminated character class");
  }

  return false;
}; // https://www.ecma-international.org/ecma-262/8.0/#prod-ClassRanges
// https://www.ecma-international.org/ecma-262/8.0/#prod-NonemptyClassRanges
// https://www.ecma-international.org/ecma-262/8.0/#prod-NonemptyClassRangesNoDash


pp$9.regexp_classRanges = function (state) {
  var this$1 = this;

  while (this.regexp_eatClassAtom(state)) {
    var left = state.lastIntValue;

    if (state.eat(0x2D
    /* - */
    ) && this$1.regexp_eatClassAtom(state)) {
      var right = state.lastIntValue;

      if (state.switchU && (left === -1 || right === -1)) {
        state.raise("Invalid character class");
      }

      if (left !== -1 && right !== -1 && left > right) {
        state.raise("Range out of order in character class");
      }
    }
  }
}; // https://www.ecma-international.org/ecma-262/8.0/#prod-ClassAtom
// https://www.ecma-international.org/ecma-262/8.0/#prod-ClassAtomNoDash


pp$9.regexp_eatClassAtom = function (state) {
  var start = state.pos;

  if (state.eat(0x5C
  /* \ */
  )) {
    if (this.regexp_eatClassEscape(state)) {
      return true;
    }

    if (state.switchU) {
      // Make the same message as V8.
      var ch$1 = state.current();

      if (ch$1 === 0x63
      /* c */
      || isOctalDigit(ch$1)) {
        state.raise("Invalid class escape");
      }

      state.raise("Invalid escape");
    }

    state.pos = start;
  }

  var ch = state.current();

  if (ch !== 0x5D
  /* [ */
  ) {
      state.lastIntValue = ch;
      state.advance();
      return true;
    }

  return false;
}; // https://www.ecma-international.org/ecma-262/8.0/#prod-annexB-ClassEscape


pp$9.regexp_eatClassEscape = function (state) {
  var start = state.pos;

  if (state.eat(0x62
  /* b */
  )) {
    state.lastIntValue = 0x08;
    /* <BS> */

    return true;
  }

  if (state.switchU && state.eat(0x2D
  /* - */
  )) {
    state.lastIntValue = 0x2D;
    /* - */

    return true;
  }

  if (!state.switchU && state.eat(0x63
  /* c */
  )) {
    if (this.regexp_eatClassControlLetter(state)) {
      return true;
    }

    state.pos = start;
  }

  return this.regexp_eatCharacterClassEscape(state) || this.regexp_eatCharacterEscape(state);
}; // https://www.ecma-international.org/ecma-262/8.0/#prod-annexB-ClassControlLetter


pp$9.regexp_eatClassControlLetter = function (state) {
  var ch = state.current();

  if (isDecimalDigit(ch) || ch === 0x5F
  /* _ */
  ) {
      state.lastIntValue = ch % 0x20;
      state.advance();
      return true;
    }

  return false;
}; // https://www.ecma-international.org/ecma-262/8.0/#prod-HexEscapeSequence


pp$9.regexp_eatHexEscapeSequence = function (state) {
  var start = state.pos;

  if (state.eat(0x78
  /* x */
  )) {
    if (this.regexp_eatFixedHexDigits(state, 2)) {
      return true;
    }

    if (state.switchU) {
      state.raise("Invalid escape");
    }

    state.pos = start;
  }

  return false;
}; // https://www.ecma-international.org/ecma-262/8.0/#prod-DecimalDigits


pp$9.regexp_eatDecimalDigits = function (state) {
  var start = state.pos;
  var ch = 0;
  state.lastIntValue = 0;

  while (isDecimalDigit(ch = state.current())) {
    state.lastIntValue = 10 * state.lastIntValue + (ch - 0x30
    /* 0 */
    );
    state.advance();
  }

  return state.pos !== start;
};

function isDecimalDigit(ch) {
  return ch >= 0x30
  /* 0 */
  && ch <= 0x39;
  /* 9 */
} // https://www.ecma-international.org/ecma-262/8.0/#prod-HexDigits


pp$9.regexp_eatHexDigits = function (state) {
  var start = state.pos;
  var ch = 0;
  state.lastIntValue = 0;

  while (isHexDigit(ch = state.current())) {
    state.lastIntValue = 16 * state.lastIntValue + hexToInt(ch);
    state.advance();
  }

  return state.pos !== start;
};

function isHexDigit(ch) {
  return ch >= 0x30
  /* 0 */
  && ch <= 0x39
  /* 9 */
  || ch >= 0x41
  /* A */
  && ch <= 0x46
  /* F */
  || ch >= 0x61
  /* a */
  && ch <= 0x66
  /* f */
  ;
}

function hexToInt(ch) {
  if (ch >= 0x41
  /* A */
  && ch <= 0x46
  /* F */
  ) {
      return 10 + (ch - 0x41
      /* A */
      );
    }

  if (ch >= 0x61
  /* a */
  && ch <= 0x66
  /* f */
  ) {
      return 10 + (ch - 0x61
      /* a */
      );
    }

  return ch - 0x30;
  /* 0 */
} // https://www.ecma-international.org/ecma-262/8.0/#prod-annexB-LegacyOctalEscapeSequence
// Allows only 0-377(octal) i.e. 0-255(decimal).


pp$9.regexp_eatLegacyOctalEscapeSequence = function (state) {
  if (this.regexp_eatOctalDigit(state)) {
    var n1 = state.lastIntValue;

    if (this.regexp_eatOctalDigit(state)) {
      var n2 = state.lastIntValue;

      if (n1 <= 3 && this.regexp_eatOctalDigit(state)) {
        state.lastIntValue = n1 * 64 + n2 * 8 + state.lastIntValue;
      } else {
        state.lastIntValue = n1 * 8 + n2;
      }
    } else {
      state.lastIntValue = n1;
    }

    return true;
  }

  return false;
}; // https://www.ecma-international.org/ecma-262/8.0/#prod-OctalDigit


pp$9.regexp_eatOctalDigit = function (state) {
  var ch = state.current();

  if (isOctalDigit(ch)) {
    state.lastIntValue = ch - 0x30;
    /* 0 */

    state.advance();
    return true;
  }

  state.lastIntValue = 0;
  return false;
};

function isOctalDigit(ch) {
  return ch >= 0x30
  /* 0 */
  && ch <= 0x37;
  /* 7 */
} // https://www.ecma-international.org/ecma-262/8.0/#prod-Hex4Digits
// https://www.ecma-international.org/ecma-262/8.0/#prod-HexDigit
// And HexDigit HexDigit in https://www.ecma-international.org/ecma-262/8.0/#prod-HexEscapeSequence


pp$9.regexp_eatFixedHexDigits = function (state, length) {
  var start = state.pos;
  state.lastIntValue = 0;

  for (var i = 0; i < length; ++i) {
    var ch = state.current();

    if (!isHexDigit(ch)) {
      state.pos = start;
      return false;
    }

    state.lastIntValue = 16 * state.lastIntValue + hexToInt(ch);
    state.advance();
  }

  return true;
}; // Object type used to represent tokens. Note that normally, tokens
// simply exist as properties on the parser object. This is only
// used for the onToken callback and the external tokenizer.


var Token = function Token(p) {
  this.type = p.type;
  this.value = p.value;
  this.start = p.start;
  this.end = p.end;

  if (p.options.locations) {
    this.loc = new SourceLocation(p, p.startLoc, p.endLoc);
  }

  if (p.options.ranges) {
    this.range = [p.start, p.end];
  }
}; // ## Tokenizer


var pp$8 = Parser.prototype; // Move to the next token

pp$8.next = function () {
  if (this.options.onToken) {
    this.options.onToken(new Token(this));
  }

  this.lastTokEnd = this.end;
  this.lastTokStart = this.start;
  this.lastTokEndLoc = this.endLoc;
  this.lastTokStartLoc = this.startLoc;
  this.nextToken();
};

pp$8.getToken = function () {
  this.next();
  return new Token(this);
}; // If we're in an ES6 environment, make parsers iterable


if (typeof Symbol !== "undefined") {
  pp$8[Symbol.iterator] = function () {
    var this$1 = this;
    return {
      next: function next() {
        var token = this$1.getToken();
        return {
          done: token.type === types.eof,
          value: token
        };
      }
    };
  };
} // Toggle strict mode. Re-reads the next number or string to please
// pedantic tests (`"use strict"; 010;` should fail).


pp$8.curContext = function () {
  return this.context[this.context.length - 1];
}; // Read a single token, updating the parser object's token-related
// properties.


pp$8.nextToken = function () {
  var curContext = this.curContext();

  if (!curContext || !curContext.preserveSpace) {
    this.skipSpace();
  }

  this.start = this.pos;

  if (this.options.locations) {
    this.startLoc = this.curPosition();
  }

  if (this.pos >= this.input.length) {
    return this.finishToken(types.eof);
  }

  if (curContext.override) {
    return curContext.override(this);
  } else {
    this.readToken(this.fullCharCodeAtPos());
  }
};

pp$8.readToken = function (code) {
  // Identifier or keyword. '\uXXXX' sequences are allowed in
  // identifiers, so '\' also dispatches to that.
  if (isIdentifierStart(code, this.options.ecmaVersion >= 6) || code === 92
  /* '\' */
  ) {
      return this.readWord();
    }

  return this.getTokenFromCode(code);
};

pp$8.fullCharCodeAtPos = function () {
  var code = this.input.charCodeAt(this.pos);

  if (code <= 0xd7ff || code >= 0xe000) {
    return code;
  }

  var next = this.input.charCodeAt(this.pos + 1);
  return (code << 10) + next - 0x35fdc00;
};

pp$8.skipBlockComment = function () {
  var this$1 = this;
  var startLoc = this.options.onComment && this.curPosition();
  var start = this.pos,
      end = this.input.indexOf("*/", this.pos += 2);

  if (end === -1) {
    this.raise(this.pos - 2, "Unterminated comment");
  }

  this.pos = end + 2;

  if (this.options.locations) {
    lineBreakG.lastIndex = start;
    var match;

    while ((match = lineBreakG.exec(this.input)) && match.index < this.pos) {
      ++this$1.curLine;
      this$1.lineStart = match.index + match[0].length;
    }
  }

  if (this.options.onComment) {
    this.options.onComment(true, this.input.slice(start + 2, end), start, this.pos, startLoc, this.curPosition());
  }
};

pp$8.skipLineComment = function (startSkip) {
  var this$1 = this;
  var start = this.pos;
  var startLoc = this.options.onComment && this.curPosition();
  var ch = this.input.charCodeAt(this.pos += startSkip);

  while (this.pos < this.input.length && !isNewLine(ch)) {
    ch = this$1.input.charCodeAt(++this$1.pos);
  }

  if (this.options.onComment) {
    this.options.onComment(false, this.input.slice(start + startSkip, this.pos), start, this.pos, startLoc, this.curPosition());
  }
}; // Called at the start of the parse and after every token. Skips
// whitespace and comments, and.


pp$8.skipSpace = function () {
  var this$1 = this;

  loop: while (this.pos < this.input.length) {
    var ch = this$1.input.charCodeAt(this$1.pos);

    switch (ch) {
      case 32:
      case 160:
        // ' '
        ++this$1.pos;
        break;

      case 13:
        if (this$1.input.charCodeAt(this$1.pos + 1) === 10) {
          ++this$1.pos;
        }

      case 10:
      case 8232:
      case 8233:
        ++this$1.pos;

        if (this$1.options.locations) {
          ++this$1.curLine;
          this$1.lineStart = this$1.pos;
        }

        break;

      case 47:
        // '/'
        switch (this$1.input.charCodeAt(this$1.pos + 1)) {
          case 42:
            // '*'
            this$1.skipBlockComment();
            break;

          case 47:
            this$1.skipLineComment(2);
            break;

          default:
            break loop;
        }

        break;

      default:
        if (ch > 8 && ch < 14 || ch >= 5760 && nonASCIIwhitespace.test(String.fromCharCode(ch))) {
          ++this$1.pos;
        } else {
          break loop;
        }

    }
  }
}; // Called at the end of every token. Sets `end`, `val`, and
// maintains `context` and `exprAllowed`, and skips the space after
// the token, so that the next one's `start` will point at the
// right position.


pp$8.finishToken = function (type, val) {
  this.end = this.pos;

  if (this.options.locations) {
    this.endLoc = this.curPosition();
  }

  var prevType = this.type;
  this.type = type;
  this.value = val;
  this.updateContext(prevType);
}; // ### Token reading
// This is the function that is called to fetch the next token. It
// is somewhat obscure, because it works in character codes rather
// than characters, and because operator parsing has been inlined
// into it.
//
// All in the name of speed.
//


pp$8.readToken_dot = function () {
  var next = this.input.charCodeAt(this.pos + 1);

  if (next >= 48 && next <= 57) {
    return this.readNumber(true);
  }

  var next2 = this.input.charCodeAt(this.pos + 2);

  if (this.options.ecmaVersion >= 6 && next === 46 && next2 === 46) {
    // 46 = dot '.'
    this.pos += 3;
    return this.finishToken(types.ellipsis);
  } else {
    ++this.pos;
    return this.finishToken(types.dot);
  }
};

pp$8.readToken_slash = function () {
  // '/'
  var next = this.input.charCodeAt(this.pos + 1);

  if (this.exprAllowed) {
    ++this.pos;
    return this.readRegexp();
  }

  if (next === 61) {
    return this.finishOp(types.assign, 2);
  }

  return this.finishOp(types.slash, 1);
};

pp$8.readToken_mult_modulo_exp = function (code) {
  // '%*'
  var next = this.input.charCodeAt(this.pos + 1);
  var size = 1;
  var tokentype = code === 42 ? types.star : types.modulo; // exponentiation operator ** and **=

  if (this.options.ecmaVersion >= 7 && code === 42 && next === 42) {
    ++size;
    tokentype = types.starstar;
    next = this.input.charCodeAt(this.pos + 2);
  }

  if (next === 61) {
    return this.finishOp(types.assign, size + 1);
  }

  return this.finishOp(tokentype, size);
};

pp$8.readToken_pipe_amp = function (code) {
  // '|&'
  var next = this.input.charCodeAt(this.pos + 1);

  if (next === code) {
    return this.finishOp(code === 124 ? types.logicalOR : types.logicalAND, 2);
  }

  if (next === 61) {
    return this.finishOp(types.assign, 2);
  }

  return this.finishOp(code === 124 ? types.bitwiseOR : types.bitwiseAND, 1);
};

pp$8.readToken_caret = function () {
  // '^'
  var next = this.input.charCodeAt(this.pos + 1);

  if (next === 61) {
    return this.finishOp(types.assign, 2);
  }

  return this.finishOp(types.bitwiseXOR, 1);
};

pp$8.readToken_plus_min = function (code) {
  // '+-'
  var next = this.input.charCodeAt(this.pos + 1);

  if (next === code) {
    if (next === 45 && !this.inModule && this.input.charCodeAt(this.pos + 2) === 62 && (this.lastTokEnd === 0 || lineBreak.test(this.input.slice(this.lastTokEnd, this.pos)))) {
      // A `-->` line comment
      this.skipLineComment(3);
      this.skipSpace();
      return this.nextToken();
    }

    return this.finishOp(types.incDec, 2);
  }

  if (next === 61) {
    return this.finishOp(types.assign, 2);
  }

  return this.finishOp(types.plusMin, 1);
};

pp$8.readToken_lt_gt = function (code) {
  // '<>'
  var next = this.input.charCodeAt(this.pos + 1);
  var size = 1;

  if (next === code) {
    size = code === 62 && this.input.charCodeAt(this.pos + 2) === 62 ? 3 : 2;

    if (this.input.charCodeAt(this.pos + size) === 61) {
      return this.finishOp(types.assign, size + 1);
    }

    return this.finishOp(types.bitShift, size);
  }

  if (next === 33 && code === 60 && !this.inModule && this.input.charCodeAt(this.pos + 2) === 45 && this.input.charCodeAt(this.pos + 3) === 45) {
    // `<!--`, an XML-style comment that should be interpreted as a line comment
    this.skipLineComment(4);
    this.skipSpace();
    return this.nextToken();
  }

  if (next === 61) {
    size = 2;
  }

  return this.finishOp(types.relational, size);
};

pp$8.readToken_eq_excl = function (code) {
  // '=!'
  var next = this.input.charCodeAt(this.pos + 1);

  if (next === 61) {
    return this.finishOp(types.equality, this.input.charCodeAt(this.pos + 2) === 61 ? 3 : 2);
  }

  if (code === 61 && next === 62 && this.options.ecmaVersion >= 6) {
    // '=>'
    this.pos += 2;
    return this.finishToken(types.arrow);
  }

  return this.finishOp(code === 61 ? types.eq : types.prefix, 1);
};

pp$8.getTokenFromCode = function (code) {
  switch (code) {
    // The interpretation of a dot depends on whether it is followed
    // by a digit or another two dots.
    case 46:
      // '.'
      return this.readToken_dot();
    // Punctuation tokens.

    case 40:
      ++this.pos;
      return this.finishToken(types.parenL);

    case 41:
      ++this.pos;
      return this.finishToken(types.parenR);

    case 59:
      ++this.pos;
      return this.finishToken(types.semi);

    case 44:
      ++this.pos;
      return this.finishToken(types.comma);

    case 91:
      ++this.pos;
      return this.finishToken(types.bracketL);

    case 93:
      ++this.pos;
      return this.finishToken(types.bracketR);

    case 123:
      ++this.pos;
      return this.finishToken(types.braceL);

    case 125:
      ++this.pos;
      return this.finishToken(types.braceR);

    case 58:
      ++this.pos;
      return this.finishToken(types.colon);

    case 63:
      ++this.pos;
      return this.finishToken(types.question);

    case 96:
      // '`'
      if (this.options.ecmaVersion < 6) {
        break;
      }

      ++this.pos;
      return this.finishToken(types.backQuote);

    case 48:
      // '0'
      var next = this.input.charCodeAt(this.pos + 1);

      if (next === 120 || next === 88) {
        return this.readRadixNumber(16);
      } // '0x', '0X' - hex number


      if (this.options.ecmaVersion >= 6) {
        if (next === 111 || next === 79) {
          return this.readRadixNumber(8);
        } // '0o', '0O' - octal number


        if (next === 98 || next === 66) {
          return this.readRadixNumber(2);
        } // '0b', '0B' - binary number

      }

    // Anything else beginning with a digit is an integer, octal
    // number, or float.

    case 49:
    case 50:
    case 51:
    case 52:
    case 53:
    case 54:
    case 55:
    case 56:
    case 57:
      // 1-9
      return this.readNumber(false);
    // Quotes produce strings.

    case 34:
    case 39:
      // '"', "'"
      return this.readString(code);
    // Operators are parsed inline in tiny state machines. '=' (61) is
    // often referred to. `finishOp` simply skips the amount of
    // characters it is given as second argument, and returns a token
    // of the type given by its first argument.

    case 47:
      // '/'
      return this.readToken_slash();

    case 37:
    case 42:
      // '%*'
      return this.readToken_mult_modulo_exp(code);

    case 124:
    case 38:
      // '|&'
      return this.readToken_pipe_amp(code);

    case 94:
      // '^'
      return this.readToken_caret();

    case 43:
    case 45:
      // '+-'
      return this.readToken_plus_min(code);

    case 60:
    case 62:
      // '<>'
      return this.readToken_lt_gt(code);

    case 61:
    case 33:
      // '=!'
      return this.readToken_eq_excl(code);

    case 126:
      // '~'
      return this.finishOp(types.prefix, 1);
  }

  this.raise(this.pos, "Unexpected character '" + codePointToString(code) + "'");
};

pp$8.finishOp = function (type, size) {
  var str = this.input.slice(this.pos, this.pos + size);
  this.pos += size;
  return this.finishToken(type, str);
};

pp$8.readRegexp = function () {
  var this$1 = this;
  var escaped,
      inClass,
      start = this.pos;

  for (;;) {
    if (this$1.pos >= this$1.input.length) {
      this$1.raise(start, "Unterminated regular expression");
    }

    var ch = this$1.input.charAt(this$1.pos);

    if (lineBreak.test(ch)) {
      this$1.raise(start, "Unterminated regular expression");
    }

    if (!escaped) {
      if (ch === "[") {
        inClass = true;
      } else if (ch === "]" && inClass) {
        inClass = false;
      } else if (ch === "/" && !inClass) {
        break;
      }

      escaped = ch === "\\";
    } else {
      escaped = false;
    }

    ++this$1.pos;
  }

  var pattern = this.input.slice(start, this.pos);
  ++this.pos;
  var flagsStart = this.pos;
  var flags = this.readWord1();

  if (this.containsEsc) {
    this.unexpected(flagsStart);
  } // Validate pattern


  var state = this.regexpState || (this.regexpState = new RegExpValidationState(this));
  state.reset(start, pattern, flags);
  this.validateRegExpFlags(state);
  this.validateRegExpPattern(state); // Create Literal#value property value.

  var value = null;

  try {
    value = new RegExp(pattern, flags);
  } catch (e) {// ESTree requires null if it failed to instantiate RegExp object.
    // https://github.com/estree/estree/blob/a27003adf4fd7bfad44de9cef372a2eacd527b1c/es5.md#regexpliteral
  }

  return this.finishToken(types.regexp, {
    pattern: pattern,
    flags: flags,
    value: value
  });
}; // Read an integer in the given radix. Return null if zero digits
// were read, the integer value otherwise. When `len` is given, this
// will return `null` unless the integer has exactly `len` digits.


pp$8.readInt = function (radix, len) {
  var this$1 = this;
  var start = this.pos,
      total = 0;

  for (var i = 0, e = len == null ? Infinity : len; i < e; ++i) {
    var code = this$1.input.charCodeAt(this$1.pos),
        val = void 0;

    if (code >= 97) {
      val = code - 97 + 10;
    } // a
    else if (code >= 65) {
        val = code - 65 + 10;
      } // A
      else if (code >= 48 && code <= 57) {
          val = code - 48;
        } // 0-9
        else {
            val = Infinity;
          }

    if (val >= radix) {
      break;
    }

    ++this$1.pos;
    total = total * radix + val;
  }

  if (this.pos === start || len != null && this.pos - start !== len) {
    return null;
  }

  return total;
};

pp$8.readRadixNumber = function (radix) {
  this.pos += 2; // 0x

  var val = this.readInt(radix);

  if (val == null) {
    this.raise(this.start + 2, "Expected number in radix " + radix);
  }

  if (isIdentifierStart(this.fullCharCodeAtPos())) {
    this.raise(this.pos, "Identifier directly after number");
  }

  return this.finishToken(types.num, val);
}; // Read an integer, octal integer, or floating-point number.


pp$8.readNumber = function (startsWithDot) {
  var start = this.pos;

  if (!startsWithDot && this.readInt(10) === null) {
    this.raise(start, "Invalid number");
  }

  var octal = this.pos - start >= 2 && this.input.charCodeAt(start) === 48;

  if (octal && this.strict) {
    this.raise(start, "Invalid number");
  }

  if (octal && /[89]/.test(this.input.slice(start, this.pos))) {
    octal = false;
  }

  var next = this.input.charCodeAt(this.pos);

  if (next === 46 && !octal) {
    // '.'
    ++this.pos;
    this.readInt(10);
    next = this.input.charCodeAt(this.pos);
  }

  if ((next === 69 || next === 101) && !octal) {
    // 'eE'
    next = this.input.charCodeAt(++this.pos);

    if (next === 43 || next === 45) {
      ++this.pos;
    } // '+-'


    if (this.readInt(10) === null) {
      this.raise(start, "Invalid number");
    }
  }

  if (isIdentifierStart(this.fullCharCodeAtPos())) {
    this.raise(this.pos, "Identifier directly after number");
  }

  var str = this.input.slice(start, this.pos);
  var val = octal ? parseInt(str, 8) : parseFloat(str);
  return this.finishToken(types.num, val);
}; // Read a string value, interpreting backslash-escapes.


pp$8.readCodePoint = function () {
  var ch = this.input.charCodeAt(this.pos),
      code;

  if (ch === 123) {
    // '{'
    if (this.options.ecmaVersion < 6) {
      this.unexpected();
    }

    var codePos = ++this.pos;
    code = this.readHexChar(this.input.indexOf("}", this.pos) - this.pos);
    ++this.pos;

    if (code > 0x10FFFF) {
      this.invalidStringToken(codePos, "Code point out of bounds");
    }
  } else {
    code = this.readHexChar(4);
  }

  return code;
};

function codePointToString(code) {
  // UTF-16 Decoding
  if (code <= 0xFFFF) {
    return String.fromCharCode(code);
  }

  code -= 0x10000;
  return String.fromCharCode((code >> 10) + 0xD800, (code & 1023) + 0xDC00);
}

pp$8.readString = function (quote) {
  var this$1 = this;
  var out = "",
      chunkStart = ++this.pos;

  for (;;) {
    if (this$1.pos >= this$1.input.length) {
      this$1.raise(this$1.start, "Unterminated string constant");
    }

    var ch = this$1.input.charCodeAt(this$1.pos);

    if (ch === quote) {
      break;
    }

    if (ch === 92) {
      // '\'
      out += this$1.input.slice(chunkStart, this$1.pos);
      out += this$1.readEscapedChar(false);
      chunkStart = this$1.pos;
    } else {
      if (isNewLine(ch, this$1.options.ecmaVersion >= 10)) {
        this$1.raise(this$1.start, "Unterminated string constant");
      }

      ++this$1.pos;
    }
  }

  out += this.input.slice(chunkStart, this.pos++);
  return this.finishToken(types.string, out);
}; // Reads template string tokens.


var INVALID_TEMPLATE_ESCAPE_ERROR = {};

pp$8.tryReadTemplateToken = function () {
  this.inTemplateElement = true;

  try {
    this.readTmplToken();
  } catch (err) {
    if (err === INVALID_TEMPLATE_ESCAPE_ERROR) {
      this.readInvalidTemplateToken();
    } else {
      throw err;
    }
  }

  this.inTemplateElement = false;
};

pp$8.invalidStringToken = function (position, message) {
  if (this.inTemplateElement && this.options.ecmaVersion >= 9) {
    throw INVALID_TEMPLATE_ESCAPE_ERROR;
  } else {
    this.raise(position, message);
  }
};

pp$8.readTmplToken = function () {
  var this$1 = this;
  var out = "",
      chunkStart = this.pos;

  for (;;) {
    if (this$1.pos >= this$1.input.length) {
      this$1.raise(this$1.start, "Unterminated template");
    }

    var ch = this$1.input.charCodeAt(this$1.pos);

    if (ch === 96 || ch === 36 && this$1.input.charCodeAt(this$1.pos + 1) === 123) {
      // '`', '${'
      if (this$1.pos === this$1.start && (this$1.type === types.template || this$1.type === types.invalidTemplate)) {
        if (ch === 36) {
          this$1.pos += 2;
          return this$1.finishToken(types.dollarBraceL);
        } else {
          ++this$1.pos;
          return this$1.finishToken(types.backQuote);
        }
      }

      out += this$1.input.slice(chunkStart, this$1.pos);
      return this$1.finishToken(types.template, out);
    }

    if (ch === 92) {
      // '\'
      out += this$1.input.slice(chunkStart, this$1.pos);
      out += this$1.readEscapedChar(true);
      chunkStart = this$1.pos;
    } else if (isNewLine(ch)) {
      out += this$1.input.slice(chunkStart, this$1.pos);
      ++this$1.pos;

      switch (ch) {
        case 13:
          if (this$1.input.charCodeAt(this$1.pos) === 10) {
            ++this$1.pos;
          }

        case 10:
          out += "\n";
          break;

        default:
          out += String.fromCharCode(ch);
          break;
      }

      if (this$1.options.locations) {
        ++this$1.curLine;
        this$1.lineStart = this$1.pos;
      }

      chunkStart = this$1.pos;
    } else {
      ++this$1.pos;
    }
  }
}; // Reads a template token to search for the end, without validating any escape sequences


pp$8.readInvalidTemplateToken = function () {
  var this$1 = this;

  for (; this.pos < this.input.length; this.pos++) {
    switch (this$1.input[this$1.pos]) {
      case "\\":
        ++this$1.pos;
        break;

      case "$":
        if (this$1.input[this$1.pos + 1] !== "{") {
          break;
        }

      // falls through

      case "`":
        return this$1.finishToken(types.invalidTemplate, this$1.input.slice(this$1.start, this$1.pos));
      // no default
    }
  }

  this.raise(this.start, "Unterminated template");
}; // Used to read escaped characters


pp$8.readEscapedChar = function (inTemplate) {
  var ch = this.input.charCodeAt(++this.pos);
  ++this.pos;

  switch (ch) {
    case 110:
      return "\n";
    // 'n' -> '\n'

    case 114:
      return "\r";
    // 'r' -> '\r'

    case 120:
      return String.fromCharCode(this.readHexChar(2));
    // 'x'

    case 117:
      return codePointToString(this.readCodePoint());
    // 'u'

    case 116:
      return "\t";
    // 't' -> '\t'

    case 98:
      return "\b";
    // 'b' -> '\b'

    case 118:
      return "\x0B";
    // 'v' -> '\u000b'

    case 102:
      return "\f";
    // 'f' -> '\f'

    case 13:
      if (this.input.charCodeAt(this.pos) === 10) {
        ++this.pos;
      }

    // '\r\n'

    case 10:
      // ' \n'
      if (this.options.locations) {
        this.lineStart = this.pos;
        ++this.curLine;
      }

      return "";

    default:
      if (ch >= 48 && ch <= 55) {
        var octalStr = this.input.substr(this.pos - 1, 3).match(/^[0-7]+/)[0];
        var octal = parseInt(octalStr, 8);

        if (octal > 255) {
          octalStr = octalStr.slice(0, -1);
          octal = parseInt(octalStr, 8);
        }

        this.pos += octalStr.length - 1;
        ch = this.input.charCodeAt(this.pos);

        if ((octalStr !== "0" || ch === 56 || ch === 57) && (this.strict || inTemplate)) {
          this.invalidStringToken(this.pos - 1 - octalStr.length, inTemplate ? "Octal literal in template string" : "Octal literal in strict mode");
        }

        return String.fromCharCode(octal);
      }

      return String.fromCharCode(ch);
  }
}; // Used to read character escape sequences ('\x', '\u', '\U').


pp$8.readHexChar = function (len) {
  var codePos = this.pos;
  var n = this.readInt(16, len);

  if (n === null) {
    this.invalidStringToken(codePos, "Bad character escape sequence");
  }

  return n;
}; // Read an identifier, and return it as a string. Sets `this.containsEsc`
// to whether the word contained a '\u' escape.
//
// Incrementally adds only escaped chars, adding other chunks as-is
// as a micro-optimization.


pp$8.readWord1 = function () {
  var this$1 = this;
  this.containsEsc = false;
  var word = "",
      first = true,
      chunkStart = this.pos;
  var astral = this.options.ecmaVersion >= 6;

  while (this.pos < this.input.length) {
    var ch = this$1.fullCharCodeAtPos();

    if (isIdentifierChar(ch, astral)) {
      this$1.pos += ch <= 0xffff ? 1 : 2;
    } else if (ch === 92) {
      // "\"
      this$1.containsEsc = true;
      word += this$1.input.slice(chunkStart, this$1.pos);
      var escStart = this$1.pos;

      if (this$1.input.charCodeAt(++this$1.pos) !== 117) // "u"
        {
          this$1.invalidStringToken(this$1.pos, "Expecting Unicode escape sequence \\uXXXX");
        }

      ++this$1.pos;
      var esc = this$1.readCodePoint();

      if (!(first ? isIdentifierStart : isIdentifierChar)(esc, astral)) {
        this$1.invalidStringToken(escStart, "Invalid Unicode escape");
      }

      word += codePointToString(esc);
      chunkStart = this$1.pos;
    } else {
      break;
    }

    first = false;
  }

  return word + this.input.slice(chunkStart, this.pos);
}; // Read an identifier or keyword token. Will check for reserved
// words when necessary.


pp$8.readWord = function () {
  var word = this.readWord1();
  var type = types.name;

  if (this.keywords.test(word)) {
    if (this.containsEsc) {
      this.raiseRecoverable(this.start, "Escape sequence in keyword " + word);
    }

    type = keywords$1[word];
  }

  return this.finishToken(type, word);
}; // Acorn is a tiny, fast JavaScript parser written in JavaScript.
//
// Acorn was written by Marijn Haverbeke, Ingvar Stepanyan, and
// various contributors and released under an MIT license.
//
// Git repositories for Acorn are available at
//
//     http://marijnhaverbeke.nl/git/acorn
//     https://github.com/acornjs/acorn.git
//
// Please use the [github bug tracker][ghbt] to report issues.
//
// [ghbt]: https://github.com/acornjs/acorn/issues
//
// [walk]: util/walk.js


var version = "6.0.2"; // The main exported interface (under `self.acorn` when in the
// browser) is a `parse` function that takes a code string and
// returns an abstract syntax tree as specified by [Mozilla parser
// API][api].
//
// [api]: https://developer.mozilla.org/en-US/docs/SpiderMonkey/Parser_API

function parse(input, options) {
  return Parser.parse(input, options);
} // This function tries to parse a single expression at a given
// offset in a string. Useful for parsing mixed-language formats
// that embed JavaScript expressions.


function parseExpressionAt(input, pos, options) {
  return Parser.parseExpressionAt(input, pos, options);
} // Acorn is organized as a tokenizer and a recursive-descent parser.
// The `tokenizer` export provides an interface to the tokenizer.


function tokenizer(input, options) {
  return Parser.tokenizer(input, options);
}

var acorn =
/*#__PURE__*/
Object.freeze({
  version: version,
  parse: parse,
  parseExpressionAt: parseExpressionAt,
  tokenizer: tokenizer,
  Parser: Parser,
  defaultOptions: defaultOptions,
  Position: Position,
  SourceLocation: SourceLocation,
  getLineInfo: getLineInfo,
  Node: Node,
  TokenType: TokenType,
  tokTypes: types,
  keywordTypes: keywords$1,
  TokContext: TokContext,
  tokContexts: types$1,
  isIdentifierChar: isIdentifierChar,
  isIdentifierStart: isIdentifierStart,
  Token: Token,
  isNewLine: isNewLine,
  lineBreak: lineBreak,
  lineBreakG: lineBreakG,
  nonASCIIwhitespace: nonASCIIwhitespace
});
var xhtml = {
  quot: "\"",
  amp: '&',
  apos: "'",
  lt: '<',
  gt: '>',
  nbsp: "\xA0",
  iexcl: "\xA1",
  cent: "\xA2",
  pound: "\xA3",
  curren: "\xA4",
  yen: "\xA5",
  brvbar: "\xA6",
  sect: "\xA7",
  uml: "\xA8",
  copy: "\xA9",
  ordf: "\xAA",
  laquo: "\xAB",
  not: "\xAC",
  shy: "\xAD",
  reg: "\xAE",
  macr: "\xAF",
  deg: "\xB0",
  plusmn: "\xB1",
  sup2: "\xB2",
  sup3: "\xB3",
  acute: "\xB4",
  micro: "\xB5",
  para: "\xB6",
  middot: "\xB7",
  cedil: "\xB8",
  sup1: "\xB9",
  ordm: "\xBA",
  raquo: "\xBB",
  frac14: "\xBC",
  frac12: "\xBD",
  frac34: "\xBE",
  iquest: "\xBF",
  Agrave: "\xC0",
  Aacute: "\xC1",
  Acirc: "\xC2",
  Atilde: "\xC3",
  Auml: "\xC4",
  Aring: "\xC5",
  AElig: "\xC6",
  Ccedil: "\xC7",
  Egrave: "\xC8",
  Eacute: "\xC9",
  Ecirc: "\xCA",
  Euml: "\xCB",
  Igrave: "\xCC",
  Iacute: "\xCD",
  Icirc: "\xCE",
  Iuml: "\xCF",
  ETH: "\xD0",
  Ntilde: "\xD1",
  Ograve: "\xD2",
  Oacute: "\xD3",
  Ocirc: "\xD4",
  Otilde: "\xD5",
  Ouml: "\xD6",
  times: "\xD7",
  Oslash: "\xD8",
  Ugrave: "\xD9",
  Uacute: "\xDA",
  Ucirc: "\xDB",
  Uuml: "\xDC",
  Yacute: "\xDD",
  THORN: "\xDE",
  szlig: "\xDF",
  agrave: "\xE0",
  aacute: "\xE1",
  acirc: "\xE2",
  atilde: "\xE3",
  auml: "\xE4",
  aring: "\xE5",
  aelig: "\xE6",
  ccedil: "\xE7",
  egrave: "\xE8",
  eacute: "\xE9",
  ecirc: "\xEA",
  euml: "\xEB",
  igrave: "\xEC",
  iacute: "\xED",
  icirc: "\xEE",
  iuml: "\xEF",
  eth: "\xF0",
  ntilde: "\xF1",
  ograve: "\xF2",
  oacute: "\xF3",
  ocirc: "\xF4",
  otilde: "\xF5",
  ouml: "\xF6",
  divide: "\xF7",
  oslash: "\xF8",
  ugrave: "\xF9",
  uacute: "\xFA",
  ucirc: "\xFB",
  uuml: "\xFC",
  yacute: "\xFD",
  thorn: "\xFE",
  yuml: "\xFF",
  OElig: "\u0152",
  oelig: "\u0153",
  Scaron: "\u0160",
  scaron: "\u0161",
  Yuml: "\u0178",
  fnof: "\u0192",
  circ: "\u02C6",
  tilde: "\u02DC",
  Alpha: "\u0391",
  Beta: "\u0392",
  Gamma: "\u0393",
  Delta: "\u0394",
  Epsilon: "\u0395",
  Zeta: "\u0396",
  Eta: "\u0397",
  Theta: "\u0398",
  Iota: "\u0399",
  Kappa: "\u039A",
  Lambda: "\u039B",
  Mu: "\u039C",
  Nu: "\u039D",
  Xi: "\u039E",
  Omicron: "\u039F",
  Pi: "\u03A0",
  Rho: "\u03A1",
  Sigma: "\u03A3",
  Tau: "\u03A4",
  Upsilon: "\u03A5",
  Phi: "\u03A6",
  Chi: "\u03A7",
  Psi: "\u03A8",
  Omega: "\u03A9",
  alpha: "\u03B1",
  beta: "\u03B2",
  gamma: "\u03B3",
  delta: "\u03B4",
  epsilon: "\u03B5",
  zeta: "\u03B6",
  eta: "\u03B7",
  theta: "\u03B8",
  iota: "\u03B9",
  kappa: "\u03BA",
  lambda: "\u03BB",
  mu: "\u03BC",
  nu: "\u03BD",
  xi: "\u03BE",
  omicron: "\u03BF",
  pi: "\u03C0",
  rho: "\u03C1",
  sigmaf: "\u03C2",
  sigma: "\u03C3",
  tau: "\u03C4",
  upsilon: "\u03C5",
  phi: "\u03C6",
  chi: "\u03C7",
  psi: "\u03C8",
  omega: "\u03C9",
  thetasym: "\u03D1",
  upsih: "\u03D2",
  piv: "\u03D6",
  ensp: "\u2002",
  emsp: "\u2003",
  thinsp: "\u2009",
  zwnj: "\u200C",
  zwj: "\u200D",
  lrm: "\u200E",
  rlm: "\u200F",
  ndash: "\u2013",
  mdash: "\u2014",
  lsquo: "\u2018",
  rsquo: "\u2019",
  sbquo: "\u201A",
  ldquo: "\u201C",
  rdquo: "\u201D",
  bdquo: "\u201E",
  dagger: "\u2020",
  Dagger: "\u2021",
  bull: "\u2022",
  hellip: "\u2026",
  permil: "\u2030",
  prime: "\u2032",
  Prime: "\u2033",
  lsaquo: "\u2039",
  rsaquo: "\u203A",
  oline: "\u203E",
  frasl: "\u2044",
  euro: "\u20AC",
  image: "\u2111",
  weierp: "\u2118",
  real: "\u211C",
  trade: "\u2122",
  alefsym: "\u2135",
  larr: "\u2190",
  uarr: "\u2191",
  rarr: "\u2192",
  darr: "\u2193",
  harr: "\u2194",
  crarr: "\u21B5",
  lArr: "\u21D0",
  uArr: "\u21D1",
  rArr: "\u21D2",
  dArr: "\u21D3",
  hArr: "\u21D4",
  forall: "\u2200",
  part: "\u2202",
  exist: "\u2203",
  empty: "\u2205",
  nabla: "\u2207",
  isin: "\u2208",
  notin: "\u2209",
  ni: "\u220B",
  prod: "\u220F",
  sum: "\u2211",
  minus: "\u2212",
  lowast: "\u2217",
  radic: "\u221A",
  prop: "\u221D",
  infin: "\u221E",
  ang: "\u2220",
  and: "\u2227",
  or: "\u2228",
  cap: "\u2229",
  cup: "\u222A",
  'int': "\u222B",
  there4: "\u2234",
  sim: "\u223C",
  cong: "\u2245",
  asymp: "\u2248",
  ne: "\u2260",
  equiv: "\u2261",
  le: "\u2264",
  ge: "\u2265",
  sub: "\u2282",
  sup: "\u2283",
  nsub: "\u2284",
  sube: "\u2286",
  supe: "\u2287",
  oplus: "\u2295",
  otimes: "\u2297",
  perp: "\u22A5",
  sdot: "\u22C5",
  lceil: "\u2308",
  rceil: "\u2309",
  lfloor: "\u230A",
  rfloor: "\u230B",
  lang: "\u2329",
  rang: "\u232A",
  loz: "\u25CA",
  spades: "\u2660",
  clubs: "\u2663",
  hearts: "\u2665",
  diams: "\u2666"
};
var hexNumber = /^[\da-fA-F]+$/;
var decimalNumber = /^\d+$/;
var tt = acorn.tokTypes;
var TokContext$1 = acorn.TokContext;
var tokContexts = acorn.tokContexts;
var TokenType$1 = acorn.TokenType;
var isNewLine$1 = acorn.isNewLine;
var isIdentifierStart$1 = acorn.isIdentifierStart;
var isIdentifierChar$1 = acorn.isIdentifierChar;
var tc_oTag = new TokContext$1('<tag', false);
var tc_cTag = new TokContext$1('</tag', false);
var tc_expr = new TokContext$1('<tag>...</tag>', true, true);
var tok = {
  jsxName: new TokenType$1('jsxName'),
  jsxText: new TokenType$1('jsxText', {
    beforeExpr: true
  }),
  jsxTagStart: new TokenType$1('jsxTagStart'),
  jsxTagEnd: new TokenType$1('jsxTagEnd')
};

tok.jsxTagStart.updateContext = function () {
  this.context.push(tc_expr); // treat as beginning of JSX expression

  this.context.push(tc_oTag); // start opening tag context

  this.exprAllowed = false;
};

tok.jsxTagEnd.updateContext = function (prevType) {
  var out = this.context.pop();

  if (out === tc_oTag && prevType === tt.slash || out === tc_cTag) {
    this.context.pop();
    this.exprAllowed = this.curContext() === tc_expr;
  } else {
    this.exprAllowed = true;
  }
}; // Transforms JSX element name to string.


function getQualifiedJSXName(object) {
  if (!object) {
    return object;
  }

  if (object.type === 'JSXIdentifier') {
    return object.name;
  }

  if (object.type === 'JSXNamespacedName') {
    return object.namespace.name + ':' + object.name.name;
  }

  if (object.type === 'JSXMemberExpression') {
    return getQualifiedJSXName(object.object) + '.' + getQualifiedJSXName(object.property);
  }
}

var acornJsx = function acornJsx(options) {
  if (options === void 0) options = {};
  return function (Parser) {
    return plugin({
      allowNamespaces: options.allowNamespaces !== false,
      allowNamespacedObjects: !!options.allowNamespacedObjects
    }, Parser);
  };
};

var tokTypes = tok;

function plugin(options, Parser) {
  return function (Parser) {
    function anonymous() {
      Parser.apply(this, arguments);
    }

    if (Parser) anonymous.__proto__ = Parser;
    anonymous.prototype = Object.create(Parser && Parser.prototype);
    anonymous.prototype.constructor = anonymous;

    anonymous.prototype.jsx_readToken = function jsx_readToken() {
      var this$1 = this;
      var out = '',
          chunkStart = this.pos;

      for (;;) {
        if (this$1.pos >= this$1.input.length) {
          this$1.raise(this$1.start, 'Unterminated JSX contents');
        }

        var ch = this$1.input.charCodeAt(this$1.pos);

        switch (ch) {
          case 60: // '<'

          case 123:
            // '{'
            if (this$1.pos === this$1.start) {
              if (ch === 60 && this$1.exprAllowed) {
                ++this$1.pos;
                return this$1.finishToken(tok.jsxTagStart);
              }

              return this$1.getTokenFromCode(ch);
            }

            out += this$1.input.slice(chunkStart, this$1.pos);
            return this$1.finishToken(tok.jsxText, out);

          case 38:
            // '&'
            out += this$1.input.slice(chunkStart, this$1.pos);
            out += this$1.jsx_readEntity();
            chunkStart = this$1.pos;
            break;

          default:
            if (isNewLine$1(ch)) {
              out += this$1.input.slice(chunkStart, this$1.pos);
              out += this$1.jsx_readNewLine(true);
              chunkStart = this$1.pos;
            } else {
              ++this$1.pos;
            }

        }
      }
    };

    anonymous.prototype.jsx_readNewLine = function jsx_readNewLine(normalizeCRLF) {
      var ch = this.input.charCodeAt(this.pos);
      var out;
      ++this.pos;

      if (ch === 13 && this.input.charCodeAt(this.pos) === 10) {
        ++this.pos;
        out = normalizeCRLF ? '\n' : '\r\n';
      } else {
        out = String.fromCharCode(ch);
      }

      if (this.options.locations) {
        ++this.curLine;
        this.lineStart = this.pos;
      }

      return out;
    };

    anonymous.prototype.jsx_readString = function jsx_readString(quote) {
      var this$1 = this;
      var out = '',
          chunkStart = ++this.pos;

      for (;;) {
        if (this$1.pos >= this$1.input.length) {
          this$1.raise(this$1.start, 'Unterminated string constant');
        }

        var ch = this$1.input.charCodeAt(this$1.pos);

        if (ch === quote) {
          break;
        }

        if (ch === 38) {
          // '&'
          out += this$1.input.slice(chunkStart, this$1.pos);
          out += this$1.jsx_readEntity();
          chunkStart = this$1.pos;
        } else if (isNewLine$1(ch)) {
          out += this$1.input.slice(chunkStart, this$1.pos);
          out += this$1.jsx_readNewLine(false);
          chunkStart = this$1.pos;
        } else {
          ++this$1.pos;
        }
      }

      out += this.input.slice(chunkStart, this.pos++);
      return this.finishToken(tt.string, out);
    };

    anonymous.prototype.jsx_readEntity = function jsx_readEntity() {
      var this$1 = this;
      var str = '',
          count = 0,
          entity;
      var ch = this.input[this.pos];

      if (ch !== '&') {
        this.raise(this.pos, 'Entity must start with an ampersand');
      }

      var startPos = ++this.pos;

      while (this.pos < this.input.length && count++ < 10) {
        ch = this$1.input[this$1.pos++];

        if (ch === ';') {
          if (str[0] === '#') {
            if (str[1] === 'x') {
              str = str.substr(2);

              if (hexNumber.test(str)) {
                entity = String.fromCharCode(parseInt(str, 16));
              }
            } else {
              str = str.substr(1);

              if (decimalNumber.test(str)) {
                entity = String.fromCharCode(parseInt(str, 10));
              }
            }
          } else {
            entity = xhtml[str];
          }

          break;
        }

        str += ch;
      }

      if (!entity) {
        this.pos = startPos;
        return '&';
      }

      return entity;
    }; // Read a JSX identifier (valid tag or attribute name).
    //
    // Optimized version since JSX identifiers can't contain
    // escape characters and so can be read as single slice.
    // Also assumes that first character was already checked
    // by isIdentifierStart in readToken.


    anonymous.prototype.jsx_readWord = function jsx_readWord() {
      var this$1 = this;
      var ch,
          start = this.pos;

      do {
        ch = this$1.input.charCodeAt(++this$1.pos);
      } while (isIdentifierChar$1(ch) || ch === 45); // '-'


      return this.finishToken(tok.jsxName, this.input.slice(start, this.pos));
    }; // Parse next token as JSX identifier


    anonymous.prototype.jsx_parseIdentifier = function jsx_parseIdentifier() {
      var node = this.startNode();

      if (this.type === tok.jsxName) {
        node.name = this.value;
      } else if (this.type.keyword) {
        node.name = this.type.keyword;
      } else {
        this.unexpected();
      }

      this.next();
      return this.finishNode(node, 'JSXIdentifier');
    }; // Parse namespaced identifier.


    anonymous.prototype.jsx_parseNamespacedName = function jsx_parseNamespacedName() {
      var startPos = this.start,
          startLoc = this.startLoc;
      var name = this.jsx_parseIdentifier();

      if (!options.allowNamespaces || !this.eat(tt.colon)) {
        return name;
      }

      var node = this.startNodeAt(startPos, startLoc);
      node.namespace = name;
      node.name = this.jsx_parseIdentifier();
      return this.finishNode(node, 'JSXNamespacedName');
    }; // Parses element name in any form - namespaced, member
    // or single identifier.


    anonymous.prototype.jsx_parseElementName = function jsx_parseElementName() {
      var this$1 = this;

      if (this.type === tok.jsxTagEnd) {
        return '';
      }

      var startPos = this.start,
          startLoc = this.startLoc;
      var node = this.jsx_parseNamespacedName();

      if (this.type === tt.dot && node.type === 'JSXNamespacedName' && !options.allowNamespacedObjects) {
        this.unexpected();
      }

      while (this.eat(tt.dot)) {
        var newNode = this$1.startNodeAt(startPos, startLoc);
        newNode.object = node;
        newNode.property = this$1.jsx_parseIdentifier();
        node = this$1.finishNode(newNode, 'JSXMemberExpression');
      }

      return node;
    }; // Parses any type of JSX attribute value.


    anonymous.prototype.jsx_parseAttributeValue = function jsx_parseAttributeValue() {
      switch (this.type) {
        case tt.braceL:
          var node = this.jsx_parseExpressionContainer();

          if (node.expression.type === 'JSXEmptyExpression') {
            this.raise(node.start, 'JSX attributes must only be assigned a non-empty expression');
          }

          return node;

        case tok.jsxTagStart:
        case tt.string:
          return this.parseExprAtom();

        default:
          this.raise(this.start, 'JSX value should be either an expression or a quoted JSX text');
      }
    }; // JSXEmptyExpression is unique type since it doesn't actually parse anything,
    // and so it should start at the end of last read token (left brace) and finish
    // at the beginning of the next one (right brace).


    anonymous.prototype.jsx_parseEmptyExpression = function jsx_parseEmptyExpression() {
      var node = this.startNodeAt(this.lastTokEnd, this.lastTokEndLoc);
      return this.finishNodeAt(node, 'JSXEmptyExpression', this.start, this.startLoc);
    }; // Parses JSX expression enclosed into curly brackets.


    anonymous.prototype.jsx_parseExpressionContainer = function jsx_parseExpressionContainer() {
      var node = this.startNode();
      this.next();
      node.expression = this.type === tt.braceR ? this.jsx_parseEmptyExpression() : this.parseExpression();
      this.expect(tt.braceR);
      return this.finishNode(node, 'JSXExpressionContainer');
    }; // Parses following JSX attribute name-value pair.


    anonymous.prototype.jsx_parseAttribute = function jsx_parseAttribute() {
      var node = this.startNode();

      if (this.eat(tt.braceL)) {
        this.expect(tt.ellipsis);
        node.argument = this.parseMaybeAssign();
        this.expect(tt.braceR);
        return this.finishNode(node, 'JSXSpreadAttribute');
      }

      node.name = this.jsx_parseNamespacedName();
      node.value = this.eat(tt.eq) ? this.jsx_parseAttributeValue() : null;
      return this.finishNode(node, 'JSXAttribute');
    }; // Parses JSX opening tag starting after '<'.


    anonymous.prototype.jsx_parseOpeningElementAt = function jsx_parseOpeningElementAt(startPos, startLoc) {
      var this$1 = this;
      var node = this.startNodeAt(startPos, startLoc);
      node.attributes = [];
      var nodeName = this.jsx_parseElementName();

      if (nodeName) {
        node.name = nodeName;
      }

      while (this.type !== tt.slash && this.type !== tok.jsxTagEnd) {
        node.attributes.push(this$1.jsx_parseAttribute());
      }

      node.selfClosing = this.eat(tt.slash);
      this.expect(tok.jsxTagEnd);
      return this.finishNode(node, nodeName ? 'JSXOpeningElement' : 'JSXOpeningFragment');
    }; // Parses JSX closing tag starting after '</'.


    anonymous.prototype.jsx_parseClosingElementAt = function jsx_parseClosingElementAt(startPos, startLoc) {
      var node = this.startNodeAt(startPos, startLoc);
      var nodeName = this.jsx_parseElementName();

      if (nodeName) {
        node.name = nodeName;
      }

      this.expect(tok.jsxTagEnd);
      return this.finishNode(node, nodeName ? 'JSXClosingElement' : 'JSXClosingFragment');
    }; // Parses entire JSX element, including it's opening tag
    // (starting after '<'), attributes, contents and closing tag.


    anonymous.prototype.jsx_parseElementAt = function jsx_parseElementAt(startPos, startLoc) {
      var this$1 = this;
      var node = this.startNodeAt(startPos, startLoc);
      var children = [];
      var openingElement = this.jsx_parseOpeningElementAt(startPos, startLoc);
      var closingElement = null;

      if (!openingElement.selfClosing) {
        contents: for (;;) {
          switch (this$1.type) {
            case tok.jsxTagStart:
              startPos = this$1.start;
              startLoc = this$1.startLoc;
              this$1.next();

              if (this$1.eat(tt.slash)) {
                closingElement = this$1.jsx_parseClosingElementAt(startPos, startLoc);
                break contents;
              }

              children.push(this$1.jsx_parseElementAt(startPos, startLoc));
              break;

            case tok.jsxText:
              children.push(this$1.parseExprAtom());
              break;

            case tt.braceL:
              children.push(this$1.jsx_parseExpressionContainer());
              break;

            default:
              this$1.unexpected();
          }
        }

        if (getQualifiedJSXName(closingElement.name) !== getQualifiedJSXName(openingElement.name)) {
          this.raise(closingElement.start, 'Expected corresponding JSX closing tag for <' + getQualifiedJSXName(openingElement.name) + '>');
        }
      }

      var fragmentOrElement = openingElement.name ? 'Element' : 'Fragment';
      node['opening' + fragmentOrElement] = openingElement;
      node['closing' + fragmentOrElement] = closingElement;
      node.children = children;

      if (this.type === tt.relational && this.value === "<") {
        this.raise(this.start, "Adjacent JSX elements must be wrapped in an enclosing tag");
      }

      return this.finishNode(node, 'JSX' + fragmentOrElement);
    }; // Parse JSX text


    anonymous.prototype.jsx_parseText = function jsx_parseText(value) {
      var node = this.parseLiteral(value);
      node.type = "JSXText";
      return node;
    }; // Parses entire JSX element from current position.


    anonymous.prototype.jsx_parseElement = function jsx_parseElement() {
      var startPos = this.start,
          startLoc = this.startLoc;
      this.next();
      return this.jsx_parseElementAt(startPos, startLoc);
    };

    anonymous.prototype.parseExprAtom = function parseExprAtom(refShortHandDefaultPos) {
      if (this.type === tok.jsxText) {
        return this.jsx_parseText(this.value);
      } else if (this.type === tok.jsxTagStart) {
        return this.jsx_parseElement();
      } else {
        return Parser.prototype.parseExprAtom.call(this, refShortHandDefaultPos);
      }
    };

    anonymous.prototype.readToken = function readToken(code) {
      var context = this.curContext();

      if (context === tc_expr) {
        return this.jsx_readToken();
      }

      if (context === tc_oTag || context === tc_cTag) {
        if (isIdentifierStart$1(code)) {
          return this.jsx_readWord();
        }

        if (code == 62) {
          ++this.pos;
          return this.finishToken(tok.jsxTagEnd);
        }

        if ((code === 34 || code === 39) && context == tc_oTag) {
          return this.jsx_readString(code);
        }
      }

      if (code === 60 && this.exprAllowed && this.input.charCodeAt(this.pos + 1) !== 33) {
        ++this.pos;
        return this.finishToken(tok.jsxTagStart);
      }

      return Parser.prototype.readToken.call(this, code);
    };

    anonymous.prototype.updateContext = function updateContext(prevType) {
      if (this.type == tt.braceL) {
        var curContext = this.curContext();

        if (curContext == tc_oTag) {
          this.context.push(tokContexts.b_expr);
        } else if (curContext == tc_expr) {
          this.context.push(tokContexts.b_tmpl);
        } else {
          Parser.prototype.updateContext.call(this, prevType);
        }

        this.exprAllowed = true;
      } else if (this.type === tt.slash && prevType === tok.jsxTagStart) {
        this.context.length -= 2; // do not consider JSX expr -> JSX open tag -> ... anymore

        this.context.push(tc_cTag); // reconsider as closing tag context

        this.exprAllowed = false;
      } else {
        return Parser.prototype.updateContext.call(this, prevType);
      }
    };

    return anonymous;
  }(Parser);
}

acornJsx.tokTypes = tokTypes;

function unwrapExports(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}

var lib = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.DynamicImportKey = undefined;

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _get = function () {
    function get(object, property, receiver) {
      if (object === null) object = Function.prototype;
      var desc = Object.getOwnPropertyDescriptor(object, property);

      if (desc === undefined) {
        var parent = Object.getPrototypeOf(object);

        if (parent === null) {
          return undefined;
        } else {
          return get(parent, property, receiver);
        }
      } else if ("value" in desc) {
        return desc.value;
      } else {
        var getter = desc.get;

        if (getter === undefined) {
          return undefined;
        }

        return getter.call(receiver);
      }
    }

    return get;
  }();

  exports['default'] = dynamicImport;

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  /* eslint-disable no-underscore-dangle */


  var DynamicImportKey = exports.DynamicImportKey = 'Import'; // NOTE: This allows `yield import()` to parse correctly.

  acorn.tokTypes._import.startsExpr = true;

  function parseDynamicImport() {
    var node = this.startNode();
    this.next();

    if (this.type !== acorn.tokTypes.parenL) {
      this.unexpected();
    }

    return this.finishNode(node, DynamicImportKey);
  }

  function parenAfter() {
    return /^(\s|\/\/.*|\/\*[^]*?\*\/)*\(/.test(this.input.slice(this.pos));
  }

  function dynamicImport(Parser) {
    return function (_Parser) {
      _inherits(_class, _Parser);

      function _class() {
        _classCallCheck(this, _class);

        return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
      }

      _createClass(_class, [{
        key: 'parseStatement',
        value: function () {
          function parseStatement(context, topLevel, exports) {
            if (this.type === acorn.tokTypes._import && parenAfter.call(this)) {
              return this.parseExpressionStatement(this.startNode(), this.parseExpression());
            }

            return _get(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), 'parseStatement', this).call(this, context, topLevel, exports);
          }

          return parseStatement;
        }()
      }, {
        key: 'parseExprAtom',
        value: function () {
          function parseExprAtom(refDestructuringErrors) {
            if (this.type === acorn.tokTypes._import) {
              return parseDynamicImport.call(this);
            }

            return _get(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), 'parseExprAtom', this).call(this, refDestructuringErrors);
          }

          return parseExprAtom;
        }()
      }]);

      return _class;
    }(Parser);
  }
});
var acornDynamicImport = unwrapExports(lib);
var lib_1 = lib.DynamicImportKey; // used for debugging, without the noise created by
// circular references

function toJSON(node) {
  var obj = {};
  Object.keys(node).forEach(function (key) {
    if (key === 'parent' || key === 'program' || key === 'keys' || key === '__wrapped') {
      return;
    }

    if (Array.isArray(node[key])) {
      obj[key] = node[key].map(toJSON);
    } else if (node[key] && node[key].toJSON) {
      obj[key] = node[key].toJSON();
    } else {
      obj[key] = node[key];
    }
  });
  return obj;
}

var Node$1 = function Node() {};

Node$1.prototype.ancestor = function ancestor(level) {
  var node = this;

  while (level--) {
    node = node.parent;

    if (!node) {
      return null;
    }
  }

  return node;
};

Node$1.prototype.contains = function contains(node) {
  var this$1 = this;

  while (node) {
    if (node === this$1) {
      return true;
    }

    node = node.parent;
  }

  return false;
};

Node$1.prototype.findLexicalBoundary = function findLexicalBoundary() {
  return this.parent.findLexicalBoundary();
};

Node$1.prototype.findNearest = function findNearest(type) {
  if (typeof type === 'string') {
    type = new RegExp("^" + type + "$");
  }

  if (type.test(this.type)) {
    return this;
  }

  return this.parent.findNearest(type);
};

Node$1.prototype.unparenthesizedParent = function unparenthesizedParent() {
  var node = this.parent;

  while (node && node.type === 'ParenthesizedExpression') {
    node = node.parent;
  }

  return node;
};

Node$1.prototype.unparenthesize = function unparenthesize() {
  var node = this;

  while (node.type === 'ParenthesizedExpression') {
    node = node.expression;
  }

  return node;
};

Node$1.prototype.findScope = function findScope(functionScope) {
  return this.parent.findScope(functionScope);
};

Node$1.prototype.getIndentation = function getIndentation() {
  return this.parent.getIndentation();
};

Node$1.prototype.initialise = function initialise(transforms) {
  var this$1 = this;

  for (var i = 0, list = this$1.keys; i < list.length; i += 1) {
    var key = list[i];
    var value = this$1[key];

    if (Array.isArray(value)) {
      value.forEach(function (node) {
        return node && node.initialise(transforms);
      });
    } else if (value && typeof value === 'object') {
      value.initialise(transforms);
    }
  }
};

Node$1.prototype.toJSON = function toJSON$1() {
  return toJSON(this);
};

Node$1.prototype.toString = function toString() {
  return this.program.magicString.original.slice(this.start, this.end);
};

Node$1.prototype.transpile = function transpile(code, transforms) {
  var this$1 = this;

  for (var i = 0, list = this$1.keys; i < list.length; i += 1) {
    var key = list[i];
    var value = this$1[key];

    if (Array.isArray(value)) {
      value.forEach(function (node) {
        return node && node.transpile(code, transforms);
      });
    } else if (value && typeof value === 'object') {
      value.transpile(code, transforms);
    }
  }
};

function extractNames(node) {
  var names = [];
  extractors[node.type](names, node);
  return names;
}

var extractors = {
  Identifier: function Identifier(names, node) {
    names.push(node);
  },
  ObjectPattern: function ObjectPattern(names, node) {
    for (var i = 0, list = node.properties; i < list.length; i += 1) {
      var prop = list[i];
      extractors[prop.type](names, prop);
    }
  },
  Property: function Property(names, node) {
    extractors[node.value.type](names, node.value);
  },
  ArrayPattern: function ArrayPattern(names, node) {
    for (var i = 0, list = node.elements; i < list.length; i += 1) {
      var element = list[i];

      if (element) {
        extractors[element.type](names, element);
      }
    }
  },
  RestElement: function RestElement(names, node) {
    extractors[node.argument.type](names, node.argument);
  },
  AssignmentPattern: function AssignmentPattern(names, node) {
    extractors[node.left.type](names, node.left);
  }
};
var reserved = Object.create(null);
'do if in for let new try var case else enum eval null this true void with await break catch class const false super throw while yield delete export import public return static switch typeof default extends finally package private continue debugger function arguments interface protected implements instanceof'.split(' ').forEach(function (word) {
  return reserved[word] = true;
});

function Scope$1(options) {
  options = options || {};
  this.parent = options.parent;
  this.isBlockScope = !!options.block;
  this.createDeclarationCallback = options.declare;
  var scope = this;

  while (scope.isBlockScope) {
    scope = scope.parent;
  }

  this.functionScope = scope;
  this.identifiers = [];
  this.declarations = Object.create(null);
  this.references = Object.create(null);
  this.blockScopedDeclarations = this.isBlockScope ? null : Object.create(null);
  this.aliases = Object.create(null);
}

Scope$1.prototype = {
  addDeclaration: function addDeclaration(node, kind) {
    var this$1 = this;

    for (var i = 0, list = extractNames(node); i < list.length; i += 1) {
      var identifier = list[i];
      var name = identifier.name;
      var declaration = {
        name: name,
        node: identifier,
        kind: kind,
        instances: []
      };
      this$1.declarations[name] = declaration;

      if (this$1.isBlockScope) {
        if (!this$1.functionScope.blockScopedDeclarations[name]) {
          this$1.functionScope.blockScopedDeclarations[name] = [];
        }

        this$1.functionScope.blockScopedDeclarations[name].push(declaration);
      }
    }
  },
  addReference: function addReference(identifier) {
    if (this.consolidated) {
      this.consolidateReference(identifier);
    } else {
      this.identifiers.push(identifier);
    }
  },
  consolidate: function consolidate() {
    var this$1 = this;

    for (var i = 0; i < this.identifiers.length; i += 1) {
      // we might push to the array during consolidation, so don't cache length
      var identifier = this$1.identifiers[i];
      this$1.consolidateReference(identifier);
    }

    this.consolidated = true; // TODO understand why this is necessary... seems bad
  },
  consolidateReference: function consolidateReference(identifier) {
    var declaration = this.declarations[identifier.name];

    if (declaration) {
      declaration.instances.push(identifier);
    } else {
      this.references[identifier.name] = true;

      if (this.parent) {
        this.parent.addReference(identifier);
      }
    }
  },
  contains: function contains(name) {
    return this.declarations[name] || (this.parent ? this.parent.contains(name) : false);
  },
  createIdentifier: function createIdentifier(base) {
    if (typeof base === 'number') {
      base = base.toString();
    }

    base = base.replace(/\s/g, '').replace(/\[([^\]]+)\]/g, '_$1').replace(/[^a-zA-Z0-9_$]/g, '_').replace(/_{2,}/, '_');
    var name = base;
    var counter = 1;

    while (this.declarations[name] || this.references[name] || this.aliases[name] || name in reserved) {
      name = base + "$" + counter++;
    }

    this.aliases[name] = true;
    return name;
  },
  createDeclaration: function createDeclaration(base) {
    var id = this.createIdentifier(base);
    this.createDeclarationCallback(id);
    return id;
  },
  findDeclaration: function findDeclaration(name) {
    return this.declarations[name] || this.parent && this.parent.findDeclaration(name);
  },
  // Sometimes, block scope declarations change name during transpilation
  resolveName: function resolveName(name) {
    var declaration = this.findDeclaration(name);
    return declaration ? declaration.name : name;
  }
};

function locate(source, index) {
  var lines = source.split('\n');
  var len = lines.length;
  var lineStart = 0;
  var i;

  for (i = 0; i < len; i += 1) {
    var line = lines[i];
    var lineEnd = lineStart + line.length + 1; // +1 for newline

    if (lineEnd > index) {
      return {
        line: i + 1,
        column: index - lineStart,
        "char": i
      };
    }

    lineStart = lineEnd;
  }

  throw new Error('Could not determine location of character');
}

function pad(num, len) {
  var result = String(num);
  return result + repeat(' ', len - result.length);
}

function repeat(str, times) {
  var result = '';

  while (times--) {
    result += str;
  }

  return result;
}

function getSnippet(source, loc, length) {
  if (length === void 0) length = 1;
  var first = Math.max(loc.line - 5, 0);
  var last = loc.line;
  var numDigits = String(last).length;
  var lines = source.split('\n').slice(first, last);
  var lastLine = lines[lines.length - 1];
  var offset = lastLine.slice(0, loc.column).replace(/\t/g, '  ').length;
  var snippet = lines.map(function (line, i) {
    return pad(i + first + 1, numDigits) + " : " + line.replace(/\t/g, '  ');
  }).join('\n');
  snippet += '\n' + repeat(' ', numDigits + 3 + offset) + repeat('^', length);
  return snippet;
}

var CompileError = function (Error) {
  function CompileError(message, node) {
    Error.call(this, message);
    this.name = 'CompileError';

    if (!node) {
      return;
    }

    var source = node.program.magicString.original;
    var loc = locate(source, node.start);
    this.message = message + " (" + loc.line + ":" + loc.column + ")";
    this.stack = new Error().stack.replace(new RegExp(".+new " + this.name + ".+\\n", 'm'), '');
    this.loc = loc;
    this.snippet = getSnippet(source, loc, node.end - node.start);
  }

  if (Error) CompileError.__proto__ = Error;
  CompileError.prototype = Object.create(Error && Error.prototype);
  CompileError.prototype.constructor = CompileError;

  CompileError.prototype.toString = function toString() {
    return this.name + ": " + this.message + "\n" + this.snippet;
  };

  return CompileError;
}(Error);

function findIndex(array, fn) {
  for (var i = 0; i < array.length; i += 1) {
    if (fn(array[i], i)) {
      return i;
    }
  }

  return -1;
}

var handlers = {
  Identifier: destructureIdentifier,
  AssignmentPattern: destructureAssignmentPattern,
  ArrayPattern: destructureArrayPattern,
  ObjectPattern: destructureObjectPattern
};

function destructure(code, createIdentifier, resolveName, node, ref, inline, statementGenerators) {
  handlers[node.type](code, createIdentifier, resolveName, node, ref, inline, statementGenerators);
}

function destructureIdentifier(code, createIdentifier, resolveName, node, ref, inline, statementGenerators) {
  statementGenerators.push(function (start, prefix, suffix) {
    code.overwrite(node.start, node.end, (inline ? prefix : prefix + "var ") + resolveName(node) + " = " + ref + suffix);
    code.move(node.start, node.end, start);
  });
}

function destructureMemberExpression(code, createIdentifier, resolveName, node, ref, inline, statementGenerators) {
  statementGenerators.push(function (start, prefix, suffix) {
    code.prependRight(node.start, inline ? prefix : prefix + "var ");
    code.appendLeft(node.end, " = " + ref + suffix);
    code.move(node.start, node.end, start);
  });
}

function destructureAssignmentPattern(code, createIdentifier, resolveName, node, ref, inline, statementGenerators) {
  var isIdentifier = node.left.type === 'Identifier';
  var name = isIdentifier ? node.left.name : ref;

  if (!inline) {
    statementGenerators.push(function (start, prefix, suffix) {
      code.prependRight(node.left.end, prefix + "if ( " + name + " === void 0 ) " + name);
      code.move(node.left.end, node.right.end, start);
      code.appendLeft(node.right.end, suffix);
    });
  }

  if (!isIdentifier) {
    destructure(code, createIdentifier, resolveName, node.left, ref, inline, statementGenerators);
  }
}

function destructureArrayPattern(code, createIdentifier, resolveName, node, ref, inline, statementGenerators) {
  var c = node.start;
  node.elements.forEach(function (element, i) {
    if (!element) {
      return;
    }

    if (element.type === 'RestElement') {
      handleProperty(code, createIdentifier, resolveName, c, element.argument, ref + ".slice(" + i + ")", inline, statementGenerators);
    } else {
      handleProperty(code, createIdentifier, resolveName, c, element, ref + "[" + i + "]", inline, statementGenerators);
    }

    c = element.end;
  });
  code.remove(c, node.end);
}

function destructureObjectPattern(code, createIdentifier, resolveName, node, ref, inline, statementGenerators) {
  var this$1 = this;
  var c = node.start;
  var nonRestKeys = [];
  node.properties.forEach(function (prop) {
    var value;
    var content;

    if (prop.type === 'Property') {
      var isComputedKey = prop.computed || prop.key.type !== 'Identifier';
      var key = isComputedKey ? code.slice(prop.key.start, prop.key.end) : prop.key.name;
      value = isComputedKey ? ref + "[" + key + "]" : ref + "." + key;
      content = prop.value;
      nonRestKeys.push(isComputedKey ? key : '"' + key + '"');
    } else if (prop.type === 'RestElement') {
      content = prop.argument;
      value = createIdentifier('rest');
      statementGenerators.push(function (start, prefix, suffix) {
        var helper = prop.program.getObjectWithoutPropertiesHelper(code);
        code.overwrite(prop.start, c = prop.argument.start, (inline ? prefix : prefix + "var ") + value + " = " + helper + "( " + ref + ", [" + nonRestKeys.join(', ') + "] )" + suffix);
        code.move(prop.start, c, start);
      });
    } else {
      throw new CompileError(this$1, "Unexpected node of type " + prop.type + " in object pattern");
    }

    handleProperty(code, createIdentifier, resolveName, c, content, value, inline, statementGenerators);
    c = prop.end;
  });
  code.remove(c, node.end);
}

function handleProperty(code, createIdentifier, resolveName, c, node, value, inline, statementGenerators) {
  switch (node.type) {
    case 'Identifier':
      {
        code.remove(c, node.start);
        destructureIdentifier(code, createIdentifier, resolveName, node, value, inline, statementGenerators);
        break;
      }

    case 'MemberExpression':
      code.remove(c, node.start);
      destructureMemberExpression(code, createIdentifier, resolveName, node, value, true, statementGenerators);
      break;

    case 'AssignmentPattern':
      {
        var name;
        var isIdentifier = node.left.type === 'Identifier';

        if (isIdentifier) {
          name = resolveName(node.left);
        } else {
          name = createIdentifier(value);
        }

        statementGenerators.push(function (start, prefix, suffix) {
          if (inline) {
            code.prependRight(node.right.start, name + " = " + value + ", " + name + " = " + name + " === void 0 ? ");
            code.appendLeft(node.right.end, " : " + name + suffix);
          } else {
            code.prependRight(node.right.start, prefix + "var " + name + " = " + value + "; if ( " + name + " === void 0 ) " + name + " = ");
            code.appendLeft(node.right.end, suffix);
          }

          code.move(node.right.start, node.right.end, start);
        });

        if (isIdentifier) {
          code.remove(c, node.right.start);
        } else {
          code.remove(c, node.left.start);
          code.remove(node.left.end, node.right.start);
          handleProperty(code, createIdentifier, resolveName, c, node.left, name, inline, statementGenerators);
        }

        break;
      }

    case 'ObjectPattern':
      {
        code.remove(c, c = node.start);
        var ref = value;

        if (node.properties.length > 1) {
          ref = createIdentifier(value);
          statementGenerators.push(function (start, prefix, suffix) {
            // this feels a tiny bit hacky, but we can't do a
            // straightforward appendLeft and keep correct order...
            code.prependRight(node.start, (inline ? '' : prefix + "var ") + ref + " = ");
            code.overwrite(node.start, c = node.start + 1, value);
            code.appendLeft(c, suffix);
            code.overwrite(node.start, c = node.start + 1, (inline ? '' : prefix + "var ") + ref + " = " + value + suffix);
            code.move(node.start, c, start);
          });
        }

        destructureObjectPattern(code, createIdentifier, resolveName, node, ref, inline, statementGenerators);
        break;
      }

    case 'ArrayPattern':
      {
        code.remove(c, c = node.start);

        if (node.elements.filter(Boolean).length > 1) {
          var ref$1 = createIdentifier(value);
          statementGenerators.push(function (start, prefix, suffix) {
            code.prependRight(node.start, (inline ? '' : prefix + "var ") + ref$1 + " = ");
            code.overwrite(node.start, c = node.start + 1, value, {
              contentOnly: true
            });
            code.appendLeft(c, suffix);
            code.move(node.start, c, start);
          });
          node.elements.forEach(function (element, i) {
            if (!element) {
              return;
            }

            if (element.type === 'RestElement') {
              handleProperty(code, createIdentifier, resolveName, c, element.argument, ref$1 + ".slice(" + i + ")", inline, statementGenerators);
            } else {
              handleProperty(code, createIdentifier, resolveName, c, element, ref$1 + "[" + i + "]", inline, statementGenerators);
            }

            c = element.end;
          });
        } else {
          var index = findIndex(node.elements, Boolean);
          var element = node.elements[index];

          if (element.type === 'RestElement') {
            handleProperty(code, createIdentifier, resolveName, c, element.argument, value + ".slice(" + index + ")", inline, statementGenerators);
          } else {
            handleProperty(code, createIdentifier, resolveName, c, element, value + "[" + index + "]", inline, statementGenerators);
          }

          c = element.end;
        }

        code.remove(c, node.end);
        break;
      }

    default:
      {
        throw new Error("Unexpected node type in destructuring (" + node.type + ")");
      }
  }
}

function isUseStrict(node) {
  if (!node) {
    return false;
  }

  if (node.type !== 'ExpressionStatement') {
    return false;
  }

  if (node.expression.type !== 'Literal') {
    return false;
  }

  return node.expression.value === 'use strict';
}

var BlockStatement = function (Node) {
  function BlockStatement() {
    Node.apply(this, arguments);
  }

  if (Node) BlockStatement.__proto__ = Node;
  BlockStatement.prototype = Object.create(Node && Node.prototype);
  BlockStatement.prototype.constructor = BlockStatement;

  BlockStatement.prototype.createScope = function createScope() {
    var this$1 = this;
    this.parentIsFunction = /Function/.test(this.parent.type);
    this.isFunctionBlock = this.parentIsFunction || this.parent.type === 'Root';
    this.scope = new Scope$1({
      block: !this.isFunctionBlock,
      parent: this.parent.findScope(false),
      declare: function declare(id) {
        return this$1.createdDeclarations.push(id);
      }
    });

    if (this.parentIsFunction) {
      this.parent.params.forEach(function (node) {
        this$1.scope.addDeclaration(node, 'param');
      });
    }
  };

  BlockStatement.prototype.initialise = function initialise(transforms) {
    this.thisAlias = null;
    this.argumentsAlias = null;
    this.defaultParameters = [];
    this.createdDeclarations = []; // normally the scope gets created here, during initialisation,
    // but in some cases (e.g. `for` statements), we need to create
    // the scope early, as it pertains to both the init block and
    // the body of the statement

    if (!this.scope) {
      this.createScope();
    }

    this.body.forEach(function (node) {
      return node.initialise(transforms);
    });
    this.scope.consolidate();
  };

  BlockStatement.prototype.findLexicalBoundary = function findLexicalBoundary() {
    if (this.type === 'Program') {
      return this;
    }

    if (/^Function/.test(this.parent.type)) {
      return this;
    }

    return this.parent.findLexicalBoundary();
  };

  BlockStatement.prototype.findScope = function findScope(functionScope) {
    if (functionScope && !this.isFunctionBlock) {
      return this.parent.findScope(functionScope);
    }

    return this.scope;
  };

  BlockStatement.prototype.getArgumentsAlias = function getArgumentsAlias() {
    if (!this.argumentsAlias) {
      this.argumentsAlias = this.scope.createIdentifier('arguments');
    }

    return this.argumentsAlias;
  };

  BlockStatement.prototype.getArgumentsArrayAlias = function getArgumentsArrayAlias() {
    if (!this.argumentsArrayAlias) {
      this.argumentsArrayAlias = this.scope.createIdentifier('argsArray');
    }

    return this.argumentsArrayAlias;
  };

  BlockStatement.prototype.getThisAlias = function getThisAlias() {
    if (!this.thisAlias) {
      this.thisAlias = this.scope.createIdentifier('this');
    }

    return this.thisAlias;
  };

  BlockStatement.prototype.getIndentation = function getIndentation() {
    var this$1 = this;

    if (this.indentation === undefined) {
      var source = this.program.magicString.original;
      var useOuter = this.synthetic || !this.body.length;
      var c = useOuter ? this.start : this.body[0].start;

      while (c && source[c] !== '\n') {
        c -= 1;
      }

      this.indentation = ''; // eslint-disable-next-line no-constant-condition

      while (true) {
        c += 1;
        var _char = source[c];

        if (_char !== ' ' && _char !== '\t') {
          break;
        }

        this$1.indentation += _char;
      }

      var indentString = this.program.magicString.getIndentString(); // account for dedented class constructors

      var parent = this.parent;

      while (parent) {
        if (parent.kind === 'constructor' && !parent.parent.parent.superClass) {
          this$1.indentation = this$1.indentation.replace(indentString, '');
        }

        parent = parent.parent;
      }

      if (useOuter) {
        this.indentation += indentString;
      }
    }

    return this.indentation;
  };

  BlockStatement.prototype.transpile = function transpile(code, transforms) {
    var this$1 = this;
    var indentation = this.getIndentation();
    var introStatementGenerators = [];

    if (this.argumentsAlias) {
      introStatementGenerators.push(function (start, prefix, suffix) {
        var assignment = prefix + "var " + this$1.argumentsAlias + " = arguments" + suffix;
        code.appendLeft(start, assignment);
      });
    }

    if (this.thisAlias) {
      introStatementGenerators.push(function (start, prefix, suffix) {
        var assignment = prefix + "var " + this$1.thisAlias + " = this" + suffix;
        code.appendLeft(start, assignment);
      });
    }

    if (this.argumentsArrayAlias) {
      introStatementGenerators.push(function (start, prefix, suffix) {
        var i = this$1.scope.createIdentifier('i');
        var assignment = prefix + "var " + i + " = arguments.length, " + this$1.argumentsArrayAlias + " = Array(" + i + ");\n" + indentation + "while ( " + i + "-- ) " + this$1.argumentsArrayAlias + "[" + i + "] = arguments[" + i + "]" + suffix;
        code.appendLeft(start, assignment);
      });
    }

    if (/Function/.test(this.parent.type)) {
      this.transpileParameters(this.parent.params, code, transforms, indentation, introStatementGenerators);
    } else if ('CatchClause' === this.parent.type) {
      this.transpileParameters([this.parent.param], code, transforms, indentation, introStatementGenerators);
    }

    if (transforms.letConst && this.isFunctionBlock) {
      this.transpileBlockScopedIdentifiers(code);
    }

    Node.prototype.transpile.call(this, code, transforms);

    if (this.createdDeclarations.length) {
      introStatementGenerators.push(function (start, prefix, suffix) {
        var assignment = prefix + "var " + this$1.createdDeclarations.join(', ') + suffix;
        code.appendLeft(start, assignment);
      });
    }

    if (this.synthetic) {
      if (this.parent.type === 'ArrowFunctionExpression') {
        var expr = this.body[0];

        if (introStatementGenerators.length) {
          code.appendLeft(this.start, "{").prependRight(this.end, this.parent.getIndentation() + "}");
          code.prependRight(expr.start, "\n" + indentation + "return ");
          code.appendLeft(expr.end, ";\n");
        } else if (transforms.arrow) {
          code.prependRight(expr.start, "{ return ");
          code.appendLeft(expr.end, "; }");
        }
      } else if (introStatementGenerators.length) {
        code.prependRight(this.start, "{").appendLeft(this.end, "}");
      }
    }

    var start;

    if (isUseStrict(this.body[0])) {
      start = this.body[0].end;
    } else if (this.synthetic || this.parent.type === 'Root') {
      start = this.start;
    } else {
      start = this.start + 1;
    }

    var prefix = "\n" + indentation;
    var suffix = ';';
    introStatementGenerators.forEach(function (fn, i) {
      if (i === introStatementGenerators.length - 1) {
        suffix = ";\n";
      }

      fn(start, prefix, suffix);
    });
  };

  BlockStatement.prototype.transpileParameters = function transpileParameters(params, code, transforms, indentation, introStatementGenerators) {
    var this$1 = this;
    params.forEach(function (param) {
      if (param.type === 'AssignmentPattern' && param.left.type === 'Identifier') {
        if (transforms.defaultParameter) {
          introStatementGenerators.push(function (start, prefix, suffix) {
            var lhs = prefix + "if ( " + param.left.name + " === void 0 ) " + param.left.name;
            code.prependRight(param.left.end, lhs).move(param.left.end, param.right.end, start).appendLeft(param.right.end, suffix);
          });
        }
      } else if (param.type === 'RestElement') {
        if (transforms.spreadRest) {
          introStatementGenerators.push(function (start, prefix, suffix) {
            var penultimateParam = params[params.length - 2];

            if (penultimateParam) {
              code.remove(penultimateParam ? penultimateParam.end : param.start, param.end);
            } else {
              var start$1 = param.start,
                  end = param.end; // TODO https://gitlab.com/Rich-Harris/buble/issues/8

              while (/\s/.test(code.original[start$1 - 1])) {
                start$1 -= 1;
              }

              while (/\s/.test(code.original[end])) {
                end += 1;
              }

              code.remove(start$1, end);
            }

            var name = param.argument.name;
            var len = this$1.scope.createIdentifier('len');
            var count = params.length - 1;

            if (count) {
              code.prependRight(start, prefix + "var " + name + " = [], " + len + " = arguments.length - " + count + ";\n" + indentation + "while ( " + len + "-- > 0 ) " + name + "[ " + len + " ] = arguments[ " + len + " + " + count + " ]" + suffix);
            } else {
              code.prependRight(start, prefix + "var " + name + " = [], " + len + " = arguments.length;\n" + indentation + "while ( " + len + "-- ) " + name + "[ " + len + " ] = arguments[ " + len + " ]" + suffix);
            }
          });
        }
      } else if (param.type !== 'Identifier') {
        if (transforms.parameterDestructuring) {
          var ref = this$1.scope.createIdentifier('ref');
          destructure(code, function (id) {
            return this$1.scope.createIdentifier(id);
          }, function (ref) {
            var name = ref.name;
            return this$1.scope.resolveName(name);
          }, param, ref, false, introStatementGenerators);
          code.prependRight(param.start, ref);
        }
      }
    });
  };

  BlockStatement.prototype.transpileBlockScopedIdentifiers = function transpileBlockScopedIdentifiers(code) {
    var this$1 = this;
    Object.keys(this.scope.blockScopedDeclarations).forEach(function (name) {
      var declarations = this$1.scope.blockScopedDeclarations[name];

      for (var i$2 = 0, list$2 = declarations; i$2 < list$2.length; i$2 += 1) {
        var declaration = list$2[i$2];
        var cont = false; // TODO implement proper continue...

        if (declaration.kind === 'for.let') {
          // special case
          var forStatement = declaration.node.findNearest('ForStatement');

          if (forStatement.shouldRewriteAsFunction) {
            var outerAlias = this$1.scope.createIdentifier(name);
            var innerAlias = forStatement.reassigned[name] ? this$1.scope.createIdentifier(name) : name;
            declaration.name = outerAlias;
            code.overwrite(declaration.node.start, declaration.node.end, outerAlias, {
              storeName: true
            });
            forStatement.aliases[name] = {
              outer: outerAlias,
              inner: innerAlias
            };

            for (var i = 0, list = declaration.instances; i < list.length; i += 1) {
              var identifier = list[i];
              var alias = forStatement.body.contains(identifier) ? innerAlias : outerAlias;

              if (name !== alias) {
                code.overwrite(identifier.start, identifier.end, alias, {
                  storeName: true
                });
              }
            }

            cont = true;
          }
        }

        if (!cont) {
          var alias$1 = this$1.scope.createIdentifier(name);

          if (name !== alias$1) {
            declaration.name = alias$1;
            code.overwrite(declaration.node.start, declaration.node.end, alias$1, {
              storeName: true
            });

            for (var i$1 = 0, list$1 = declaration.instances; i$1 < list$1.length; i$1 += 1) {
              var identifier$1 = list$1[i$1];
              identifier$1.rewritten = true;
              code.overwrite(identifier$1.start, identifier$1.end, alias$1, {
                storeName: true
              });
            }
          }
        }
      }
    });
  };

  return BlockStatement;
}(Node$1);

function isArguments(node) {
  return node.type === 'Identifier' && node.name === 'arguments';
}

function spread(code, elements, start, argumentsArrayAlias, isNew) {
  var i = elements.length;
  var firstSpreadIndex = -1;

  while (i--) {
    var element$1 = elements[i];

    if (element$1 && element$1.type === 'SpreadElement') {
      if (isArguments(element$1.argument)) {
        code.overwrite(element$1.argument.start, element$1.argument.end, argumentsArrayAlias);
      }

      firstSpreadIndex = i;
    }
  }

  if (firstSpreadIndex === -1) {
    return false;
  } // false indicates no spread elements


  if (isNew) {
    for (i = 0; i < elements.length; i += 1) {
      var element$2 = elements[i];

      if (element$2.type === 'SpreadElement') {
        code.remove(element$2.start, element$2.argument.start);
      } else {
        code.prependRight(element$2.start, '[');
        code.prependRight(element$2.end, ']');
      }
    }

    return true; // true indicates some spread elements
  }

  var element = elements[firstSpreadIndex];
  var previousElement = elements[firstSpreadIndex - 1];

  if (!previousElement) {
    code.remove(start, element.start);
    code.overwrite(element.end, elements[1].start, '.concat( ');
  } else {
    code.overwrite(previousElement.end, element.start, ' ].concat( ');
  }

  for (i = firstSpreadIndex; i < elements.length; i += 1) {
    element = elements[i];

    if (element) {
      if (element.type === 'SpreadElement') {
        code.remove(element.start, element.argument.start);
      } else {
        code.appendLeft(element.start, '[');
        code.appendLeft(element.end, ']');
      }
    }
  }

  return true; // true indicates some spread elements
}

var ArrayExpression = function (Node) {
  function ArrayExpression() {
    Node.apply(this, arguments);
  }

  if (Node) ArrayExpression.__proto__ = Node;
  ArrayExpression.prototype = Object.create(Node && Node.prototype);
  ArrayExpression.prototype.constructor = ArrayExpression;

  ArrayExpression.prototype.initialise = function initialise(transforms) {
    var this$1 = this;

    if (transforms.spreadRest && this.elements.length) {
      var lexicalBoundary = this.findLexicalBoundary();
      var i = this.elements.length;

      while (i--) {
        var element = this$1.elements[i];

        if (element && element.type === 'SpreadElement' && isArguments(element.argument)) {
          this$1.argumentsArrayAlias = lexicalBoundary.getArgumentsArrayAlias();
        }
      }
    }

    Node.prototype.initialise.call(this, transforms);
  };

  ArrayExpression.prototype.transpile = function transpile(code, transforms) {
    Node.prototype.transpile.call(this, code, transforms);

    if (transforms.spreadRest) {
      // erase trailing comma after last array element if not an array hole
      if (this.elements.length) {
        var lastElement = this.elements[this.elements.length - 1];

        if (lastElement && /\s*,/.test(code.original.slice(lastElement.end, this.end))) {
          code.overwrite(lastElement.end, this.end - 1, ' ');
        }
      }

      if (this.elements.length === 1) {
        var element = this.elements[0];

        if (element && element.type === 'SpreadElement') {
          // special case – [ ...arguments ]
          if (isArguments(element.argument)) {
            code.overwrite(this.start, this.end, "[].concat( " + this.argumentsArrayAlias + " )"); // TODO if this is the only use of argsArray, don't bother concating
          } else {
            code.overwrite(this.start, element.argument.start, '[].concat( ');
            code.overwrite(element.end, this.end, ' )');
          }
        }
      } else {
        var hasSpreadElements = spread(code, this.elements, this.start, this.argumentsArrayAlias);

        if (hasSpreadElements) {
          code.overwrite(this.end - 1, this.end, ')');
        }
      }
    }
  };

  return ArrayExpression;
}(Node$1);

function removeTrailingComma(code, c) {
  while (code.original[c] !== ')') {
    if (code.original[c] === ',') {
      code.remove(c, c + 1);
      return;
    }

    if (code.original[c] === '/') {
      c = code.original.indexOf(code.original[c + 1] === '/' ? '\n' : '*/', c) + 1;
    }

    c += 1;
  }
}

var ArrowFunctionExpression = function (Node) {
  function ArrowFunctionExpression() {
    Node.apply(this, arguments);
  }

  if (Node) ArrowFunctionExpression.__proto__ = Node;
  ArrowFunctionExpression.prototype = Object.create(Node && Node.prototype);
  ArrowFunctionExpression.prototype.constructor = ArrowFunctionExpression;

  ArrowFunctionExpression.prototype.initialise = function initialise(transforms) {
    this.body.createScope();
    Node.prototype.initialise.call(this, transforms);
  };

  ArrowFunctionExpression.prototype.transpile = function transpile(code, transforms) {
    var naked = this.params.length === 1 && this.start === this.params[0].start;

    if (transforms.arrow || this.needsArguments(transforms)) {
      // remove arrow
      var charIndex = this.body.start;

      while (code.original[charIndex] !== '=') {
        charIndex -= 1;
      }

      code.remove(charIndex, this.body.start);
      Node.prototype.transpile.call(this, code, transforms); // wrap naked parameter

      if (naked) {
        code.prependRight(this.params[0].start, '(');
        code.appendLeft(this.params[0].end, ')');
      } // add function


      if (this.parent && this.parent.type === 'ExpressionStatement') {
        // standalone expression statement
        code.prependRight(this.start, '!function');
      } else {
        code.prependRight(this.start, 'function ');
      }
    } else {
      Node.prototype.transpile.call(this, code, transforms);
    }

    if (transforms.trailingFunctionCommas && this.params.length && !naked) {
      removeTrailingComma(code, this.params[this.params.length - 1].end);
    }
  }; // Returns whether any transforms that will happen use `arguments`


  ArrowFunctionExpression.prototype.needsArguments = function needsArguments(transforms) {
    return transforms.spreadRest && this.params.filter(function (param) {
      return param.type === 'RestElement';
    }).length > 0;
  };

  return ArrowFunctionExpression;
}(Node$1);

function checkConst(identifier, scope) {
  var declaration = scope.findDeclaration(identifier.name);

  if (declaration && declaration.kind === 'const') {
    throw new CompileError(identifier.name + " is read-only", identifier);
  }
}

var AssignmentExpression = function (Node) {
  function AssignmentExpression() {
    Node.apply(this, arguments);
  }

  if (Node) AssignmentExpression.__proto__ = Node;
  AssignmentExpression.prototype = Object.create(Node && Node.prototype);
  AssignmentExpression.prototype.constructor = AssignmentExpression;

  AssignmentExpression.prototype.initialise = function initialise(transforms) {
    if (this.left.type === 'Identifier') {
      var declaration = this.findScope(false).findDeclaration(this.left.name); // special case – https://gitlab.com/Rich-Harris/buble/issues/11

      var statement = declaration && declaration.node.ancestor(3);

      if (statement && statement.type === 'ForStatement' && statement.body.contains(this)) {
        statement.reassigned[this.left.name] = true;
      }
    }

    Node.prototype.initialise.call(this, transforms);
  };

  AssignmentExpression.prototype.transpile = function transpile(code, transforms) {
    if (this.left.type === 'Identifier') {
      // Do this check after everything has been initialized to find
      // shadowing declarations after this expression
      checkConst(this.left, this.findScope(false));
    }

    if (this.operator === '**=' && transforms.exponentiation) {
      this.transpileExponentiation(code, transforms);
    } else if (/Pattern/.test(this.left.type) && transforms.destructuring) {
      this.transpileDestructuring(code);
    }

    Node.prototype.transpile.call(this, code, transforms);
  };

  AssignmentExpression.prototype.transpileDestructuring = function transpileDestructuring(code) {
    var this$1 = this;
    var writeScope = this.findScope(true);
    var lookupScope = this.findScope(false);
    var assign = writeScope.createDeclaration('assign');
    code.appendRight(this.left.end, "(" + assign);
    code.appendLeft(this.right.end, ', ');
    var statementGenerators = [];
    destructure(code, function (id) {
      return writeScope.createDeclaration(id);
    }, function (node) {
      var name = lookupScope.resolveName(node.name);
      checkConst(node, lookupScope);
      return name;
    }, this.left, assign, true, statementGenerators);
    var suffix = ', ';
    statementGenerators.forEach(function (fn, j) {
      if (j === statementGenerators.length - 1) {
        suffix = '';
      }

      fn(this$1.end, '', suffix);
    });

    if (this.unparenthesizedParent().type === 'ExpressionStatement') {
      // no rvalue needed for expression statement
      code.prependRight(this.end, ")");
    } else {
      // destructuring is part of an expression - need an rvalue
      code.appendRight(this.end, ", " + assign + ")");
    }
  };

  AssignmentExpression.prototype.transpileExponentiation = function transpileExponentiation(code) {
    var scope = this.findScope(false); // first, the easy part – `**=` -> `=`

    var charIndex = this.left.end;

    while (code.original[charIndex] !== '*') {
      charIndex += 1;
    }

    code.remove(charIndex, charIndex + 2); // how we do the next part depends on a number of factors – whether
    // this is a top-level statement, and whether we're updating a
    // simple or complex reference

    var base;
    var left = this.left.unparenthesize();

    if (left.type === 'Identifier') {
      base = scope.resolveName(left.name);
    } else if (left.type === 'MemberExpression') {
      var object;
      var needsObjectVar = false;
      var property;
      var needsPropertyVar = false;
      var statement = this.findNearest(/(?:Statement|Declaration)$/);
      var i0 = statement.getIndentation();

      if (left.property.type === 'Identifier') {
        property = left.computed ? scope.resolveName(left.property.name) : left.property.name;
      } else {
        property = scope.createDeclaration('property');
        needsPropertyVar = true;
      }

      if (left.object.type === 'Identifier') {
        object = scope.resolveName(left.object.name);
      } else {
        object = scope.createDeclaration('object');
        needsObjectVar = true;
      }

      if (left.start === statement.start) {
        if (needsObjectVar && needsPropertyVar) {
          code.prependRight(statement.start, object + " = ");
          code.overwrite(left.object.end, left.property.start, ";\n" + i0 + property + " = ");
          code.overwrite(left.property.end, left.end, ";\n" + i0 + object + "[" + property + "]");
        } else if (needsObjectVar) {
          code.prependRight(statement.start, object + " = ");
          code.appendLeft(left.object.end, ";\n" + i0);
          code.appendLeft(left.object.end, object);
        } else if (needsPropertyVar) {
          code.prependRight(left.property.start, property + " = ");
          code.appendLeft(left.property.end, ";\n" + i0);
          code.move(left.property.start, left.property.end, this.start);
          code.appendLeft(left.object.end, "[" + property + "]");
          code.remove(left.object.end, left.property.start);
          code.remove(left.property.end, left.end);
        }
      } else {
        if (needsObjectVar && needsPropertyVar) {
          code.prependRight(left.start, "( " + object + " = ");
          code.overwrite(left.object.end, left.property.start, ", " + property + " = ");
          code.overwrite(left.property.end, left.end, ", " + object + "[" + property + "]");
        } else if (needsObjectVar) {
          code.prependRight(left.start, "( " + object + " = ");
          code.appendLeft(left.object.end, ", " + object);
        } else if (needsPropertyVar) {
          code.prependRight(left.property.start, "( " + property + " = ");
          code.appendLeft(left.property.end, ", ");
          code.move(left.property.start, left.property.end, left.start);
          code.overwrite(left.object.end, left.property.start, "[" + property + "]");
          code.remove(left.property.end, left.end);
        }

        if (needsPropertyVar) {
          code.appendLeft(this.end, " )");
        }
      }

      base = object + (left.computed || needsPropertyVar ? "[" + property + "]" : "." + property);
    }

    code.prependRight(this.right.start, "Math.pow( " + base + ", ");
    code.appendLeft(this.right.end, " )");
  };

  return AssignmentExpression;
}(Node$1);

var BinaryExpression = function (Node) {
  function BinaryExpression() {
    Node.apply(this, arguments);
  }

  if (Node) BinaryExpression.__proto__ = Node;
  BinaryExpression.prototype = Object.create(Node && Node.prototype);
  BinaryExpression.prototype.constructor = BinaryExpression;

  BinaryExpression.prototype.transpile = function transpile(code, transforms) {
    if (this.operator === '**' && transforms.exponentiation) {
      code.prependRight(this.start, "Math.pow( ");
      code.overwrite(this.left.end, this.right.start, ", ");
      code.appendLeft(this.end, " )");
    }

    Node.prototype.transpile.call(this, code, transforms);
  };

  return BinaryExpression;
}(Node$1);

var loopStatement = /(?:For(?:In|Of)?|While)Statement/;

var BreakStatement = function (Node) {
  function BreakStatement() {
    Node.apply(this, arguments);
  }

  if (Node) BreakStatement.__proto__ = Node;
  BreakStatement.prototype = Object.create(Node && Node.prototype);
  BreakStatement.prototype.constructor = BreakStatement;

  BreakStatement.prototype.initialise = function initialise() {
    var loop = this.findNearest(loopStatement);
    var switchCase = this.findNearest('SwitchCase');

    if (loop && (!switchCase || loop.depth > switchCase.depth)) {
      loop.canBreak = true;
      this.loop = loop;
    }
  };

  BreakStatement.prototype.transpile = function transpile(code) {
    if (this.loop && this.loop.shouldRewriteAsFunction) {
      if (this.label) {
        throw new CompileError('Labels are not currently supported in a loop with locally-scoped variables', this);
      }

      code.overwrite(this.start, this.start + 5, "return 'break'");
    }
  };

  return BreakStatement;
}(Node$1);

var CallExpression = function (Node) {
  function CallExpression() {
    Node.apply(this, arguments);
  }

  if (Node) CallExpression.__proto__ = Node;
  CallExpression.prototype = Object.create(Node && Node.prototype);
  CallExpression.prototype.constructor = CallExpression;

  CallExpression.prototype.initialise = function initialise(transforms) {
    var this$1 = this;

    if (transforms.spreadRest && this.arguments.length > 1) {
      var lexicalBoundary = this.findLexicalBoundary();
      var i = this.arguments.length;

      while (i--) {
        var arg = this$1.arguments[i];

        if (arg.type === 'SpreadElement' && isArguments(arg.argument)) {
          this$1.argumentsArrayAlias = lexicalBoundary.getArgumentsArrayAlias();
        }
      }
    }

    Node.prototype.initialise.call(this, transforms);
  };

  CallExpression.prototype.transpile = function transpile(code, transforms) {
    if (transforms.spreadRest && this.arguments.length) {
      var hasSpreadElements = false;
      var context;
      var firstArgument = this.arguments[0];

      if (this.arguments.length === 1) {
        if (firstArgument.type === 'SpreadElement') {
          code.remove(firstArgument.start, firstArgument.argument.start);
          hasSpreadElements = true;
        }
      } else {
        hasSpreadElements = spread(code, this.arguments, firstArgument.start, this.argumentsArrayAlias);
      }

      if (hasSpreadElements) {
        // we need to handle super() and super.method() differently
        // due to its instance
        var _super = null;

        if (this.callee.type === 'Super') {
          _super = this.callee;
        } else if (this.callee.type === 'MemberExpression' && this.callee.object.type === 'Super') {
          _super = this.callee.object;
        }

        if (!_super && this.callee.type === 'MemberExpression') {
          if (this.callee.object.type === 'Identifier') {
            context = this.callee.object.name;
          } else {
            context = this.findScope(true).createDeclaration('ref');
            var callExpression = this.callee.object;
            code.prependRight(callExpression.start, "(" + context + " = ");
            code.appendLeft(callExpression.end, ")");
          }
        } else {
          context = 'void 0';
        }

        code.appendLeft(this.callee.end, '.apply');

        if (_super) {
          _super.noCall = true; // bit hacky...

          if (this.arguments.length > 1) {
            if (firstArgument.type !== 'SpreadElement') {
              code.prependRight(firstArgument.start, "[ ");
            }

            code.appendLeft(this.arguments[this.arguments.length - 1].end, ' )');
          }
        } else if (this.arguments.length === 1) {
          code.prependRight(firstArgument.start, context + ", ");
        } else {
          if (firstArgument.type === 'SpreadElement') {
            code.appendLeft(firstArgument.start, context + ", ");
          } else {
            code.appendLeft(firstArgument.start, context + ", [ ");
          }

          code.appendLeft(this.arguments[this.arguments.length - 1].end, ' )');
        }
      }
    }

    if (transforms.trailingFunctionCommas && this.arguments.length) {
      removeTrailingComma(code, this.arguments[this.arguments.length - 1].end);
    }

    Node.prototype.transpile.call(this, code, transforms);
  };

  return CallExpression;
}(Node$1); // TODO this code is pretty wild, tidy it up


var ClassBody = function (Node) {
  function ClassBody() {
    Node.apply(this, arguments);
  }

  if (Node) ClassBody.__proto__ = Node;
  ClassBody.prototype = Object.create(Node && Node.prototype);
  ClassBody.prototype.constructor = ClassBody;

  ClassBody.prototype.transpile = function transpile(code, transforms, inFunctionExpression, superName) {
    var this$1 = this;

    if (transforms.classes) {
      var name = this.parent.name;
      var indentStr = code.getIndentString();
      var i0 = this.getIndentation() + (inFunctionExpression ? indentStr : '');
      var i1 = i0 + indentStr;
      var constructorIndex = findIndex(this.body, function (node) {
        return node.kind === 'constructor';
      });
      var constructor = this.body[constructorIndex];
      var introBlock = '';
      var outroBlock = '';

      if (this.body.length) {
        code.remove(this.start, this.body[0].start);
        code.remove(this.body[this.body.length - 1].end, this.end);
      } else {
        code.remove(this.start, this.end);
      }

      if (constructor) {
        constructor.value.body.isConstructorBody = true;
        var previousMethod = this.body[constructorIndex - 1];
        var nextMethod = this.body[constructorIndex + 1]; // ensure constructor is first

        if (constructorIndex > 0) {
          code.remove(previousMethod.end, constructor.start);
          code.move(constructor.start, nextMethod ? nextMethod.start : this.end - 1, this.body[0].start);
        }

        if (!inFunctionExpression) {
          code.appendLeft(constructor.end, ';');
        }
      }

      var namedFunctions = this.program.options.namedFunctionExpressions !== false;
      var namedConstructor = namedFunctions || this.parent.superClass || this.parent.type !== 'ClassDeclaration';

      if (this.parent.superClass) {
        var inheritanceBlock = "if ( " + superName + " ) " + name + ".__proto__ = " + superName + ";\n" + i0 + name + ".prototype = Object.create( " + superName + " && " + superName + ".prototype );\n" + i0 + name + ".prototype.constructor = " + name + ";";

        if (constructor) {
          introBlock += "\n\n" + i0 + inheritanceBlock;
        } else {
          var fn = "function " + name + " () {" + (superName ? "\n" + i1 + superName + ".apply(this, arguments);\n" + i0 + "}" : "}") + (inFunctionExpression ? '' : ';') + (this.body.length ? "\n\n" + i0 : '');
          inheritanceBlock = fn + inheritanceBlock;
          introBlock += inheritanceBlock + "\n\n" + i0;
        }
      } else if (!constructor) {
        var fn$1 = 'function ' + (namedConstructor ? name + ' ' : '') + '() {}';

        if (this.parent.type === 'ClassDeclaration') {
          fn$1 += ';';
        }

        if (this.body.length) {
          fn$1 += "\n\n" + i0;
        }

        introBlock += fn$1;
      }

      var scope = this.findScope(false);
      var prototypeGettersAndSetters = [];
      var staticGettersAndSetters = [];
      var prototypeAccessors;
      var staticAccessors;
      this.body.forEach(function (method, i) {
        if ((method.kind === 'get' || method.kind === 'set') && transforms.getterSetter) {
          throw new CompileError("getters and setters are not supported. Use `transforms: { getterSetter: false }` to skip transformation and disable this error", method);
        }

        if (method.kind === 'constructor') {
          var constructorName = namedConstructor ? ' ' + name : '';
          code.overwrite(method.key.start, method.key.end, "function" + constructorName);
          return;
        }

        if (method["static"]) {
          var len = code.original[method.start + 6] == ' ' ? 7 : 6;
          code.remove(method.start, method.start + len);
        }

        var isAccessor = method.kind !== 'method';
        var lhs;
        var methodName = method.key.name;

        if (reserved[methodName] || method.value.body.scope.references[methodName]) {
          methodName = scope.createIdentifier(methodName);
        } // when method name is a string or a number let's pretend it's a computed method


        var fake_computed = false;

        if (!method.computed && method.key.type === 'Literal') {
          fake_computed = true;
          method.computed = true;
        }

        if (isAccessor) {
          if (method.computed) {
            throw new Error('Computed accessor properties are not currently supported');
          }

          code.remove(method.start, method.key.start);

          if (method["static"]) {
            if (!~staticGettersAndSetters.indexOf(method.key.name)) {
              staticGettersAndSetters.push(method.key.name);
            }

            if (!staticAccessors) {
              staticAccessors = scope.createIdentifier('staticAccessors');
            }

            lhs = "" + staticAccessors;
          } else {
            if (!~prototypeGettersAndSetters.indexOf(method.key.name)) {
              prototypeGettersAndSetters.push(method.key.name);
            }

            if (!prototypeAccessors) {
              prototypeAccessors = scope.createIdentifier('prototypeAccessors');
            }

            lhs = "" + prototypeAccessors;
          }
        } else {
          lhs = method["static"] ? "" + name : name + ".prototype";
        }

        if (!method.computed) {
          lhs += '.';
        }

        var insertNewlines = constructorIndex > 0 && i === constructorIndex + 1 || i === 0 && constructorIndex === this$1.body.length - 1;

        if (insertNewlines) {
          lhs = "\n\n" + i0 + lhs;
        }

        var c = method.key.end;

        if (method.computed) {
          if (fake_computed) {
            code.prependRight(method.key.start, '[');
            code.appendLeft(method.key.end, ']');
          } else {
            while (code.original[c] !== ']') {
              c += 1;
            }

            c += 1;
          }
        }

        var funcName = method.computed || isAccessor || !namedFunctions ? '' : methodName + " ";
        var rhs = (isAccessor ? "." + method.kind : '') + " = function" + (method.value.generator ? '* ' : ' ') + funcName;
        code.remove(c, method.value.start);
        code.prependRight(method.value.start, rhs);
        code.appendLeft(method.end, ';');

        if (method.value.generator) {
          code.remove(method.start, method.key.start);
        }

        code.prependRight(method.start, lhs);
      });

      if (prototypeGettersAndSetters.length || staticGettersAndSetters.length) {
        var intro = [];
        var outro = [];

        if (prototypeGettersAndSetters.length) {
          intro.push("var " + prototypeAccessors + " = { " + prototypeGettersAndSetters.map(function (name) {
            return name + ": { configurable: true }";
          }).join(',') + " };");
          outro.push("Object.defineProperties( " + name + ".prototype, " + prototypeAccessors + " );");
        }

        if (staticGettersAndSetters.length) {
          intro.push("var " + staticAccessors + " = { " + staticGettersAndSetters.map(function (name) {
            return name + ": { configurable: true }";
          }).join(',') + " };");
          outro.push("Object.defineProperties( " + name + ", " + staticAccessors + " );");
        }

        if (constructor) {
          introBlock += "\n\n" + i0;
        }

        introBlock += intro.join("\n" + i0);

        if (!constructor) {
          introBlock += "\n\n" + i0;
        }

        outroBlock += "\n\n" + i0 + outro.join("\n" + i0);
      }

      if (constructor) {
        code.appendLeft(constructor.end, introBlock);
      } else {
        code.prependRight(this.start, introBlock);
      }

      code.appendLeft(this.end, outroBlock);
    }

    Node.prototype.transpile.call(this, code, transforms);
  };

  return ClassBody;
}(Node$1); // TODO this function is slightly flawed – it works on the original string,
// not its current edited state.
// That's not a problem for the way that it's currently used, but it could
// be in future...


function deindent(node, code) {
  var start = node.start;
  var end = node.end;
  var indentStr = code.getIndentString();
  var indentStrLen = indentStr.length;
  var indentStart = start - indentStrLen;

  if (!node.program.indentExclusions[indentStart] && code.original.slice(indentStart, start) === indentStr) {
    code.remove(indentStart, start);
  }

  var pattern = new RegExp(indentStr + '\\S', 'g');
  var slice = code.original.slice(start, end);
  var match;

  while (match = pattern.exec(slice)) {
    var removeStart = start + match.index;

    if (!node.program.indentExclusions[removeStart]) {
      code.remove(removeStart, removeStart + indentStrLen);
    }
  }
}

var ClassDeclaration = function (Node) {
  function ClassDeclaration() {
    Node.apply(this, arguments);
  }

  if (Node) ClassDeclaration.__proto__ = Node;
  ClassDeclaration.prototype = Object.create(Node && Node.prototype);
  ClassDeclaration.prototype.constructor = ClassDeclaration;

  ClassDeclaration.prototype.initialise = function initialise(transforms) {
    if (this.id) {
      this.name = this.id.name;
      this.findScope(true).addDeclaration(this.id, 'class');
    } else {
      this.name = this.findScope(true).createIdentifier("defaultExport");
    }

    Node.prototype.initialise.call(this, transforms);
  };

  ClassDeclaration.prototype.transpile = function transpile(code, transforms) {
    if (transforms.classes) {
      if (!this.superClass) {
        deindent(this.body, code);
      }

      var superName = this.superClass && (this.superClass.name || 'superclass');
      var i0 = this.getIndentation();
      var i1 = i0 + code.getIndentString(); // if this is an export default statement, we have to move the export to
      // after the declaration, because `export default var Foo = ...` is illegal

      var isExportDefaultDeclaration = this.parent.type === 'ExportDefaultDeclaration';

      if (isExportDefaultDeclaration) {
        code.remove(this.parent.start, this.start);
      }

      var c = this.start;

      if (this.id) {
        code.overwrite(c, this.id.start, 'var ');
        c = this.id.end;
      } else {
        code.prependLeft(c, "var " + this.name);
      }

      if (this.superClass) {
        if (this.superClass.end === this.body.start) {
          code.remove(c, this.superClass.start);
          code.appendLeft(c, " = /*@__PURE__*/(function (" + superName + ") {\n" + i1);
        } else {
          code.overwrite(c, this.superClass.start, ' = ');
          code.overwrite(this.superClass.end, this.body.start, "/*@__PURE__*/(function (" + superName + ") {\n" + i1);
        }
      } else {
        if (c === this.body.start) {
          code.appendLeft(c, ' = ');
        } else {
          code.overwrite(c, this.body.start, ' = ');
        }
      }

      this.body.transpile(code, transforms, !!this.superClass, superName);
      var syntheticDefaultExport = isExportDefaultDeclaration ? "\n\n" + i0 + "export default " + this.name + ";" : '';

      if (this.superClass) {
        code.appendLeft(this.end, "\n\n" + i1 + "return " + this.name + ";\n" + i0 + "}(");
        code.move(this.superClass.start, this.superClass.end, this.end);
        code.prependRight(this.end, "));" + syntheticDefaultExport);
      } else if (syntheticDefaultExport) {
        code.prependRight(this.end, syntheticDefaultExport);
      }
    } else {
      this.body.transpile(code, transforms, false, null);
    }
  };

  return ClassDeclaration;
}(Node$1);

var ClassExpression = function (Node) {
  function ClassExpression() {
    Node.apply(this, arguments);
  }

  if (Node) ClassExpression.__proto__ = Node;
  ClassExpression.prototype = Object.create(Node && Node.prototype);
  ClassExpression.prototype.constructor = ClassExpression;

  ClassExpression.prototype.initialise = function initialise(transforms) {
    this.name = (this.id ? this.id.name : this.parent.type === 'VariableDeclarator' ? this.parent.id.name : this.parent.type !== 'AssignmentExpression' ? null : this.parent.left.type === 'Identifier' ? this.parent.left.name : this.parent.left.type === 'MemberExpression' ? this.parent.left.property.name : null) || this.findScope(true).createIdentifier('anonymous');
    Node.prototype.initialise.call(this, transforms);
  };

  ClassExpression.prototype.transpile = function transpile(code, transforms) {
    if (transforms.classes) {
      var superName = this.superClass && (this.superClass.name || 'superclass');
      var i0 = this.getIndentation();
      var i1 = i0 + code.getIndentString();

      if (this.superClass) {
        code.remove(this.start, this.superClass.start);
        code.remove(this.superClass.end, this.body.start);
        code.appendRight(this.start, "/*@__PURE__*/(function (" + superName + ") {\n" + i1);
      } else {
        code.overwrite(this.start, this.body.start, "/*@__PURE__*/(function () {\n" + i1);
      }

      this.body.transpile(code, transforms, true, superName);
      var superClass = '';

      if (this.superClass) {
        superClass = code.slice(this.superClass.start, this.superClass.end);
        code.remove(this.superClass.start, this.superClass.end);
      }

      code.appendLeft(this.end, "\n\n" + i1 + "return " + this.name + ";\n" + i0 + "}(" + superClass + "))");
    } else {
      this.body.transpile(code, transforms, false);
    }
  };

  return ClassExpression;
}(Node$1);

var ContinueStatement = function (Node) {
  function ContinueStatement() {
    Node.apply(this, arguments);
  }

  if (Node) ContinueStatement.__proto__ = Node;
  ContinueStatement.prototype = Object.create(Node && Node.prototype);
  ContinueStatement.prototype.constructor = ContinueStatement;

  ContinueStatement.prototype.transpile = function transpile(code) {
    var loop = this.findNearest(loopStatement);

    if (loop.shouldRewriteAsFunction) {
      if (this.label) {
        throw new CompileError('Labels are not currently supported in a loop with locally-scoped variables', this);
      }

      code.overwrite(this.start, this.start + 8, 'return');
    }
  };

  return ContinueStatement;
}(Node$1);

var ExportDefaultDeclaration = function (Node) {
  function ExportDefaultDeclaration() {
    Node.apply(this, arguments);
  }

  if (Node) ExportDefaultDeclaration.__proto__ = Node;
  ExportDefaultDeclaration.prototype = Object.create(Node && Node.prototype);
  ExportDefaultDeclaration.prototype.constructor = ExportDefaultDeclaration;

  ExportDefaultDeclaration.prototype.initialise = function initialise(transforms) {
    if (transforms.moduleExport) {
      throw new CompileError('export is not supported', this);
    }

    Node.prototype.initialise.call(this, transforms);
  };

  return ExportDefaultDeclaration;
}(Node$1);

var ExportNamedDeclaration = function (Node) {
  function ExportNamedDeclaration() {
    Node.apply(this, arguments);
  }

  if (Node) ExportNamedDeclaration.__proto__ = Node;
  ExportNamedDeclaration.prototype = Object.create(Node && Node.prototype);
  ExportNamedDeclaration.prototype.constructor = ExportNamedDeclaration;

  ExportNamedDeclaration.prototype.initialise = function initialise(transforms) {
    if (transforms.moduleExport) {
      throw new CompileError('export is not supported', this);
    }

    Node.prototype.initialise.call(this, transforms);
  };

  return ExportNamedDeclaration;
}(Node$1);

var LoopStatement = function (Node) {
  function LoopStatement() {
    Node.apply(this, arguments);
  }

  if (Node) LoopStatement.__proto__ = Node;
  LoopStatement.prototype = Object.create(Node && Node.prototype);
  LoopStatement.prototype.constructor = LoopStatement;

  LoopStatement.prototype.findScope = function findScope(functionScope) {
    return functionScope || !this.createdScope ? this.parent.findScope(functionScope) : this.body.scope;
  };

  LoopStatement.prototype.initialise = function initialise(transforms) {
    var this$1 = this;
    this.body.createScope();
    this.createdScope = true; // this is populated as and when reassignments occur

    this.reassigned = Object.create(null);
    this.aliases = Object.create(null);
    this.thisRefs = [];
    Node.prototype.initialise.call(this, transforms);

    if (transforms.letConst) {
      // see if any block-scoped declarations are referenced
      // inside function expressions
      var names = Object.keys(this.body.scope.declarations);
      var i = names.length;

      while (i--) {
        var name = names[i];
        var declaration = this$1.body.scope.declarations[name];
        var j = declaration.instances.length;

        while (j--) {
          var instance = declaration.instances[j];
          var nearestFunctionExpression = instance.findNearest(/Function/);

          if (nearestFunctionExpression && nearestFunctionExpression.depth > this$1.depth) {
            this$1.shouldRewriteAsFunction = true;

            for (var i$1 = 0, list = this$1.thisRefs; i$1 < list.length; i$1 += 1) {
              var node = list[i$1];
              node.alias = node.alias || node.findLexicalBoundary().getThisAlias();
            }

            break;
          }
        }

        if (this$1.shouldRewriteAsFunction) {
          break;
        }
      }
    }
  };

  LoopStatement.prototype.transpile = function transpile(code, transforms) {
    var needsBlock = this.type != 'ForOfStatement' && (this.body.type !== 'BlockStatement' || this.body.type === 'BlockStatement' && this.body.synthetic);

    if (this.shouldRewriteAsFunction) {
      var i0 = this.getIndentation();
      var i1 = i0 + code.getIndentString();
      var argString = this.args ? " " + this.args.join(', ') + " " : '';
      var paramString = this.params ? " " + this.params.join(', ') + " " : '';
      var functionScope = this.findScope(true);
      var loop = functionScope.createIdentifier('loop');
      var before = "var " + loop + " = function (" + paramString + ") " + (this.body.synthetic ? "{\n" + i0 + code.getIndentString() : '');
      var after = (this.body.synthetic ? "\n" + i0 + "}" : '') + ";\n\n" + i0;
      code.prependRight(this.body.start, before);
      code.appendLeft(this.body.end, after);
      code.move(this.start, this.body.start, this.body.end);

      if (this.canBreak || this.canReturn) {
        var returned = functionScope.createIdentifier('returned');
        var insert = "{\n" + i1 + "var " + returned + " = " + loop + "(" + argString + ");\n";

        if (this.canBreak) {
          insert += "\n" + i1 + "if ( " + returned + " === 'break' ) break;";
        }

        if (this.canReturn) {
          insert += "\n" + i1 + "if ( " + returned + " ) return " + returned + ".v;";
        }

        insert += "\n" + i0 + "}";
        code.prependRight(this.body.end, insert);
      } else {
        var callExpression = loop + "(" + argString + ");";

        if (this.type === 'DoWhileStatement') {
          code.overwrite(this.start, this.body.start, "do {\n" + i1 + callExpression + "\n" + i0 + "}");
        } else {
          code.prependRight(this.body.end, callExpression);
        }
      }
    } else if (needsBlock) {
      code.appendLeft(this.body.start, '{ ');
      code.prependRight(this.body.end, ' }');
    }

    Node.prototype.transpile.call(this, code, transforms);
  };

  return LoopStatement;
}(Node$1);

var ForStatement = function (LoopStatement$$1) {
  function ForStatement() {
    LoopStatement$$1.apply(this, arguments);
  }

  if (LoopStatement$$1) ForStatement.__proto__ = LoopStatement$$1;
  ForStatement.prototype = Object.create(LoopStatement$$1 && LoopStatement$$1.prototype);
  ForStatement.prototype.constructor = ForStatement;

  ForStatement.prototype.findScope = function findScope(functionScope) {
    return functionScope || !this.createdScope ? this.parent.findScope(functionScope) : this.body.scope;
  };

  ForStatement.prototype.transpile = function transpile(code, transforms) {
    var this$1 = this;
    var i1 = this.getIndentation() + code.getIndentString();

    if (this.shouldRewriteAsFunction) {
      // which variables are declared in the init statement?
      var names = this.init.type === 'VariableDeclaration' ? this.init.declarations.map(function (declarator) {
        return extractNames(declarator.id);
      }) : [];
      var aliases = this.aliases;
      this.args = names.map(function (name) {
        return name in this$1.aliases ? this$1.aliases[name].outer : name;
      });
      this.params = names.map(function (name) {
        return name in this$1.aliases ? this$1.aliases[name].inner : name;
      });
      var updates = Object.keys(this.reassigned).map(function (name) {
        return aliases[name].outer + " = " + aliases[name].inner + ";";
      });

      if (updates.length) {
        if (this.body.synthetic) {
          code.appendLeft(this.body.body[0].end, "; " + updates.join(" "));
        } else {
          var lastStatement = this.body.body[this.body.body.length - 1];
          code.appendLeft(lastStatement.end, "\n\n" + i1 + updates.join("\n" + i1));
        }
      }
    }

    LoopStatement$$1.prototype.transpile.call(this, code, transforms);
  };

  return ForStatement;
}(LoopStatement);

var ForInStatement = function (LoopStatement$$1) {
  function ForInStatement() {
    LoopStatement$$1.apply(this, arguments);
  }

  if (LoopStatement$$1) ForInStatement.__proto__ = LoopStatement$$1;
  ForInStatement.prototype = Object.create(LoopStatement$$1 && LoopStatement$$1.prototype);
  ForInStatement.prototype.constructor = ForInStatement;

  ForInStatement.prototype.findScope = function findScope(functionScope) {
    return functionScope || !this.createdScope ? this.parent.findScope(functionScope) : this.body.scope;
  };

  ForInStatement.prototype.transpile = function transpile(code, transforms) {
    var this$1 = this;
    var hasDeclaration = this.left.type === 'VariableDeclaration';

    if (this.shouldRewriteAsFunction) {
      // which variables are declared in the init statement?
      var names = hasDeclaration ? this.left.declarations.map(function (declarator) {
        return extractNames(declarator.id);
      }) : [];
      this.args = names.map(function (name) {
        return name in this$1.aliases ? this$1.aliases[name].outer : name;
      });
      this.params = names.map(function (name) {
        return name in this$1.aliases ? this$1.aliases[name].inner : name;
      });
    }

    LoopStatement$$1.prototype.transpile.call(this, code, transforms);
    var maybePattern = hasDeclaration ? this.left.declarations[0].id : this.left;

    if (maybePattern.type !== 'Identifier') {
      this.destructurePattern(code, maybePattern, hasDeclaration);
    }
  };

  ForInStatement.prototype.destructurePattern = function destructurePattern(code, pattern, isDeclaration) {
    var scope = this.findScope(true);
    var i0 = this.getIndentation();
    var i1 = i0 + code.getIndentString();
    var ref = scope.createIdentifier('ref');
    var bodyStart = this.body.body.length ? this.body.body[0].start : this.body.start + 1;
    code.move(pattern.start, pattern.end, bodyStart);
    code.prependRight(pattern.end, isDeclaration ? ref : "var " + ref);
    var statementGenerators = [];
    destructure(code, function (id) {
      return scope.createIdentifier(id);
    }, function (ref) {
      var name = ref.name;
      return scope.resolveName(name);
    }, pattern, ref, false, statementGenerators);
    var suffix = ";\n" + i1;
    statementGenerators.forEach(function (fn, i) {
      if (i === statementGenerators.length - 1) {
        suffix = ";\n\n" + i1;
      }

      fn(bodyStart, '', suffix);
    });
  };

  return ForInStatement;
}(LoopStatement);

var ForOfStatement = function (LoopStatement$$1) {
  function ForOfStatement() {
    LoopStatement$$1.apply(this, arguments);
  }

  if (LoopStatement$$1) ForOfStatement.__proto__ = LoopStatement$$1;
  ForOfStatement.prototype = Object.create(LoopStatement$$1 && LoopStatement$$1.prototype);
  ForOfStatement.prototype.constructor = ForOfStatement;

  ForOfStatement.prototype.initialise = function initialise(transforms) {
    if (transforms.forOf && !transforms.dangerousForOf) {
      throw new CompileError("for...of statements are not supported. Use `transforms: { forOf: false }` to skip transformation and disable this error, or `transforms: { dangerousForOf: true }` if you know what you're doing", this);
    }

    LoopStatement$$1.prototype.initialise.call(this, transforms);
  };

  ForOfStatement.prototype.transpile = function transpile(code, transforms) {
    LoopStatement$$1.prototype.transpile.call(this, code, transforms);

    if (!transforms.dangerousForOf) {
      return;
    } // edge case (#80)


    if (!this.body.body[0]) {
      if (this.left.type === 'VariableDeclaration' && this.left.kind === 'var') {
        code.remove(this.start, this.left.start);
        code.appendLeft(this.left.end, ';');
        code.remove(this.left.end, this.end);
      } else {
        code.remove(this.start, this.end);
      }

      return;
    }

    var scope = this.findScope(true);
    var i0 = this.getIndentation();
    var i1 = i0 + code.getIndentString();
    var key = scope.createIdentifier('i');
    var list = scope.createIdentifier('list');

    if (this.body.synthetic) {
      code.prependRight(this.left.start, "{\n" + i1);
      code.appendLeft(this.body.body[0].end, "\n" + i0 + "}");
    }

    var bodyStart = this.body.body[0].start;
    code.remove(this.left.end, this.right.start);
    code.move(this.left.start, this.left.end, bodyStart);
    code.prependRight(this.right.start, "var " + key + " = 0, " + list + " = ");
    code.appendLeft(this.right.end, "; " + key + " < " + list + ".length; " + key + " += 1");
    var isDeclaration = this.left.type === 'VariableDeclaration';
    var maybeDestructuring = isDeclaration ? this.left.declarations[0].id : this.left;

    if (maybeDestructuring.type !== 'Identifier') {
      var statementGenerators = [];
      var ref = scope.createIdentifier('ref');
      destructure(code, function (id) {
        return scope.createIdentifier(id);
      }, function (ref) {
        var name = ref.name;
        return scope.resolveName(name);
      }, maybeDestructuring, ref, !isDeclaration, statementGenerators);
      var suffix = ";\n" + i1;
      statementGenerators.forEach(function (fn, i) {
        if (i === statementGenerators.length - 1) {
          suffix = ";\n\n" + i1;
        }

        fn(bodyStart, '', suffix);
      });

      if (isDeclaration) {
        code.appendLeft(this.left.start + this.left.kind.length + 1, ref);
        code.appendLeft(this.left.end, " = " + list + "[" + key + "];\n" + i1);
      } else {
        code.appendLeft(this.left.end, "var " + ref + " = " + list + "[" + key + "];\n" + i1);
      }
    } else {
      code.appendLeft(this.left.end, " = " + list + "[" + key + "];\n\n" + i1);
    }
  };

  return ForOfStatement;
}(LoopStatement);

var FunctionDeclaration = function (Node) {
  function FunctionDeclaration() {
    Node.apply(this, arguments);
  }

  if (Node) FunctionDeclaration.__proto__ = Node;
  FunctionDeclaration.prototype = Object.create(Node && Node.prototype);
  FunctionDeclaration.prototype.constructor = FunctionDeclaration;

  FunctionDeclaration.prototype.initialise = function initialise(transforms) {
    if (this.generator && transforms.generator) {
      throw new CompileError('Generators are not supported', this);
    }

    this.body.createScope();

    if (this.id) {
      this.findScope(true).addDeclaration(this.id, 'function');
    }

    Node.prototype.initialise.call(this, transforms);
  };

  FunctionDeclaration.prototype.transpile = function transpile(code, transforms) {
    Node.prototype.transpile.call(this, code, transforms);

    if (transforms.trailingFunctionCommas && this.params.length) {
      removeTrailingComma(code, this.params[this.params.length - 1].end);
    }
  };

  return FunctionDeclaration;
}(Node$1);

var FunctionExpression = function (Node) {
  function FunctionExpression() {
    Node.apply(this, arguments);
  }

  if (Node) FunctionExpression.__proto__ = Node;
  FunctionExpression.prototype = Object.create(Node && Node.prototype);
  FunctionExpression.prototype.constructor = FunctionExpression;

  FunctionExpression.prototype.initialise = function initialise(transforms) {
    var this$1 = this;

    if (this.generator && transforms.generator) {
      throw new CompileError('Generators are not supported', this);
    }

    this.body.createScope();

    if (this.id) {
      // function expression IDs belong to the child scope...
      this.body.scope.addDeclaration(this.id, 'function');
    }

    Node.prototype.initialise.call(this, transforms);
    var parent = this.parent;
    var methodName;

    if (transforms.conciseMethodProperty && parent.type === 'Property' && parent.kind === 'init' && parent.method && parent.key.type === 'Identifier') {
      // object literal concise method
      methodName = parent.key.name;
    } else if (transforms.classes && parent.type === 'MethodDefinition' && parent.kind === 'method' && parent.key.type === 'Identifier') {
      // method definition in a class
      methodName = parent.key.name;
    } else if (this.id && this.id.type === 'Identifier') {
      // naked function expression
      methodName = this.id.alias || this.id.name;
    }

    if (methodName) {
      for (var i$1 = 0, list$1 = this$1.params; i$1 < list$1.length; i$1 += 1) {
        var param = list$1[i$1];

        if (param.type === 'Identifier' && methodName === param.name) {
          // workaround for Safari 9/WebKit bug:
          // https://gitlab.com/Rich-Harris/buble/issues/154
          // change parameter name when same as method name
          var scope = this$1.body.scope;
          var declaration = scope.declarations[methodName];
          var alias = scope.createIdentifier(methodName);
          param.alias = alias;

          for (var i = 0, list = declaration.instances; i < list.length; i += 1) {
            var identifier = list[i];
            identifier.alias = alias;
          }

          break;
        }
      }
    }
  };

  FunctionExpression.prototype.transpile = function transpile(code, transforms) {
    Node.prototype.transpile.call(this, code, transforms);

    if (transforms.trailingFunctionCommas && this.params.length) {
      removeTrailingComma(code, this.params[this.params.length - 1].end);
    }
  };

  return FunctionExpression;
}(Node$1);

function isReference(node, parent) {
  if (node.type === 'MemberExpression') {
    return !node.computed && isReference(node.object, node);
  }

  if (node.type === 'Identifier') {
    // the only time we could have an identifier node without a parent is
    // if it's the entire body of a function without a block statement –
    // i.e. an arrow function expression like `a => a`
    if (!parent) {
      return true;
    }

    if (/(Function|Class)Expression/.test(parent.type)) {
      return false;
    }

    if (parent.type === 'VariableDeclarator') {
      return node === parent.init;
    } // TODO is this right?


    if (parent.type === 'MemberExpression' || parent.type === 'MethodDefinition') {
      return parent.computed || node === parent.object;
    }

    if (parent.type === 'ArrayPattern') {
      return false;
    } // disregard the `bar` in `{ bar: foo }`, but keep it in `{ [bar]: foo }`


    if (parent.type === 'Property') {
      if (parent.parent.type === 'ObjectPattern') {
        return false;
      }

      return parent.computed || node === parent.value;
    } // disregard the `bar` in `class Foo { bar () {...} }`


    if (parent.type === 'MethodDefinition') {
      return false;
    } // disregard the `bar` in `export { foo as bar }`


    if (parent.type === 'ExportSpecifier' && node !== parent.local) {
      return false;
    }

    return true;
  }
}

var Identifier = function (Node) {
  function Identifier() {
    Node.apply(this, arguments);
  }

  if (Node) Identifier.__proto__ = Node;
  Identifier.prototype = Object.create(Node && Node.prototype);
  Identifier.prototype.constructor = Identifier;

  Identifier.prototype.findScope = function findScope(functionScope) {
    if (this.parent.params && ~this.parent.params.indexOf(this)) {
      return this.parent.body.scope;
    }

    if (this.parent.type === 'FunctionExpression' && this === this.parent.id) {
      return this.parent.body.scope;
    }

    return this.parent.findScope(functionScope);
  };

  Identifier.prototype.initialise = function initialise(transforms) {
    if (isReference(this, this.parent)) {
      if (transforms.arrow && this.name === 'arguments' && !this.findScope(false).contains(this.name)) {
        var lexicalBoundary = this.findLexicalBoundary();
        var arrowFunction = this.findNearest('ArrowFunctionExpression');
        var loop = this.findNearest(loopStatement);

        if (arrowFunction && arrowFunction.depth > lexicalBoundary.depth) {
          this.alias = lexicalBoundary.getArgumentsAlias();
        }

        if (loop && loop.body.contains(this) && loop.depth > lexicalBoundary.depth) {
          this.alias = lexicalBoundary.getArgumentsAlias();
        }
      }

      this.findScope(false).addReference(this);
    }
  };

  Identifier.prototype.transpile = function transpile(code) {
    if (this.alias) {
      code.overwrite(this.start, this.end, this.alias, {
        storeName: true,
        contentOnly: true
      });
    }
  };

  return Identifier;
}(Node$1);

var IfStatement = function (Node) {
  function IfStatement() {
    Node.apply(this, arguments);
  }

  if (Node) IfStatement.__proto__ = Node;
  IfStatement.prototype = Object.create(Node && Node.prototype);
  IfStatement.prototype.constructor = IfStatement;

  IfStatement.prototype.initialise = function initialise(transforms) {
    Node.prototype.initialise.call(this, transforms);
  };

  IfStatement.prototype.transpile = function transpile(code, transforms) {
    if (this.consequent.type !== 'BlockStatement' || this.consequent.type === 'BlockStatement' && this.consequent.synthetic) {
      code.appendLeft(this.consequent.start, '{ ');
      code.prependRight(this.consequent.end, ' }');
    }

    if (this.alternate && this.alternate.type !== 'IfStatement' && (this.alternate.type !== 'BlockStatement' || this.alternate.type === 'BlockStatement' && this.alternate.synthetic)) {
      code.appendLeft(this.alternate.start, '{ ');
      code.prependRight(this.alternate.end, ' }');
    }

    Node.prototype.transpile.call(this, code, transforms);
  };

  return IfStatement;
}(Node$1);

var ImportDeclaration = function (Node) {
  function ImportDeclaration() {
    Node.apply(this, arguments);
  }

  if (Node) ImportDeclaration.__proto__ = Node;
  ImportDeclaration.prototype = Object.create(Node && Node.prototype);
  ImportDeclaration.prototype.constructor = ImportDeclaration;

  ImportDeclaration.prototype.initialise = function initialise(transforms) {
    if (transforms.moduleImport) {
      throw new CompileError('import is not supported', this);
    }

    Node.prototype.initialise.call(this, transforms);
  };

  return ImportDeclaration;
}(Node$1);

var ImportDefaultSpecifier = function (Node) {
  function ImportDefaultSpecifier() {
    Node.apply(this, arguments);
  }

  if (Node) ImportDefaultSpecifier.__proto__ = Node;
  ImportDefaultSpecifier.prototype = Object.create(Node && Node.prototype);
  ImportDefaultSpecifier.prototype.constructor = ImportDefaultSpecifier;

  ImportDefaultSpecifier.prototype.initialise = function initialise(transforms) {
    this.findScope(true).addDeclaration(this.local, 'import');
    Node.prototype.initialise.call(this, transforms);
  };

  return ImportDefaultSpecifier;
}(Node$1);

var ImportSpecifier = function (Node) {
  function ImportSpecifier() {
    Node.apply(this, arguments);
  }

  if (Node) ImportSpecifier.__proto__ = Node;
  ImportSpecifier.prototype = Object.create(Node && Node.prototype);
  ImportSpecifier.prototype.constructor = ImportSpecifier;

  ImportSpecifier.prototype.initialise = function initialise(transforms) {
    this.findScope(true).addDeclaration(this.local, 'import');
    Node.prototype.initialise.call(this, transforms);
  };

  return ImportSpecifier;
}(Node$1);

var hasDashes = function hasDashes(val) {
  return /-/.test(val);
};

var formatKey = function formatKey(key) {
  return hasDashes(key) ? "'" + key + "'" : key;
};

var formatVal = function formatVal(val) {
  return val ? '' : 'true';
};

var JSXAttribute = function (Node) {
  function JSXAttribute() {
    Node.apply(this, arguments);
  }

  if (Node) JSXAttribute.__proto__ = Node;
  JSXAttribute.prototype = Object.create(Node && Node.prototype);
  JSXAttribute.prototype.constructor = JSXAttribute;

  JSXAttribute.prototype.transpile = function transpile(code, transforms) {
    var ref = this.name;
    var start = ref.start;
    var name = ref.name; // Overwrite equals sign if value is present.

    var end = this.value ? this.value.start : this.name.end;
    code.overwrite(start, end, formatKey(name) + ": " + formatVal(this.value));
    Node.prototype.transpile.call(this, code, transforms);
  };

  return JSXAttribute;
}(Node$1);

function containsNewLine(node) {
  return node.type === 'JSXText' && !/\S/.test(node.value) && /\n/.test(node.value);
}

var JSXClosingElement = function (Node) {
  function JSXClosingElement() {
    Node.apply(this, arguments);
  }

  if (Node) JSXClosingElement.__proto__ = Node;
  JSXClosingElement.prototype = Object.create(Node && Node.prototype);
  JSXClosingElement.prototype.constructor = JSXClosingElement;

  JSXClosingElement.prototype.transpile = function transpile(code) {
    var spaceBeforeParen = true;
    var lastChild = this.parent.children[this.parent.children.length - 1]; // omit space before closing paren if
    //   a) this is on a separate line, or
    //   b) there are no children but there are attributes

    if (lastChild && containsNewLine(lastChild) || this.parent.openingElement.attributes.length) {
      spaceBeforeParen = false;
    }

    code.overwrite(this.start, this.end, spaceBeforeParen ? ' )' : ')');
  };

  return JSXClosingElement;
}(Node$1);

function containsNewLine$1(node) {
  return node.type === 'JSXText' && !/\S/.test(node.value) && /\n/.test(node.value);
}

var JSXClosingFragment = function (Node) {
  function JSXClosingFragment() {
    Node.apply(this, arguments);
  }

  if (Node) JSXClosingFragment.__proto__ = Node;
  JSXClosingFragment.prototype = Object.create(Node && Node.prototype);
  JSXClosingFragment.prototype.constructor = JSXClosingFragment;

  JSXClosingFragment.prototype.transpile = function transpile(code) {
    var spaceBeforeParen = true;
    var lastChild = this.parent.children[this.parent.children.length - 1]; // omit space before closing paren if this is on a separate line

    if (lastChild && containsNewLine$1(lastChild)) {
      spaceBeforeParen = false;
    }

    code.overwrite(this.start, this.end, spaceBeforeParen ? ' )' : ')');
  };

  return JSXClosingFragment;
}(Node$1);

function normalise(str, removeTrailingWhitespace) {
  str = str.replace(/\u00a0/g, '&nbsp;');

  if (removeTrailingWhitespace && /\n/.test(str)) {
    str = str.replace(/\s+$/, '');
  }

  str = str.replace(/^\n\r?\s+/, '') // remove leading newline + space
  .replace(/\s*\n\r?\s*/gm, ' '); // replace newlines with spaces
  // TODO prefer single quotes?

  return JSON.stringify(str);
}

var JSXElement = function (Node) {
  function JSXElement() {
    Node.apply(this, arguments);
  }

  if (Node) JSXElement.__proto__ = Node;
  JSXElement.prototype = Object.create(Node && Node.prototype);
  JSXElement.prototype.constructor = JSXElement;

  JSXElement.prototype.transpile = function transpile(code, transforms) {
    Node.prototype.transpile.call(this, code, transforms);
    var children = this.children.filter(function (child) {
      if (child.type !== 'JSXText') {
        return true;
      } // remove whitespace-only literals, unless on a single line


      return /\S/.test(child.raw) || !/\n/.test(child.raw);
    });

    if (children.length) {
      var c = (this.openingElement || this.openingFragment).end;
      var i;

      for (i = 0; i < children.length; i += 1) {
        var child = children[i];
        if (child.type === 'JSXExpressionContainer' && child.expression.type === 'JSXEmptyExpression') ;else {
          var tail = code.original[c] === '\n' && child.type !== 'JSXText' ? '' : ' ';
          code.appendLeft(c, "," + tail);
        }

        if (child.type === 'JSXText') {
          var str = normalise(child.value, i === children.length - 1);
          code.overwrite(child.start, child.end, str);
        }

        c = child.end;
      }
    }
  };

  return JSXElement;
}(Node$1);

var JSXExpressionContainer = function (Node) {
  function JSXExpressionContainer() {
    Node.apply(this, arguments);
  }

  if (Node) JSXExpressionContainer.__proto__ = Node;
  JSXExpressionContainer.prototype = Object.create(Node && Node.prototype);
  JSXExpressionContainer.prototype.constructor = JSXExpressionContainer;

  JSXExpressionContainer.prototype.transpile = function transpile(code, transforms) {
    code.remove(this.start, this.expression.start);
    code.remove(this.expression.end, this.end);
    Node.prototype.transpile.call(this, code, transforms);
  };

  return JSXExpressionContainer;
}(Node$1);

var JSXFragment = function (JSXElement$$1) {
  function JSXFragment() {
    JSXElement$$1.apply(this, arguments);
  }

  if (JSXElement$$1) JSXFragment.__proto__ = JSXElement$$1;
  JSXFragment.prototype = Object.create(JSXElement$$1 && JSXElement$$1.prototype);
  JSXFragment.prototype.constructor = JSXFragment;
  return JSXFragment;
}(JSXElement);

var JSXOpeningElement = function (Node) {
  function JSXOpeningElement() {
    Node.apply(this, arguments);
  }

  if (Node) JSXOpeningElement.__proto__ = Node;
  JSXOpeningElement.prototype = Object.create(Node && Node.prototype);
  JSXOpeningElement.prototype.constructor = JSXOpeningElement;

  JSXOpeningElement.prototype.transpile = function transpile(code, transforms) {
    var this$1 = this;
    Node.prototype.transpile.call(this, code, transforms);
    code.overwrite(this.start, this.name.start, this.program.jsx + "( ");
    var html = this.name.type === 'JSXIdentifier' && this.name.name[0] === this.name.name[0].toLowerCase();

    if (html) {
      code.prependRight(this.name.start, "'");
    }

    var len = this.attributes.length;
    var c = this.name.end;

    if (len) {
      var i;
      var hasSpread = false;

      for (i = 0; i < len; i += 1) {
        if (this$1.attributes[i].type === 'JSXSpreadAttribute') {
          hasSpread = true;
          break;
        }
      }

      c = this.attributes[0].end;

      for (i = 0; i < len; i += 1) {
        var attr = this$1.attributes[i];

        if (i > 0) {
          if (attr.start === c) {
            code.prependRight(c, ', ');
          } else {
            code.overwrite(c, attr.start, ', ');
          }
        }

        if (hasSpread && attr.type !== 'JSXSpreadAttribute') {
          var lastAttr = this$1.attributes[i - 1];
          var nextAttr = this$1.attributes[i + 1];

          if (!lastAttr || lastAttr.type === 'JSXSpreadAttribute') {
            code.prependRight(attr.start, '{ ');
          }

          if (!nextAttr || nextAttr.type === 'JSXSpreadAttribute') {
            code.appendLeft(attr.end, ' }');
          }
        }

        c = attr.end;
      }

      var after;
      var before;

      if (hasSpread) {
        if (len === 1) {
          before = html ? "'," : ',';
        } else {
          if (!this.program.options.objectAssign) {
            throw new CompileError("Mixed JSX attributes ending in spread requires specified objectAssign option with 'Object.assign' or polyfill helper.", this);
          }

          before = html ? "', " + this.program.options.objectAssign + "({}," : ", " + this.program.options.objectAssign + "({},";
          after = ')';
        }
      } else {
        before = html ? "', {" : ', {';
        after = ' }';
      }

      code.prependRight(this.name.end, before);

      if (after) {
        code.appendLeft(this.attributes[len - 1].end, after);
      }
    } else {
      code.appendLeft(this.name.end, html ? "', null" : ", null");
      c = this.name.end;
    }

    if (this.selfClosing) {
      code.overwrite(c, this.end, this.attributes.length ? ")" : " )");
    } else {
      code.remove(c, this.end);
    }
  };

  return JSXOpeningElement;
}(Node$1);

var JSXOpeningFragment = function (Node) {
  function JSXOpeningFragment() {
    Node.apply(this, arguments);
  }

  if (Node) JSXOpeningFragment.__proto__ = Node;
  JSXOpeningFragment.prototype = Object.create(Node && Node.prototype);
  JSXOpeningFragment.prototype.constructor = JSXOpeningFragment;

  JSXOpeningFragment.prototype.transpile = function transpile(code) {
    code.overwrite(this.start, this.end, this.program.jsx + "( React.Fragment, null");
  };

  return JSXOpeningFragment;
}(Node$1);

var JSXSpreadAttribute = function (Node) {
  function JSXSpreadAttribute() {
    Node.apply(this, arguments);
  }

  if (Node) JSXSpreadAttribute.__proto__ = Node;
  JSXSpreadAttribute.prototype = Object.create(Node && Node.prototype);
  JSXSpreadAttribute.prototype.constructor = JSXSpreadAttribute;

  JSXSpreadAttribute.prototype.transpile = function transpile(code, transforms) {
    code.remove(this.start, this.argument.start);
    code.remove(this.argument.end, this.end);
    Node.prototype.transpile.call(this, code, transforms);
  };

  return JSXSpreadAttribute;
}(Node$1);

var nonAsciiLsOrPs = /[\u2028-\u2029]/g;

var Literal = function (Node) {
  function Literal() {
    Node.apply(this, arguments);
  }

  if (Node) Literal.__proto__ = Node;
  Literal.prototype = Object.create(Node && Node.prototype);
  Literal.prototype.constructor = Literal;

  Literal.prototype.initialise = function initialise() {
    if (typeof this.value === 'string') {
      this.program.indentExclusionElements.push(this);
    }
  };

  Literal.prototype.transpile = function transpile(code, transforms) {
    if (transforms.numericLiteral) {
      if (this.raw.match(/^0[bo]/i)) {
        code.overwrite(this.start, this.end, String(this.value), {
          storeName: true,
          contentOnly: true
        });
      }
    }

    if (this.regex) {
      var ref = this.regex;
      var pattern = ref.pattern;
      var flags = ref.flags;

      if (transforms.stickyRegExp && /y/.test(flags)) {
        throw new CompileError('Regular expression sticky flag is not supported', this);
      }

      if (transforms.unicodeRegExp && /u/.test(flags)) {
        code.overwrite(this.start, this.end, "/" + rewritePattern(pattern, flags) + "/" + flags.replace('u', ''), {
          contentOnly: true
        });
      }
    } else if (typeof this.value === "string" && this.value.match(nonAsciiLsOrPs)) {
      code.overwrite(this.start, this.end, this.raw.replace(nonAsciiLsOrPs, function (m) {
        return m == "\u2028" ? "\\u2028" : "\\u2029";
      }), {
        contentOnly: true
      });
    }
  };

  return Literal;
}(Node$1);

var MemberExpression = function (Node) {
  function MemberExpression() {
    Node.apply(this, arguments);
  }

  if (Node) MemberExpression.__proto__ = Node;
  MemberExpression.prototype = Object.create(Node && Node.prototype);
  MemberExpression.prototype.constructor = MemberExpression;

  MemberExpression.prototype.transpile = function transpile(code, transforms) {
    if (transforms.reservedProperties && reserved[this.property.name]) {
      code.overwrite(this.object.end, this.property.start, "['");
      code.appendLeft(this.property.end, "']");
    }

    Node.prototype.transpile.call(this, code, transforms);
  };

  return MemberExpression;
}(Node$1);

var NewExpression = function (Node) {
  function NewExpression() {
    Node.apply(this, arguments);
  }

  if (Node) NewExpression.__proto__ = Node;
  NewExpression.prototype = Object.create(Node && Node.prototype);
  NewExpression.prototype.constructor = NewExpression;

  NewExpression.prototype.initialise = function initialise(transforms) {
    var this$1 = this;

    if (transforms.spreadRest && this.arguments.length) {
      var lexicalBoundary = this.findLexicalBoundary();
      var i = this.arguments.length;

      while (i--) {
        var arg = this$1.arguments[i];

        if (arg.type === 'SpreadElement' && isArguments(arg.argument)) {
          this$1.argumentsArrayAlias = lexicalBoundary.getArgumentsArrayAlias();
          break;
        }
      }
    }

    Node.prototype.initialise.call(this, transforms);
  };

  NewExpression.prototype.transpile = function transpile(code, transforms) {
    Node.prototype.transpile.call(this, code, transforms);

    if (transforms.spreadRest && this.arguments.length) {
      var firstArgument = this.arguments[0];
      var isNew = true;
      var hasSpreadElements = spread(code, this.arguments, firstArgument.start, this.argumentsArrayAlias, isNew);

      if (hasSpreadElements) {
        code.prependRight(this.start + 'new'.length, ' (Function.prototype.bind.apply(');
        code.overwrite(this.callee.end, firstArgument.start, ', [ null ].concat( ');
        code.appendLeft(this.end, ' ))');
      }
    }

    if (this.arguments.length) {
      removeTrailingComma(code, this.arguments[this.arguments.length - 1].end);
    }
  };

  return NewExpression;
}(Node$1);

var ObjectExpression = function (Node) {
  function ObjectExpression() {
    Node.apply(this, arguments);
  }

  if (Node) ObjectExpression.__proto__ = Node;
  ObjectExpression.prototype = Object.create(Node && Node.prototype);
  ObjectExpression.prototype.constructor = ObjectExpression;

  ObjectExpression.prototype.transpile = function transpile(code, transforms) {
    var this$1 = this;
    Node.prototype.transpile.call(this, code, transforms);
    var firstPropertyStart = this.start + 1;
    var spreadPropertyCount = 0;
    var computedPropertyCount = 0;
    var firstSpreadProperty = null;
    var firstComputedProperty = null;

    for (var i = 0; i < this.properties.length; ++i) {
      var prop = this$1.properties[i];

      if (prop.type === 'SpreadElement') {
        spreadPropertyCount += 1;

        if (firstSpreadProperty === null) {
          firstSpreadProperty = i;
        }
      } else if (prop.computed && transforms.computedProperty) {
        computedPropertyCount += 1;

        if (firstComputedProperty === null) {
          firstComputedProperty = i;
        }
      }
    }

    if (spreadPropertyCount && !transforms.objectRestSpread && !(computedPropertyCount && transforms.computedProperty)) {
      spreadPropertyCount = 0;
      firstSpreadProperty = null;
    } else if (spreadPropertyCount) {
      if (!this.program.options.objectAssign) {
        throw new CompileError("Object spread operator requires specified objectAssign option with 'Object.assign' or polyfill helper.", this);
      }

      var i$1 = this.properties.length;

      while (i$1--) {
        var prop$1 = this$1.properties[i$1]; // enclose run of non-spread properties in curlies

        if (prop$1.type === 'Property' && !computedPropertyCount) {
          var lastProp = this$1.properties[i$1 - 1];
          var nextProp = this$1.properties[i$1 + 1];

          if (!lastProp || lastProp.type !== 'Property') {
            code.prependRight(prop$1.start, '{');
          }

          if (!nextProp || nextProp.type !== 'Property') {
            code.appendLeft(prop$1.end, '}');
          }
        } // Remove ellipsis on spread property


        if (prop$1.type === 'SpreadElement') {
          code.remove(prop$1.start, prop$1.argument.start);
          code.remove(prop$1.argument.end, prop$1.end);
        }
      } // wrap the whole thing in Object.assign


      firstPropertyStart = this.properties[0].start;

      if (!computedPropertyCount) {
        code.overwrite(this.start, firstPropertyStart, this.program.options.objectAssign + "({}, ");
        code.overwrite(this.properties[this.properties.length - 1].end, this.end, ')');
      } else if (this.properties[0].type === 'SpreadElement') {
        code.overwrite(this.start, firstPropertyStart, this.program.options.objectAssign + "({}, ");
        code.remove(this.end - 1, this.end);
        code.appendRight(this.end, ')');
      } else {
        code.prependLeft(this.start, this.program.options.objectAssign + "(");
        code.appendRight(this.end, ')');
      }
    }

    if (computedPropertyCount && transforms.computedProperty) {
      var i0 = this.getIndentation();
      var isSimpleAssignment;
      var name;

      if (this.parent.type === 'VariableDeclarator' && this.parent.parent.declarations.length === 1 && this.parent.id.type === 'Identifier') {
        isSimpleAssignment = true;
        name = this.parent.id.alias || this.parent.id.name; // TODO is this right?
      } else if (this.parent.type === 'AssignmentExpression' && this.parent.parent.type === 'ExpressionStatement' && this.parent.left.type === 'Identifier') {
        isSimpleAssignment = true;
        name = this.parent.left.alias || this.parent.left.name; // TODO is this right?
      } else if (this.parent.type === 'AssignmentPattern' && this.parent.left.type === 'Identifier') {
        isSimpleAssignment = true;
        name = this.parent.left.alias || this.parent.left.name; // TODO is this right?
      }

      if (spreadPropertyCount) {
        isSimpleAssignment = false;
      } // handle block scoping


      name = this.findScope(false).resolveName(name);
      var start = firstPropertyStart;
      var end = this.end;
      if (isSimpleAssignment) ;else {
        if (firstSpreadProperty === null || firstComputedProperty < firstSpreadProperty) {
          name = this.findScope(true).createDeclaration('obj');
          code.prependRight(this.start, "( " + name + " = ");
        } else {
          name = null;
        } // We don't actually need this variable

      }
      var len = this.properties.length;
      var lastComputedProp;
      var sawNonComputedProperty = false;
      var isFirst = true;

      for (var i$2 = 0; i$2 < len; i$2 += 1) {
        var prop$2 = this$1.properties[i$2];
        var moveStart = i$2 > 0 ? this$1.properties[i$2 - 1].end : start;

        if (prop$2.type === 'Property' && (prop$2.computed || lastComputedProp && !spreadPropertyCount)) {
          if (i$2 === 0) {
            moveStart = this$1.start + 1;
          } // Trim leading whitespace


          lastComputedProp = prop$2;

          if (!name) {
            name = this$1.findScope(true).createDeclaration('obj');
            var propId = name + (prop$2.computed ? '' : '.');
            code.appendRight(prop$2.start, "( " + name + " = {}, " + propId);
          } else {
            var propId$1 = (isSimpleAssignment ? ";\n" + i0 + name : ", " + name) + (prop$2.key.type === 'Literal' || prop$2.computed ? '' : '.');

            if (moveStart < prop$2.start) {
              code.overwrite(moveStart, prop$2.start, propId$1);
            } else {
              code.prependRight(prop$2.start, propId$1);
            }
          }

          var c = prop$2.key.end;

          if (prop$2.computed) {
            while (code.original[c] !== ']') {
              c += 1;
            }

            c += 1;
          }

          if (prop$2.key.type === 'Literal' && !prop$2.computed) {
            code.overwrite(prop$2.start, prop$2.key.end + 1, '[' + code.slice(prop$2.start, prop$2.key.end) + '] = ');
          } else if (prop$2.shorthand || prop$2.method && !prop$2.computed && transforms.conciseMethodProperty) {
            // Replace : with = if Property::transpile inserted the :
            code.overwrite(prop$2.key.start, prop$2.key.end, code.slice(prop$2.key.start, prop$2.key.end).replace(/:/, ' ='));
          } else {
            if (prop$2.value.start > c) {
              code.remove(c, prop$2.value.start);
            }

            code.prependLeft(c, ' = ');
          } // This duplicates behavior from Property::transpile which is disabled
          // for computed properties or if conciseMethodProperty is false


          if (prop$2.method && (prop$2.computed || !transforms.conciseMethodProperty)) {
            if (prop$2.value.generator) {
              code.remove(prop$2.start, prop$2.key.start);
            }

            code.prependRight(prop$2.value.start, "function" + (prop$2.value.generator ? '*' : '') + " ");
          }
        } else if (prop$2.type === 'SpreadElement') {
          if (name && i$2 > 0) {
            if (!lastComputedProp) {
              lastComputedProp = this$1.properties[i$2 - 1];
            }

            code.appendLeft(lastComputedProp.end, ", " + name + " )");
            lastComputedProp = null;
            name = null;
          }
        } else {
          if (!isFirst && spreadPropertyCount) {
            // We are in an Object.assign context, so we need to wrap regular properties
            code.prependRight(prop$2.start, '{');
            code.appendLeft(prop$2.end, '}');
          }

          sawNonComputedProperty = true;
        }

        if (isFirst && (prop$2.type === 'SpreadElement' || prop$2.computed)) {
          var beginEnd = sawNonComputedProperty ? this$1.properties[this$1.properties.length - 1].end : this$1.end - 1; // Trim trailing comma because it can easily become a leading comma which is illegal

          if (code.original[beginEnd] == ',') {
            ++beginEnd;
          }

          var closing = code.slice(beginEnd, end);
          code.prependLeft(moveStart, closing);
          code.remove(beginEnd, end);
          isFirst = false;
        } // Clean up some extranous whitespace


        var c$1 = prop$2.end;

        if (i$2 < len - 1 && !sawNonComputedProperty) {
          while (code.original[c$1] !== ',') {
            c$1 += 1;
          }
        } else if (i$2 == len - 1) {
          c$1 = this$1.end;
        }

        if (prop$2.end != c$1) {
          code.overwrite(prop$2.end, c$1, '', {
            contentOnly: true
          });
        }
      }

      if (!isSimpleAssignment && name) {
        code.appendLeft(lastComputedProp.end, ", " + name + " )");
      }
    }
  };

  return ObjectExpression;
}(Node$1);

var Property = function (Node) {
  function Property() {
    Node.apply(this, arguments);
  }

  if (Node) Property.__proto__ = Node;
  Property.prototype = Object.create(Node && Node.prototype);
  Property.prototype.constructor = Property;

  Property.prototype.initialise = function initialise(transforms) {
    if ((this.kind === 'get' || this.kind === 'set') && transforms.getterSetter) {
      throw new CompileError("getters and setters are not supported. Use `transforms: { getterSetter: false }` to skip transformation and disable this error", this);
    }

    Node.prototype.initialise.call(this, transforms);
  };

  Property.prototype.transpile = function transpile(code, transforms) {
    Node.prototype.transpile.call(this, code, transforms);

    if (transforms.conciseMethodProperty && !this.computed && this.parent.type !== 'ObjectPattern') {
      if (this.shorthand) {
        code.prependRight(this.start, this.key.name + ": ");
      } else if (this.method) {
        var name = '';

        if (this.program.options.namedFunctionExpressions !== false) {
          if (this.key.type === 'Literal' && typeof this.key.value === 'number') {
            name = '';
          } else if (this.key.type === 'Identifier') {
            if (reserved[this.key.name] || !/^[a-z_$][a-z0-9_$]*$/i.test(this.key.name) || this.value.body.scope.references[this.key.name]) {
              name = this.findScope(true).createIdentifier(this.key.name);
            } else {
              name = this.key.name;
            }
          } else {
            name = this.findScope(true).createIdentifier(this.key.value);
          }

          name = ' ' + name;
        }

        if (this.value.generator) {
          code.remove(this.start, this.key.start);
        }

        code.appendLeft(this.key.end, ": function" + (this.value.generator ? '*' : '') + name);
      }
    }

    if (transforms.reservedProperties && reserved[this.key.name]) {
      code.prependRight(this.key.start, "'");
      code.appendLeft(this.key.end, "'");
    }
  };

  return Property;
}(Node$1);

var ReturnStatement = function (Node) {
  function ReturnStatement() {
    Node.apply(this, arguments);
  }

  if (Node) ReturnStatement.__proto__ = Node;
  ReturnStatement.prototype = Object.create(Node && Node.prototype);
  ReturnStatement.prototype.constructor = ReturnStatement;

  ReturnStatement.prototype.initialise = function initialise(transforms) {
    this.loop = this.findNearest(loopStatement);
    this.nearestFunction = this.findNearest(/Function/);

    if (this.loop && (!this.nearestFunction || this.loop.depth > this.nearestFunction.depth)) {
      this.loop.canReturn = true;
      this.shouldWrap = true;
    }

    if (this.argument) {
      this.argument.initialise(transforms);
    }
  };

  ReturnStatement.prototype.transpile = function transpile(code, transforms) {
    var shouldWrap = this.shouldWrap && this.loop && this.loop.shouldRewriteAsFunction;

    if (this.argument) {
      if (shouldWrap) {
        code.prependRight(this.argument.start, "{ v: ");
      }

      this.argument.transpile(code, transforms);

      if (shouldWrap) {
        code.appendLeft(this.argument.end, " }");
      }
    } else if (shouldWrap) {
      code.appendLeft(this.start + 6, ' {}');
    }
  };

  return ReturnStatement;
}(Node$1);

var Super = function (Node) {
  function Super() {
    Node.apply(this, arguments);
  }

  if (Node) Super.__proto__ = Node;
  Super.prototype = Object.create(Node && Node.prototype);
  Super.prototype.constructor = Super;

  Super.prototype.initialise = function initialise(transforms) {
    if (transforms.classes) {
      this.method = this.findNearest('MethodDefinition');

      if (!this.method) {
        throw new CompileError('use of super outside class method', this);
      }

      var parentClass = this.findNearest('ClassBody').parent;
      this.superClassName = parentClass.superClass && (parentClass.superClass.name || 'superclass');

      if (!this.superClassName) {
        throw new CompileError('super used in base class', this);
      }

      this.isCalled = this.parent.type === 'CallExpression' && this === this.parent.callee;

      if (this.method.kind !== 'constructor' && this.isCalled) {
        throw new CompileError('super() not allowed outside class constructor', this);
      }

      this.isMember = this.parent.type === 'MemberExpression';

      if (!this.isCalled && !this.isMember) {
        throw new CompileError('Unexpected use of `super` (expected `super(...)` or `super.*`)', this);
      }
    }

    if (transforms.arrow) {
      var lexicalBoundary = this.findLexicalBoundary();
      var arrowFunction = this.findNearest('ArrowFunctionExpression');
      var loop = this.findNearest(loopStatement);

      if (arrowFunction && arrowFunction.depth > lexicalBoundary.depth) {
        this.thisAlias = lexicalBoundary.getThisAlias();
      }

      if (loop && loop.body.contains(this) && loop.depth > lexicalBoundary.depth) {
        this.thisAlias = lexicalBoundary.getThisAlias();
      }
    }
  };

  Super.prototype.transpile = function transpile(code, transforms) {
    if (transforms.classes) {
      var expression = this.isCalled || this.method["static"] ? this.superClassName : this.superClassName + ".prototype";
      code.overwrite(this.start, this.end, expression, {
        storeName: true,
        contentOnly: true
      });
      var callExpression = this.isCalled ? this.parent : this.parent.parent;

      if (callExpression && callExpression.type === 'CallExpression') {
        if (!this.noCall) {
          // special case – `super( ...args )`
          code.appendLeft(callExpression.callee.end, '.call');
        }

        var thisAlias = this.thisAlias || 'this';

        if (callExpression.arguments.length) {
          code.appendLeft(callExpression.arguments[0].start, thisAlias + ", ");
        } else {
          code.appendLeft(callExpression.end - 1, "" + thisAlias);
        }
      }
    }
  };

  return Super;
}(Node$1);

var TaggedTemplateExpression = function (Node) {
  function TaggedTemplateExpression() {
    Node.apply(this, arguments);
  }

  if (Node) TaggedTemplateExpression.__proto__ = Node;
  TaggedTemplateExpression.prototype = Object.create(Node && Node.prototype);
  TaggedTemplateExpression.prototype.constructor = TaggedTemplateExpression;

  TaggedTemplateExpression.prototype.initialise = function initialise(transforms) {
    if (transforms.templateString && !transforms.dangerousTaggedTemplateString) {
      throw new CompileError("Tagged template strings are not supported. Use `transforms: { templateString: false }` to skip transformation and disable this error, or `transforms: { dangerousTaggedTemplateString: true }` if you know what you're doing", this);
    }

    Node.prototype.initialise.call(this, transforms);
  };

  TaggedTemplateExpression.prototype.transpile = function transpile(code, transforms) {
    if (transforms.templateString && transforms.dangerousTaggedTemplateString) {
      var ordered = this.quasi.expressions.concat(this.quasi.quasis).sort(function (a, b) {
        return a.start - b.start;
      });
      var program = this.program;
      var rootScope = program.body.scope; // insert strings at start

      var templateStrings = this.quasi.quasis.map(function (quasi) {
        return JSON.stringify(quasi.value.cooked);
      }).join(', ');
      var templateObject = this.program.templateLiteralQuasis[templateStrings];

      if (!templateObject) {
        templateObject = rootScope.createIdentifier('templateObject');
        code.prependRight(this.program.prependAt, "var " + templateObject + " = Object.freeze([" + templateStrings + "]);\n");
        this.program.templateLiteralQuasis[templateStrings] = templateObject;
      }

      code.overwrite(this.tag.end, ordered[0].start, "(" + templateObject);
      var lastIndex = ordered[0].start;
      ordered.forEach(function (node) {
        if (node.type === 'TemplateElement') {
          code.remove(lastIndex, node.end);
        } else {
          code.overwrite(lastIndex, node.start, ', ');
        }

        lastIndex = node.end;
      });
      code.overwrite(lastIndex, this.end, ')');
    }

    Node.prototype.transpile.call(this, code, transforms);
  };

  return TaggedTemplateExpression;
}(Node$1);

var TemplateElement = function (Node) {
  function TemplateElement() {
    Node.apply(this, arguments);
  }

  if (Node) TemplateElement.__proto__ = Node;
  TemplateElement.prototype = Object.create(Node && Node.prototype);
  TemplateElement.prototype.constructor = TemplateElement;

  TemplateElement.prototype.initialise = function initialise() {
    this.program.indentExclusionElements.push(this);
  };

  return TemplateElement;
}(Node$1);

var TemplateLiteral = function (Node) {
  function TemplateLiteral() {
    Node.apply(this, arguments);
  }

  if (Node) TemplateLiteral.__proto__ = Node;
  TemplateLiteral.prototype = Object.create(Node && Node.prototype);
  TemplateLiteral.prototype.constructor = TemplateLiteral;

  TemplateLiteral.prototype.transpile = function transpile(code, transforms) {
    Node.prototype.transpile.call(this, code, transforms);

    if (transforms.templateString && this.parent.type !== 'TaggedTemplateExpression') {
      var ordered = this.expressions.concat(this.quasis).sort(function (a, b) {
        return a.start - b.start || a.end - b.end;
      }).filter(function (node, i) {
        // include all expressions
        if (node.type !== 'TemplateElement') {
          return true;
        } // include all non-empty strings


        if (node.value.raw) {
          return true;
        } // exclude all empty strings not at the head


        return !i;
      }); // special case – we may be able to skip the first element,
      // if it's the empty string, but only if the second and
      // third elements aren't both expressions (since they maybe
      // be numeric, and `1 + 2 + '3' === '33'`)

      if (ordered.length >= 3) {
        var first = ordered[0];
        var third = ordered[2];

        if (first.type === 'TemplateElement' && first.value.raw === '' && third.type === 'TemplateElement') {
          ordered.shift();
        }
      }

      var parenthesise = (this.quasis.length !== 1 || this.expressions.length !== 0) && this.parent.type !== 'TemplateLiteral' && this.parent.type !== 'AssignmentExpression' && this.parent.type !== 'AssignmentPattern' && this.parent.type !== 'VariableDeclarator' && (this.parent.type !== 'BinaryExpression' || this.parent.operator !== '+');

      if (parenthesise) {
        code.appendRight(this.start, '(');
      }

      var lastIndex = this.start;
      ordered.forEach(function (node, i) {
        var prefix = i === 0 ? parenthesise ? '(' : '' : ' + ';

        if (node.type === 'TemplateElement') {
          code.overwrite(lastIndex, node.end, prefix + JSON.stringify(node.value.cooked));
        } else {
          var parenthesise$1 = node.type !== 'Identifier'; // TODO other cases where it's safe

          if (parenthesise$1) {
            prefix += '(';
          }

          code.remove(lastIndex, node.start);

          if (prefix) {
            code.prependRight(node.start, prefix);
          }

          if (parenthesise$1) {
            code.appendLeft(node.end, ')');
          }
        }

        lastIndex = node.end;
      });

      if (parenthesise) {
        code.appendLeft(lastIndex, ')');
      }

      code.overwrite(lastIndex, this.end, "", {
        contentOnly: true
      });
    }
  };

  return TemplateLiteral;
}(Node$1);

var ThisExpression = function (Node) {
  function ThisExpression() {
    Node.apply(this, arguments);
  }

  if (Node) ThisExpression.__proto__ = Node;
  ThisExpression.prototype = Object.create(Node && Node.prototype);
  ThisExpression.prototype.constructor = ThisExpression;

  ThisExpression.prototype.initialise = function initialise(transforms) {
    var this$1 = this;
    var lexicalBoundary = this.findLexicalBoundary();

    if (transforms.letConst) {
      // save all loops up to the lexical boundary in case we need
      // to alias them later for block-scoped declarations
      var node = this.findNearest(loopStatement);

      while (node && node.depth > lexicalBoundary.depth) {
        node.thisRefs.push(this$1);
        node = node.parent.findNearest(loopStatement);
      }
    }

    if (transforms.arrow) {
      var arrowFunction = this.findNearest('ArrowFunctionExpression');

      if (arrowFunction && arrowFunction.depth > lexicalBoundary.depth) {
        this.alias = lexicalBoundary.getThisAlias();
      }
    }
  };

  ThisExpression.prototype.transpile = function transpile(code) {
    if (this.alias) {
      code.overwrite(this.start, this.end, this.alias, {
        storeName: true,
        contentOnly: true
      });
    }
  };

  return ThisExpression;
}(Node$1);

var UpdateExpression = function (Node) {
  function UpdateExpression() {
    Node.apply(this, arguments);
  }

  if (Node) UpdateExpression.__proto__ = Node;
  UpdateExpression.prototype = Object.create(Node && Node.prototype);
  UpdateExpression.prototype.constructor = UpdateExpression;

  UpdateExpression.prototype.initialise = function initialise(transforms) {
    if (this.argument.type === 'Identifier') {
      var declaration = this.findScope(false).findDeclaration(this.argument.name); // special case – https://gitlab.com/Rich-Harris/buble/issues/150

      var statement = declaration && declaration.node.ancestor(3);

      if (statement && statement.type === 'ForStatement' && statement.body.contains(this)) {
        statement.reassigned[this.argument.name] = true;
      }
    }

    Node.prototype.initialise.call(this, transforms);
  };

  UpdateExpression.prototype.transpile = function transpile(code, transforms) {
    if (this.argument.type === 'Identifier') {
      // Do this check after everything has been initialized to find
      // shadowing declarations after this expression
      checkConst(this.argument, this.findScope(false));
    }

    Node.prototype.transpile.call(this, code, transforms);
  };

  return UpdateExpression;
}(Node$1);

var VariableDeclaration = function (Node) {
  function VariableDeclaration() {
    Node.apply(this, arguments);
  }

  if (Node) VariableDeclaration.__proto__ = Node;
  VariableDeclaration.prototype = Object.create(Node && Node.prototype);
  VariableDeclaration.prototype.constructor = VariableDeclaration;

  VariableDeclaration.prototype.initialise = function initialise(transforms) {
    this.scope = this.findScope(this.kind === 'var');
    this.declarations.forEach(function (declarator) {
      return declarator.initialise(transforms);
    });
  };

  VariableDeclaration.prototype.transpile = function transpile(code, transforms) {
    var this$1 = this;
    var i0 = this.getIndentation();
    var kind = this.kind;

    if (transforms.letConst && kind !== 'var') {
      kind = 'var';
      code.overwrite(this.start, this.start + this.kind.length, kind, {
        contentOnly: true,
        storeName: true
      });
    }

    if (transforms.destructuring && this.parent.type !== 'ForOfStatement' && this.parent.type !== 'ForInStatement') {
      var c = this.start;
      var lastDeclaratorIsPattern;
      this.declarations.forEach(function (declarator, i) {
        declarator.transpile(code, transforms);

        if (declarator.id.type === 'Identifier') {
          if (i > 0 && this$1.declarations[i - 1].id.type !== 'Identifier') {
            code.overwrite(c, declarator.id.start, "var ");
          }
        } else {
          var inline = loopStatement.test(this$1.parent.type);

          if (i === 0) {
            code.remove(c, declarator.id.start);
          } else {
            code.overwrite(c, declarator.id.start, ";\n" + i0);
          }

          var simple = declarator.init.type === 'Identifier' && !declarator.init.rewritten;
          var name = simple ? declarator.init.alias || declarator.init.name : declarator.findScope(true).createIdentifier('ref');
          c = declarator.start;
          var statementGenerators = [];

          if (simple) {
            code.remove(declarator.id.end, declarator.end);
          } else {
            statementGenerators.push(function (start, prefix, suffix) {
              code.prependRight(declarator.id.end, "var " + name);
              code.appendLeft(declarator.init.end, "" + suffix);
              code.move(declarator.id.end, declarator.end, start);
            });
          }

          var scope = declarator.findScope(false);
          destructure(code, function (id) {
            return scope.createIdentifier(id);
          }, function (ref) {
            var name = ref.name;
            return scope.resolveName(name);
          }, declarator.id, name, inline, statementGenerators);
          var prefix = inline ? 'var ' : '';
          var suffix = inline ? ", " : ";\n" + i0;
          statementGenerators.forEach(function (fn, j) {
            if (i === this$1.declarations.length - 1 && j === statementGenerators.length - 1) {
              suffix = inline ? '' : ';';
            }

            fn(declarator.start, j === 0 ? prefix : '', suffix);
          });
        }

        c = declarator.end;
        lastDeclaratorIsPattern = declarator.id.type !== 'Identifier';
      });

      if (lastDeclaratorIsPattern && this.end > c) {
        code.overwrite(c, this.end, '', {
          contentOnly: true
        });
      }
    } else {
      this.declarations.forEach(function (declarator) {
        declarator.transpile(code, transforms);
      });
    }
  };

  return VariableDeclaration;
}(Node$1);

var VariableDeclarator = function (Node) {
  function VariableDeclarator() {
    Node.apply(this, arguments);
  }

  if (Node) VariableDeclarator.__proto__ = Node;
  VariableDeclarator.prototype = Object.create(Node && Node.prototype);
  VariableDeclarator.prototype.constructor = VariableDeclarator;

  VariableDeclarator.prototype.initialise = function initialise(transforms) {
    var kind = this.parent.kind;

    if (kind === 'let' && this.parent.parent.type === 'ForStatement') {
      kind = 'for.let'; // special case...
    }

    this.parent.scope.addDeclaration(this.id, kind);
    Node.prototype.initialise.call(this, transforms);
  };

  VariableDeclarator.prototype.transpile = function transpile(code, transforms) {
    if (!this.init && transforms.letConst && this.parent.kind !== 'var') {
      var inLoop = this.findNearest(/Function|^For(In|Of)?Statement|^(?:Do)?WhileStatement/);

      if (inLoop && !/Function/.test(inLoop.type) && !this.isLeftDeclaratorOfLoop()) {
        code.appendLeft(this.id.end, ' = (void 0)');
      }
    }

    if (this.id) {
      this.id.transpile(code, transforms);
    }

    if (this.init) {
      this.init.transpile(code, transforms);
    }
  };

  VariableDeclarator.prototype.isLeftDeclaratorOfLoop = function isLeftDeclaratorOfLoop() {
    return this.parent && this.parent.type === 'VariableDeclaration' && this.parent.parent && (this.parent.parent.type === 'ForInStatement' || this.parent.parent.type === 'ForOfStatement') && this.parent.parent.left && this.parent.parent.left.declarations[0] === this;
  };

  return VariableDeclarator;
}(Node$1);

var types$2 = {
  ArrayExpression: ArrayExpression,
  ArrowFunctionExpression: ArrowFunctionExpression,
  AssignmentExpression: AssignmentExpression,
  BinaryExpression: BinaryExpression,
  BreakStatement: BreakStatement,
  CallExpression: CallExpression,
  ClassBody: ClassBody,
  ClassDeclaration: ClassDeclaration,
  ClassExpression: ClassExpression,
  ContinueStatement: ContinueStatement,
  DoWhileStatement: LoopStatement,
  ExportNamedDeclaration: ExportNamedDeclaration,
  ExportDefaultDeclaration: ExportDefaultDeclaration,
  ForStatement: ForStatement,
  ForInStatement: ForInStatement,
  ForOfStatement: ForOfStatement,
  FunctionDeclaration: FunctionDeclaration,
  FunctionExpression: FunctionExpression,
  Identifier: Identifier,
  IfStatement: IfStatement,
  ImportDeclaration: ImportDeclaration,
  ImportDefaultSpecifier: ImportDefaultSpecifier,
  ImportSpecifier: ImportSpecifier,
  JSXAttribute: JSXAttribute,
  JSXClosingElement: JSXClosingElement,
  JSXClosingFragment: JSXClosingFragment,
  JSXElement: JSXElement,
  JSXExpressionContainer: JSXExpressionContainer,
  JSXFragment: JSXFragment,
  JSXOpeningElement: JSXOpeningElement,
  JSXOpeningFragment: JSXOpeningFragment,
  JSXSpreadAttribute: JSXSpreadAttribute,
  Literal: Literal,
  MemberExpression: MemberExpression,
  NewExpression: NewExpression,
  ObjectExpression: ObjectExpression,
  Property: Property,
  ReturnStatement: ReturnStatement,
  Super: Super,
  TaggedTemplateExpression: TaggedTemplateExpression,
  TemplateElement: TemplateElement,
  TemplateLiteral: TemplateLiteral,
  ThisExpression: ThisExpression,
  UpdateExpression: UpdateExpression,
  VariableDeclaration: VariableDeclaration,
  VariableDeclarator: VariableDeclarator,
  WhileStatement: LoopStatement
};
var keys = {
  Program: ['body'],
  Literal: []
};
var statementsWithBlocks = {
  IfStatement: 'consequent',
  ForStatement: 'body',
  ForInStatement: 'body',
  ForOfStatement: 'body',
  WhileStatement: 'body',
  DoWhileStatement: 'body',
  ArrowFunctionExpression: 'body'
};

function wrap(raw, parent) {
  if (!raw) {
    return;
  }

  if ('length' in raw) {
    var i = raw.length;

    while (i--) {
      wrap(raw[i], parent);
    }

    return;
  } // with e.g. shorthand properties, key and value are
  // the same node. We don't want to wrap an object twice


  if (raw.__wrapped) {
    return;
  }

  raw.__wrapped = true;

  if (!keys[raw.type]) {
    keys[raw.type] = Object.keys(raw).filter(function (key) {
      return typeof raw[key] === 'object';
    });
  } // special case – body-less if/for/while statements. TODO others?


  var bodyType = statementsWithBlocks[raw.type];

  if (bodyType && raw[bodyType].type !== 'BlockStatement') {
    var expression = raw[bodyType]; // create a synthetic block statement, otherwise all hell
    // breaks loose when it comes to block scoping

    raw[bodyType] = {
      start: expression.start,
      end: expression.end,
      type: 'BlockStatement',
      body: [expression],
      synthetic: true
    };
  }

  raw.parent = parent;
  raw.program = parent.program || parent;
  raw.depth = parent.depth + 1;
  raw.keys = keys[raw.type];
  raw.indentation = undefined;

  for (var i$1 = 0, list = keys[raw.type]; i$1 < list.length; i$1 += 1) {
    var key = list[i$1];
    wrap(raw[key], raw);
  }

  raw.program.magicString.addSourcemapLocation(raw.start);
  raw.program.magicString.addSourcemapLocation(raw.end);
  var type = (raw.type === 'BlockStatement' ? BlockStatement : types$2[raw.type]) || Node$1;
  raw.__proto__ = type.prototype;
}

function Program(source, ast, transforms, options) {
  var this$1 = this;
  this.type = 'Root'; // options

  this.jsx = options.jsx || 'React.createElement';
  this.options = options;
  this.source = source;
  this.magicString = new MagicString(source);
  this.ast = ast;
  this.depth = 0;
  wrap(this.body = ast, this);
  this.body.__proto__ = BlockStatement.prototype;
  this.templateLiteralQuasis = Object.create(null);

  for (var i = 0; i < this.body.body.length; ++i) {
    if (!this$1.body.body[i].directive) {
      this$1.prependAt = this$1.body.body[i].start;
      break;
    }
  }

  this.objectWithoutPropertiesHelper = null;
  this.indentExclusionElements = [];
  this.body.initialise(transforms);
  this.indentExclusions = Object.create(null);

  for (var i$2 = 0, list = this$1.indentExclusionElements; i$2 < list.length; i$2 += 1) {
    var node = list[i$2];

    for (var i$1 = node.start; i$1 < node.end; i$1 += 1) {
      this$1.indentExclusions[i$1] = true;
    }
  }

  this.body.transpile(this.magicString, transforms);
}

Program.prototype = {
  "export": function export$1(options) {
    if (options === void 0) options = {};
    return {
      code: this.magicString.toString(),
      map: this.magicString.generateMap({
        file: options.file,
        source: options.source,
        includeContent: options.includeContent !== false
      })
    };
  },
  findNearest: function findNearest() {
    return null;
  },
  findScope: function findScope() {
    return null;
  },
  getObjectWithoutPropertiesHelper: function getObjectWithoutPropertiesHelper(code) {
    if (!this.objectWithoutPropertiesHelper) {
      this.objectWithoutPropertiesHelper = this.body.scope.createIdentifier('objectWithoutProperties');
      code.prependLeft(this.prependAt, "function " + this.objectWithoutPropertiesHelper + " (obj, exclude) { " + "var target = {}; for (var k in obj) " + "if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) " + "target[k] = obj[k]; return target; }\n");
    }

    return this.objectWithoutPropertiesHelper;
  }
};
var matrix = {
  chrome: {
    48: 610719,
    49: 652287,
    50: 783359,
    51: 783359,
    52: 1045503,
    53: 1045503,
    54: 1045503,
    55: 3142655,
    56: 3142655,
    57: 3142655,
    58: 4191231,
    59: 4191231,
    60: 8385535,
    61: 8385535,
    62: 8385535,
    63: 8385535,
    64: 8385535,
    65: 8385535,
    66: 8385535,
    67: 8385535,
    68: 8385535,
    69: 8385535,
    70: 8385535,
    71: 8385535
  },
  firefox: {
    43: 643515,
    44: 643515,
    45: 643519,
    46: 774591,
    47: 774655,
    48: 774655,
    49: 774655,
    50: 774655,
    51: 775167,
    52: 4191231,
    53: 4191231,
    54: 4191231,
    55: 8385535,
    56: 8385535,
    57: 8385535,
    58: 8385535,
    59: 8385535,
    60: 8385535,
    61: 8385535,
    62: 8385535,
    63: 8385535,
    64: 8385535
  },
  safari: {
    8: 524297,
    9: 594141,
    10: 1831935,
    '10.1': 4191231,
    11: 4191231,
    '11.1': 8385535,
    12: 8385535
  },
  ie: {
    8: 0,
    9: 524289,
    10: 524289,
    11: 524289 // no let/const in for loops

  },
  edge: {
    12: 610459,
    13: 774559,
    14: 2085887,
    15: 4183039,
    16: 4183039,
    17: 4183039,
    18: 4183039,
    19: 4183039
  },
  node: {
    '0.10': 524289,
    '0.12': 524417,
    4: 594335,
    5: 594335,
    6: 783359,
    8: 4191231,
    '8.3': 8385535,
    '8.7': 8385535,
    '8.10': 8385535
  }
};
var features = ['getterSetter', 'arrow', 'classes', 'computedProperty', 'conciseMethodProperty', 'defaultParameter', 'destructuring', 'forOf', 'generator', 'letConst', 'moduleExport', 'moduleImport', 'numericLiteral', 'parameterDestructuring', 'spreadRest', 'stickyRegExp', 'templateString', 'unicodeRegExp', // ES2016
'exponentiation', // additional transforms, not from
// https://featuretests.io
'reservedProperties', 'trailingFunctionCommas', 'asyncAwait', 'objectRestSpread'];
var version$1 = "0.19.6";
var parser = Parser.extend(acornDynamicImport, acornJsx());
var dangerousTransforms = ['dangerousTaggedTemplateString', 'dangerousForOf'];

function target(target) {
  var targets = Object.keys(target);
  var bitmask = targets.length ? 8388607 : 524289;
  Object.keys(target).forEach(function (environment) {
    var versions = matrix[environment];

    if (!versions) {
      throw new Error("Unknown environment '" + environment + "'. Please raise an issue at https://github.com/Rich-Harris/buble/issues");
    }

    var targetVersion = target[environment];

    if (!(targetVersion in versions)) {
      throw new Error("Support data exists for the following versions of " + environment + ": " + Object.keys(versions).join(', ') + ". Please raise an issue at https://github.com/Rich-Harris/buble/issues");
    }

    var support = versions[targetVersion];
    bitmask &= support;
  });
  var transforms = Object.create(null);
  features.forEach(function (name, i) {
    transforms[name] = !(bitmask & 1 << i);
  });
  dangerousTransforms.forEach(function (name) {
    transforms[name] = false;
  });
  return transforms;
}

function transform(source, options) {
  if (options === void 0) options = {};
  var ast;
  var jsx = null;

  try {
    ast = parser.parse(source, {
      ecmaVersion: 10,
      preserveParens: true,
      sourceType: 'module',
      allowReturnOutsideFunction: true,
      onComment: function onComment(block, text) {
        if (!jsx) {
          var match = /@jsx\s+([^\s]+)/.exec(text);

          if (match) {
            jsx = match[1];
          }
        }
      }
    });
    options.jsx = jsx || options.jsx;
  } catch (err) {
    err.snippet = getSnippet(source, err.loc);

    err.toString = function () {
      return err.name + ": " + err.message + "\n" + err.snippet;
    };

    throw err;
  }

  var transforms = target(options.target || {});
  Object.keys(options.transforms || {}).forEach(function (name) {
    if (name === 'modules') {
      if (!('moduleImport' in options.transforms)) {
        transforms.moduleImport = options.transforms.modules;
      }

      if (!('moduleExport' in options.transforms)) {
        transforms.moduleExport = options.transforms.modules;
      }

      return;
    }

    if (!(name in transforms)) {
      throw new Error("Unknown transform '" + name + "'");
    }

    transforms[name] = options.transforms[name];
  });

  if (options.objectAssign === true) {
    options.objectAssign = 'Object.assign';
  }

  return new Program(source, ast, transforms, options)["export"](options);
}

export { target, transform, version$1 as VERSION };